(function () {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4c53"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4c53"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cnCS2", function(module, exports) {

module.exports = (parcelRequire("4WKyX"))($parcel$resolve("clwvD")).then(()=>parcelRequire('S0nQY'));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1c132cac09cd18d9$var$cachedPreloads;
        case 'prefetch':
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $6697e6e436eb0e32$exports = {};
$parcel$extendImportMap({
    "clwvD": "tinymce.min.63fbecd4.js"
});

class $8f658dda969a7982$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.listeners = [];
    }
    connectedCallback() {}
    /**
     * If the custom element is getting removed of the dom, all listeners
     * are getting removed of the element.
     */ disconnectedCallback() {
        this.listeners.forEach((item)=>{
            item.element.removeEventListener(item.event, item.action);
        });
    }
    /**
     * Here you can push a listener object directly to the listener array
     *
     * @param {Listener} {}
     */ pushListener({ event: event, element: element, action: action }) {
        const existing = this.listeners.find((listener)=>listener.element === element && listener.event === event);
        if (existing) {
            existing.element.removeEventListener(existing.event, existing.action);
            this.listeners = this.listeners.filter((listener)=>!(listener.element === element && listener.event === event));
        }
        this.listeners.push({
            event: event,
            element: element,
            action: action
        });
        element.addEventListener(event, action);
    }
    /**
     * Removes the given element from the listener array and removes the
     * EventListener from the element and returns the listener object.
     * If the element was not found, undefined is returned.
     *
     * @param {Element} element
     * @returns {Listener | undefined}
     */ removeListener(element) {
        const foundElement = this.listeners.find((item)=>item.element === element);
        if (!foundElement) return;
        foundElement?.element.removeEventListener(foundElement.event, foundElement.action);
        const newList = this.listeners.filter((item)=>item.element !== element);
        this.listeners = newList;
        return foundElement;
    }
    /**
     * Removes all registered event listeners that were previously added
     * using the `pushListener()` method. This ensures that no dangling
     * or duplicate event handlers remain active on DOM elements.
     *
     * This method should be called before re-rendering or updating the DOM
     * to avoid memory leaks and unintended behavior caused by multiple bindings.
     *
     * @example
     * this.clearListeners();
     * this.render(); // safe to re-bind new listeners after rendering
     */ clearListeners() {
        this.listeners.forEach(({ element: element, event: event, action: action })=>{
            element.removeEventListener(event, action);
        });
        this.listeners = [];
    }
    /**
     * Retrieves a data attribute from the element with the specified name.
     * If the attribute is not present, the provided default value is returned.
     *
     * @protected
     * @param {string} name - The name of the data attribute (without the `data-tk-` prefix).
     * @param {string} defaultValue - The default value to return if the attribute is not found.
     * @returns {string} - The value of the data attribute or the default value.
     */ getDataAttribute(name, defaultValue) {
        return this.getAttribute(`data-tk-${name}`) || defaultValue;
    }
}


var $588d148f2c9ac202$export$4120f82005ec4b2d = /*#__PURE__*/ function(TrackerPushTypes) {
    TrackerPushTypes["BASKET_UPDATE"] = "basket-update";
    TrackerPushTypes["FAVORITE_UPDATE"] = "favorite-update";
    return TrackerPushTypes;
}({});
class $588d148f2c9ac202$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.registry = {};
    }
    constructor(){
        super(), this.trackers = [];
        this.ready = new CustomEvent('tk-tracker-ready');
    }
    static registerTracker(name, factory) {
        this.registry[name] = factory;
    }
    async connectedCallback() {
        this.getTrackingIds();
        if (!this.trackerIds || this.trackerIds.length === 0) throw new Error('Trackier is not defined');
        await this.initTrackers();
        this.registerTrackingListener();
        this.dispatchEvent(this.ready);
    }
    registerTrackingListener() {
        const onTracking = this.handleTracking.bind(this);
        this.pushListener({
            event: 'tk-tracking-push',
            element: this,
            action: onTracking
        });
    }
    getTrackingIds() {
        try {
            this.trackerIds = JSON.parse(this.getAttribute('data-tk-trackers') || '[]');
        } catch (error) {
            console.error('Error parsing json', error);
        }
    }
    async initTrackers() {
        if (!this.trackerIds) return;
        for (const item of this.trackerIds)try {
            const createTracker = $588d148f2c9ac202$export$2e2bcd8739ae039.registry[item.name];
            if (createTracker) {
                const instance = await createTracker(item.key, {
                    endpoint: item.endpoint
                });
                await instance.init();
                this.trackers.push({
                    name: item.name,
                    instance: instance
                });
            } else console.warn(`Tracker "${item.name}" nicht gefunden.`);
        } catch (error) {
            console.error(`This tracker ${item.name} could not be initialized:` + error);
        }
    }
    handleTracking(event) {
        const { trackerType: trackerType, type: type, item: item } = event.detail;
        this.trackers.filter((trackerItem)=>!trackerType || trackerItem.name.toLowerCase() === trackerType.toLowerCase()).forEach((trackerItem)=>{
            if (type === "basket-update") trackerItem.instance.pushBasket(item);
            else if (type === "favorite-update") trackerItem.instance.pushFavorite(item);
            else trackerItem.instance.push(item);
        });
    }
}


class $26efcff9bda53fd7$export$2e2bcd8739ae039 {
    constructor(trackingId, tracker, defaultEndpoint, options){
        this.trackingId = trackingId;
        this.tracker = tracker;
        this.endpoint = options?.endpoint || defaultEndpoint;
        this.url = this.endpoint.replace(/%KEY/g, trackingId);
        this.basketEventMap = options?.basketEventMap || {
            added: 'add_to_cart',
            deleted: 'remove_from_cart',
            changed: 'update_cart'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'add_from_wishlist',
            deleted: 'remove_from_wishlist'
        };
        this.favoriteActionMap = options?.favoriteActionMap || {
            added: 'add',
            deleted: 'delete'
        };
    }
    loadScript() {
        return new Promise((resolve, reject)=>{
            const script = document.createElement('script');
            script.async = true;
            script.src = this.url;
            script.onload = ()=>resolve(script);
            script.onerror = ()=>reject(new Error(`Failed to load script: ${this.url}`));
            document.head.appendChild(script);
        });
    }
}


class $4fa2285174eed561$export$2e2bcd8739ae039 extends (0, $26efcff9bda53fd7$export$2e2bcd8739ae039) {
    constructor(trackingId, options){
        super(trackingId, window.dataLayer || [], `https://www.googletagmanager.com/gtm.js?id=%KEY`, options);
        this.basketEventMap = options?.basketEventMap || {
            added: 'add_to_cart',
            deleted: 'remove_from_cart',
            changed: 'update_cart'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'add_from_wishlist',
            deleted: 'remove_from_wishlist'
        };
    }
    init() {
        return new Promise((resolve, reject)=>{
            try {
                this.initGTM();
                this.loadScript().then(()=>{
                    console.log('Google Tag Manager successfully loaded');
                    resolve();
                }).catch((error)=>{
                    console.error('Error loading Google Tag Manager', error);
                    reject(error);
                });
            } catch (error) {
                console.error('Google Tag Manager initialization failed', error);
                reject(error);
            }
        });
    }
    initGTM() {
        this.tracker.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
    }
    push(item) {
        const { event: event, ...rest } = item;
        this.tracker.push({
            event: event,
            ecommerce: {
                ...rest
            }
        });
    }
    pushBasket(item) {
        this.tracker.push({
            event: this.basketEventMap[item.event],
            ecommerce: {
                currencyCode: item.currency,
                value: item.value,
                items: item.items.map((item)=>({
                        item_id: item.sku,
                        item_name: item.name,
                        price: item.price,
                        quantity: item.quantity
                    }))
            }
        });
    }
    pushFavorite(item) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action],
            ecommerce: {
                category: item.category,
                action: this.favoriteActionMap[item.action],
                name: item.name,
                value: item.value
            }
        });
    }
}



class $30ee64c4b301d5a8$export$2e2bcd8739ae039 extends (0, $26efcff9bda53fd7$export$2e2bcd8739ae039) {
    constructor(trackingId, options){
        super(trackingId, window._mtm || [], `https://matomo01.opacc.net/js/container_%KEY.js`, options);
        this.basketEventMap = options?.basketEventMap || {
            added: 'opc_cart_add',
            deleted: 'opc_cart_remove',
            changed: 'opc_cart_update'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'opc_wishlist_add',
            deleted: 'opc_wishlist_remove'
        };
    }
    async init() {
        await this.loadScript();
        this.initMatomo();
        console.log('Matomo Tag Manager successfully loaded');
    }
    initMatomo() {
        this.tracker.push({
            'mtm.startTime': new Date().getTime(),
            event: 'mtm.Start'
        });
    }
    push(item) {
        this.tracker.push(item);
    }
    pushBasket(item) {
        this.tracker.push({
            event: this.basketEventMap[item.event],
            location: item.location,
            currency: item.currency,
            value: item.value,
            items: item.items
        });
    }
    pushFavorite(item) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action],
            location: window.location.href,
            category: item.category,
            action: this.favoriteActionMap[item.action],
            name: item.name,
            value: item.value
        });
    }
}


// Registry of tracker
(0, $588d148f2c9ac202$export$2e2bcd8739ae039).registerTracker('google', async (trackingId, options)=>new (0, $4fa2285174eed561$export$2e2bcd8739ae039)(trackingId, options));
(0, $588d148f2c9ac202$export$2e2bcd8739ae039).registerTracker('matomo', async (trackingId, options)=>new (0, $30ee64c4b301d5a8$export$2e2bcd8739ae039)(trackingId, options));


class $e31d2de11bbf216d$export$2e2bcd8739ae039 {
    constructor(list){
        this.customElementList = list;
        this.init();
    }
    init() {
        this.customElementList.forEach((item)=>{
            !customElements.get(item.name) && customElements.define(item.name, item.constructor);
        });
    }
}



const $86b3c5b6d66bd808$var$globalFormErrorMessages = {
    badInput: 'Please enter a number.',
    patternMismatch: 'Please match the requested format.',
    rangeOverflow: 'Please select a value that is no more than {max}.',
    rangeUnderflow: 'Please select a value that is no less than {min}.',
    stepMismatch: 'Please select a value that is a multiple from {step}.',
    tooLong: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
    tooShort: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.',
    typeMismatch: 'The value you have entered for this field is invalid.',
    valueMissing: 'Please fill out this field.',
    // These properties must be empty.
    valid: '',
    customError: ''
};
const $86b3c5b6d66bd808$var$globalFormPasswordValidityMessages = {
    passwordNotMatching: 'The password does not match the one above.'
};
const $86b3c5b6d66bd808$var$globalFormExpandErrorMessages = {
    stepAdjust: 'The value you entered for this field is invalid. The value has been changed from {currentValue} to {newValue}',
    existigName: 'This name {currentValue} already exists.'
};
const $86b3c5b6d66bd808$var$globalBasketMessages = {
    messageEmptyBasket: {
        code: '1-6-6220',
        text: 'Shopping cart is empty'
    },
    messageAddedToBasket: {
        code: '1-6-6221',
        text: 'added to the shopping cart'
    },
    quickOrderMessageTooShort: {
        code: '1-6-6222',
        text: 'At least %1 characters are required for a search.'
    }
};
const $86b3c5b6d66bd808$var$globalDeliveryMessages = {
    messageDeliveryTypeGeneral: {
        code: '1-6-6226',
        text: 'Delivery method changed'
    }
};
const $86b3c5b6d66bd808$var$globalPaymentMessages = {
    messagePaymentTypeCreditCard: {
        code: '1-6-6227',
        text: 'Payment type credit card'
    },
    messagePaymentTypeInvoice: {
        code: '1-6-6227',
        text: 'Payment type invoice'
    },
    messagePaymentTypeInAdvance: {
        code: '1-6-6227',
        text: 'Payment type advance payment'
    },
    messagePaymentTypeOnDelivery: {
        code: '1-6-6227',
        text: 'Payment type cash on delivery'
    },
    messagePaymentTypeGeneral: {
        code: '1-6-6227',
        text: 'Payment type changed'
    }
};
const $86b3c5b6d66bd808$var$globalCompareMessages = {
    messageHint: {
        code: '1-6-6240',
        text: ''
    },
    allRemoved: {
        code: '1-6-6240',
        text: 'All items removed'
    },
    empty: {
        code: '1-6-6240',
        text: 'Your article comparison is empty.'
    },
    importantTitle: {
        code: '1-6-6240',
        text: 'The most important information'
    },
    removed: {
        code: '1-6-6240',
        text: 'The article was successfully removed.'
    },
    added: {
        code: '1-6-6240',
        text: 'The article was successfully added.'
    },
    noAttributesFound: {
        code: '1-6-6240',
        text: 'No comparison attributes were found.'
    }
};
const $86b3c5b6d66bd808$var$globalFavoriteMessages = {
    messageInvalidName: {
        code: '2-6-6270',
        text: 'Unable to create the wish list; the name is invalid.'
    },
    messageMaxLists: {
        code: '2-6-6277',
        text: 'Max. number of wish lists reached!'
    },
    messageMaxPositions: {
        code: '2-6-6278',
        text: 'Max. number of positions reached!'
    },
    messageDeleteConfirmation: {
        code: '2-6-6273',
        text: 'Do you really want to delete the wish list?'
    }
};
const $86b3c5b6d66bd808$var$globalAutocompleteMessages = {
    messageNoValueFound: {
        code: '1-6-6290',
        text: 'No match found!'
    }
};
const $86b3c5b6d66bd808$var$globalAccountMessages = {
    messageDelete: {
        code: '1-6-6200',
        text: 'Do you really want to delete this address?'
    },
    messageChangeSuccess: {
        code: '1-6-6200',
        text: 'Address successfully modified.'
    }
};
const $86b3c5b6d66bd808$var$globalGeneralMessages = {
    messageEmptyText: {
        code: '1-6-6290',
        text: 'The output was suppressed due to an empty text.'
    },
    messageOk: {
        code: '1-6-6290',
        text: 'Yes'
    },
    messageCancel: {
        code: '1-6-6290',
        text: 'No'
    },
    messageChange: {
        code: '1-6-6290',
        text: 'The selection was changed'
    },
    messageDefault: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultInfo: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultWarning: {
        code: '2-6-0000',
        text: ''
    },
    messageDefaultError: {
        code: '3-6-0000',
        text: ''
    },
    messageDefaultDebug: {
        code: '4-6-0000',
        text: ''
    },
    messageClipboard: {
        code: '1-6-6290',
        text: 'The text has been successfully saved to the clipboard.'
    }
};
const $86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages = {
    messageTooShort: {
        code: '1-6-6260',
        text: 'At least 3 characters!'
    },
    messageResultEmpty: {
        code: '1-6-6260',
        text: 'No items found!'
    },
    messageDangerousString: {
        code: '1-6-6260',
        text: 'invalid character <.'
    },
    messageDisallowedCharacter: {
        code: '1-6-6260',
        text: 'Invalid character: %1'
    }
};
const $86b3c5b6d66bd808$var$globalFileuploadAreaMessages = {
    defaultMessage: {
        code: '1-6-2002',
        text: 'Store the files here to upload them'
    },
    fallbackMessage: {
        code: '2-6-2002',
        text: 'Your browser does not support drag&drop file uploads'
    },
    fallbackText: {
        code: '2-6-2002',
        text: 'Use the form to upload your files'
    },
    fileTooBig: {
        code: '2-6-2002',
        text: 'The file is too large. The maximum file size is {{maxFileSize}} MB'
    },
    invalidFileType: {
        code: '2-6-2002',
        text: 'Unable to upload files of this type'
    },
    responseError: {
        code: '3-6-2002',
        text: 'The server rejected your request with status {{statusCode}}'
    },
    cancelUpload: {
        code: '1-6-2002',
        text: 'Cancel upload'
    },
    cancelUploadConfirmation: {
        code: '1-6-2002',
        text: 'Cancel upload?'
    },
    removeFile: {
        code: '1-6-2002',
        text: 'Remove file'
    },
    maxFilesExceeded: {
        code: '2-6-2002',
        text: 'You are not allowed to upload any more files'
    },
    buttonBrowse: {
        code: '1-6-2002',
        text: 'Select files to upload'
    },
    uploadHint: {
        code: '1-6-2002',
        text: 'Drag files and folders here'
    }
};
const $86b3c5b6d66bd808$var$globalFilterMessages = {
    emptyResult: {
        code: '1-1-6280',
        text: 'Keine Ergebnisse gefunden.'
    }
};
const $86b3c5b6d66bd808$var$globalCheckoutMessages = {
    missingTerms: {
        code: '3-6-6230',
        text: 'Please accept the General terms and conditions.'
    },
    loadingCheckoutTitle: {
        code: '1-6-6260',
        text: 'Almost done!'
    },
    loadingCheckoutText: {
        code: '1-6-6261',
        text: 'The order is carried out. This can take a moment!'
    }
};
const $86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages = {
    htmlErrorGeneral: {
        code: '3-6-6000',
        text: 'Something has gone wrong!'
    },
    htmlError401: {
        code: '3-6-6000',
        text: 'A valid authentication is required to process the request.'
    },
    htmlError403: {
        code: '3-6-6000',
        text: 'The request could not be processed due to missing authorization of the client.'
    },
    htmlError404: {
        code: '3-6-6000',
        text: 'The requested site does not exist.'
    },
    htmlError413: {
        code: '3-6-6000',
        text: 'The file is too large.'
    },
    htmlError415: {
        code: '3-6-6000',
        text: 'This media type is not supported.'
    },
    htmlError422: {
        code: '3-6-6000',
        text: 'Unable to display the requested site correctly.'
    },
    htmlError500: {
        code: '3-6-6000',
        text: 'Internal server error'
    },
    htmlError503: {
        code: '3-6-6000',
        text: 'The server is temporarily unavailable.'
    }
};
if (!window.opacc) window.opacc = {};
const $86b3c5b6d66bd808$export$7ea287b8bcd34b91 = {
    ...$86b3c5b6d66bd808$var$globalFormErrorMessages,
    ...$86b3c5b6d66bd808$var$globalFormPasswordValidityMessages,
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormValidityMessages,
    ...window.opacc.tkFormPasswordValidityMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormValidityMessages,
    ...window.opacc.projectFormPasswordValidityMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$35e6ad2b040b8403 = {
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$287bafa924522a4d = {
    ...$86b3c5b6d66bd808$var$globalBasketMessages,
    ...window.opacc.tkBasketMessages,
    ...window.opacc.projectBasketMessages
};
const $86b3c5b6d66bd808$export$ad480231e1cfb49 = {
    ...$86b3c5b6d66bd808$var$globalCompareMessages,
    ...window.opacc.tkCompareMessages,
    ...window.opacc.projectCompareMessages
};
const $86b3c5b6d66bd808$export$329e838a9ba51357 = {
    ...$86b3c5b6d66bd808$var$globalFavoriteMessages,
    ...window.opacc.tkFavoriteMessages,
    ...window.opacc.projectFavoriteMessages
};
const $86b3c5b6d66bd808$export$39227038979f1988 = {
    ...$86b3c5b6d66bd808$var$globalGeneralMessages,
    ...window.opacc.tkGeneralMessages,
    ...window.opacc.projectGeneralMessages
};
const $86b3c5b6d66bd808$export$f625b980042672da = {
    ...$86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages,
    ...window.opacc.tkDirectSearchSuggestMessages,
    ...window.opacc.projectDirectSearchSuggestMessages
};
const $86b3c5b6d66bd808$export$fe24ead06f0313ff = {
    ...$86b3c5b6d66bd808$var$globalFileuploadAreaMessages,
    ...window.opacc.tkFileUploadAreaMessages,
    ...window.opacc.projectFileUploadAreaMessages
};
const $86b3c5b6d66bd808$export$1c7f7f3bbe522ebc = {
    ...$86b3c5b6d66bd808$var$globalFilterMessages,
    ...window.opacc.tkFilterMessages,
    ...window.opacc.projectFilterMessages
};
const $86b3c5b6d66bd808$export$fbedd73e1269236f = {
    ...$86b3c5b6d66bd808$var$globalAutocompleteMessages,
    ...window.opacc.tkAutocompleteMessages,
    ...window.opacc.projectAutocompleteMessages
};
const $86b3c5b6d66bd808$export$389a1ce21906c656 = {
    ...$86b3c5b6d66bd808$var$globalPaymentMessages,
    ...window.opacc.tkPaymentMessages,
    ...window.opacc.projectPaymentMessages
};
const $86b3c5b6d66bd808$export$36d5448025feaaa9 = {
    ...$86b3c5b6d66bd808$var$globalDeliveryMessages,
    ...window.opacc.tkDeliveryMessages,
    ...window.opacc.projectDeliveryMessages
};
const $86b3c5b6d66bd808$export$efd88ea7bc399322 = {
    ...$86b3c5b6d66bd808$var$globalAccountMessages,
    ...window.opacc.tkAccountMessages,
    ...window.opacc.projectAccountMessages
};
const $86b3c5b6d66bd808$export$4705307fe5270e12 = {
    ...$86b3c5b6d66bd808$var$globalCheckoutMessages,
    ...window.opacc.tkCheckoutMessages,
    ...window.opacc.projectCheckoutMessages
};
const $86b3c5b6d66bd808$export$6e7e78d2cde281b0 = {
    ...$86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages,
    ...window.opacc.tkHtmlErrorCodeMessages,
    ...window.opacc.projectHtmlErrorCodeMessages
};
const $86b3c5b6d66bd808$export$97a703132b664051 = {
    ...window.opacc.tkZipCityMessages
};


/**
 * @param {string} html representing any number of sibling elements
 * @return {NodeListOf<ChildNode>}
 */ const $2d540709c75492d4$var$render = (html, isBody = false, shouldDecode = false)=>{
    if (!html) $2d540709c75492d4$var$render('<div></div>');
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    if (shouldDecode) return $2d540709c75492d4$var$render(doc.documentElement.textContent || '');
    return isBody ? doc.body : doc.body.children.item(0);
};
var $2d540709c75492d4$export$2e2bcd8739ae039 = $2d540709c75492d4$var$render;


var $1221feb2184dfefe$export$9130146a86a85749 = /*#__PURE__*/ function(NotificationType) {
    NotificationType["SUCCESS"] = "Success";
    NotificationType["WARNING"] = "Warning";
    NotificationType["ERROR"] = "Error";
    NotificationType["INFO"] = "Info";
    return NotificationType;
}({});
const $1221feb2184dfefe$var$mapMessageCodeToText = (response, messages)=>{
    let textMessage;
    if (!response.pluginId) return '';
    if (response.pluginId === 'paymentType') {
        const paymentMessages = {
            0: messages.messagePaymentTypeGeneral.text,
            1: messages.messagePaymentTypeCreditCard.text,
            2: messages.messagePaymentTypeInvoice.text,
            5: messages.messagePaymentTypeInAdvance.text,
            6: messages.messagePaymentTypeOnDelivery.text
        };
        textMessage = paymentMessages[Number(response.paymentType) || 0];
    } else if (response.pluginId === 'deliveryType') textMessage = messages.messageDeliveryTypeGeneral.text;
    else if (response.pluginId === 'checkoutAdressChange') textMessage = messages.messageChangeSuccess.text;
    return textMessage;
};
const $1221feb2184dfefe$var$getConsoleStyle = (backgroundColor, textColor = 'white')=>[
        `background: ${backgroundColor}`,
        `color: ${textColor}`,
        'display: block'
    ].join(';');
const $1221feb2184dfefe$var$logToConsole = (message, type)=>{
    const consoleHandler = {
        ["Success"] () {
            console.info(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('green'));
        },
        ["Warning"] () {
            console.warn(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('yellow', 'black'));
        },
        ["Error"] () {
            console.log(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('red'));
        },
        ["Info"] () {
            console.debug(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('blue'));
        }
    };
    consoleHandler[type]();
};
const $1221feb2184dfefe$var$renderMessageContainer = (parentElement)=>{
    let messageContainer = parentElement.querySelector('[data-tk-message-container]');
    if (!messageContainer) {
        messageContainer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-message__container" data-tk-message-container></div>');
        parentElement.insertAdjacentElement('beforeend', messageContainer);
    }
    return messageContainer;
};
const $1221feb2184dfefe$export$3a57e165650c636f = (type, message, wait = 2.5, options = {})=>{
    if (!message) return;
    const dialogs = document.querySelectorAll('dialog[open]');
    let messageContainer;
    if (dialogs.length === 0) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
    else {
        const lastDialog = Array.from(dialogs).at(-1);
        if (!lastDialog) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
        else messageContainer = $1221feb2184dfefe$var$renderMessageContainer(lastDialog);
    }
    const toast = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
        <div class="tk-message tk-message--toast tk-message--${type.toLowerCase()}">
            <span class="tk-message__icon"><i class="tk-icon-${type.toLowerCase()}"></i></span>
            <span class="tk-message__label">${message}</span>
        </div>
    `);
    toast.style.animation = `fadein .5s, fadeout .5s ${wait}s`;
    toast.classList.add('tk-message--show');
    messageContainer.appendChild(toast);
    toast.addEventListener('animationend', (event)=>{
        if (event.animationName !== 'fadeout') return;
        messageContainer.removeChild(toast);
    });
    options.consoleMessage ? $1221feb2184dfefe$var$logToConsole(options.consoleMessage, type) : $1221feb2184dfefe$var$logToConsole(message, type);
};
const $1221feb2184dfefe$export$146c7c7e50ed1bd2 = (item, messageOverride)=>{
    const type = item.code.substring(0, 1);
    const message = messageOverride || item.text;
    const typeHandler = {
        1: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Success", message, item.wait),
        2: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Warning", message, item.wait),
        3: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Error", message, item.wait),
        4: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Info", message, item.wait)
    };
    typeHandler[type]();
};
const $1221feb2184dfefe$export$5b256beea4c7e9b5 = (items, response)=>{
    const messages = {
        ...(0, $86b3c5b6d66bd808$export$39227038979f1988),
        ...(0, $86b3c5b6d66bd808$export$efd88ea7bc399322),
        ...(0, $86b3c5b6d66bd808$export$389a1ce21906c656),
        ...(0, $86b3c5b6d66bd808$export$36d5448025feaaa9)
    };
    items.forEach((item)=>{
        $1221feb2184dfefe$export$146c7c7e50ed1bd2(item, $1221feb2184dfefe$var$mapMessageCodeToText(response, messages));
    });
};


class $aa35ef9547ba682e$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.eventName = this.getAttribute('data-tk-event-name') || 'event-purchase';
        this.basketId = this.querySelector('[data-tk-otm-basket-id]') || undefined;
        this.messageContainerSelector = this.getAttribute('data-tk-message-container-selector') || '[id^="wp_messages_container_"]';
        this.sessionTimeoutWrapper = this.querySelector('[data-tk-session-timeout-wrapper]') || undefined;
        this.sessionTime = Number(this.sessionTimeoutWrapper?.getAttribute('data-tk-session-time') || 0);
        this.firstItemToScrollInto = this.querySelector('[data-tk-scroll-into]') || undefined;
    }
    connectedCallback() {
        this.processNotification();
        this.sessionTimeoutWrapper && this.showSessionTimeout();
        this.firstItemToScrollInto && this.scrollToElement();
        if (!this.basketId || !window.dataLayer) return;
        const data = this.getPurchaseData();
        data && window.dataLayer.push(data);
    }
    processNotification() {
        const messageContainer = document.querySelector(this.messageContainerSelector);
        if (!messageContainer || !messageContainer.hasChildNodes()) return;
        const infoMessage = messageContainer.querySelectorAll('.Info');
        const errorMessage = messageContainer.querySelectorAll('.Error');
        const warningMessage = messageContainer.querySelectorAll('.Warning');
        const debugMessage = messageContainer.querySelectorAll('.Debug');
        const messageList = Array.from([
            ...infoMessage,
            ...errorMessage,
            ...warningMessage,
            ...debugMessage
        ]);
        const types = {
            Info: (0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS,
            Error: (0, $1221feb2184dfefe$export$9130146a86a85749).ERROR,
            Warning: (0, $1221feb2184dfefe$export$9130146a86a85749).WARNING,
            Debug: (0, $1221feb2184dfefe$export$9130146a86a85749).INFO
        };
        messageList.forEach((item)=>{
            const type = types[item.className];
            const childList = Array.from(item.firstChild?.childNodes || []);
            const message = childList.find((item)=>item instanceof Text)?.textContent || '';
            const code = item.querySelector('.was-message-code')?.textContent || '';
            const addition = item.querySelector('.was-message-addition')?.textContent || '';
            const wait = Number(item.querySelector('.was-message-wait')?.textContent) || undefined;
            const consoleMessage = `${code}: ${message}} (wait: ${wait} sec.${addition})`;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)(type, message, wait, {
                consoleMessage: consoleMessage
            });
        });
        messageContainer.remove();
    }
    showSessionTimeout() {
        setTimeout(()=>{
            this.sessionTimeoutWrapper.hidden = false;
        }, this.sessionTime);
    }
    getPurchaseData() {
        return {
            event: 'event-purchase',
            ecommerce: {
                purchase: {
                    actionField: this.getActionData(),
                    products: this.getProductData()
                }
            }
        };
    }
    getActionData() {
        const affiliation = this.querySelector('[data-tk-otm-affiliation]');
        const revenue = this.querySelector('[data-tk-otm-revenue]');
        const tax = this.querySelector('[data-tk-otm-tax]');
        const shipping = this.querySelector('[data-tk-otm-shipping]');
        return {
            id: this.basketId.innerText,
            affiliation: affiliation ? affiliation.innerText : '',
            revenue: revenue ? revenue.innerText : '',
            tax: tax ? tax.innerText : '',
            shipping: shipping ? shipping.innerText : ''
        };
    }
    getProductData() {
        const data = [];
        const items = this.querySelectorAll('[data-tk-otm-item]');
        Array.from(items).forEach((item)=>{
            const id = item.querySelector('.otm-id');
            const name = item.querySelector('.otm-name');
            const brand = item.querySelector('.otm-brand');
            const category = item.querySelector('.otm-category');
            const price = item.querySelector('.otm-price');
            const quantity = item.querySelector('.otm-quantity');
            const position = item.querySelector('.otm-position');
            data.push({
                id: id ? id.innerText : '',
                name: name ? name.innerText : '',
                brand: brand ? brand.innerText : '',
                category: category ? category.innerText : '',
                price: price ? price.innerText : '',
                quantity: quantity ? quantity.innerText : '',
                position: position ? position.innerText : ''
            });
        });
        return data;
    }
    scrollToElement() {
        const { top: top } = this.firstItemToScrollInto.getBoundingClientRect();
        const offset = Number(this.firstItemToScrollInto?.getAttribute('data-tk-scroll-into-offset')) || 16;
        const mainContainer = this.querySelector('main');
        const mainRect = mainContainer?.getBoundingClientRect();
        const mainRectTop = mainRect?.top || 0;
        const scrollY = top - mainRectTop - offset;
        setTimeout(()=>{
            window.scrollTo({
                top: scrollY,
                behavior: 'smooth'
            });
        }, 0);
    }
}



class $49fab39bf1404505$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.resizeEventName = this.getAttribute('data-tk-resize-event-name') || 'tk-viewport-resize';
        this.resizeObserver = new ResizeObserver(this.checkSize.bind(this));
        // * These breakpoints must match the CSS breakpoints, otherwise conflicts may occur.
        this.breakpoints = new Map([
            [
                'xs',
                576
            ],
            [
                's',
                768
            ],
            [
                'm',
                992
            ],
            [
                'l',
                1200
            ],
            [
                'xl',
                1440
            ]
        ]);
        this.currentBreakpoint = this.getCurrentBreakpoint(this.clientWidth);
    }
    connectedCallback() {
        this.resizeObserver.observe(this);
        window.viewport = this;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
    }
    checkSize(entries) {
        entries.forEach(()=>{
            const currentWidth = window.innerWidth;
            const currentBreakpoint = this.getCurrentBreakpoint(currentWidth);
            if (this.currentBreakpoint !== currentBreakpoint) {
                const event = new CustomEvent(this.resizeEventName, {
                    bubbles: true,
                    detail: {
                        width: currentWidth,
                        breakpoint: currentBreakpoint
                    }
                });
                this.currentBreakpoint = currentBreakpoint;
                this.dispatchEvent(event);
            }
        });
    }
    getCurrentBreakpoint(width) {
        let currentBreakpoint = 'xs';
        this.breakpoints.forEach((value, key)=>{
            if (width >= value) currentBreakpoint = key;
        });
        return currentBreakpoint;
    }
}


class $9ada6dd3e169a5cf$export$2e2bcd8739ae039 extends (0, $49fab39bf1404505$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.breakpoints = new Map([
            [
                'xs',
                576
            ],
            [
                's',
                768
            ],
            [
                'm',
                992
            ],
            [
                'l',
                1200
            ],
            [
                'xl',
                1920
            ]
        ]);
    }
}


var $5e6391609e4b352e$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $5e6391609e4b352e$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $983d310815fae63e$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $983d310815fae63e$export$2e2bcd8739ae039 = $983d310815fae63e$export$33e6c23ebe2ee669;


var $1aad83eefaa11659$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $1aad83eefaa11659$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $1aad83eefaa11659$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $1aad83eefaa11659$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $8d7d2474ed9a5f7d$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $8d7d2474ed9a5f7d$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $8d7d2474ed9a5f7d$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $8d7d2474ed9a5f7d$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $8d7d2474ed9a5f7d$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $763bd4de3a8b9966$var$doNothing = function() {
    return undefined;
};
var $763bd4de3a8b9966$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $763bd4de3a8b9966$export$9490b78b888a863f = {
    D: $763bd4de3a8b9966$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $763bd4de3a8b9966$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $763bd4de3a8b9966$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $763bd4de3a8b9966$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $763bd4de3a8b9966$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$763bd4de3a8b9966$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $763bd4de3a8b9966$export$27a2dd9af757e89c($763bd4de3a8b9966$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)($763bd4de3a8b9966$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $763bd4de3a8b9966$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $d16da6e601d564a3$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $5e6391609e4b352e$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $983d310815fae63e$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $763bd4de3a8b9966$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $763bd4de3a8b9966$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $d16da6e601d564a3$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $5e6391609e4b352e$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $983d310815fae63e$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $5e6391609e4b352e$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $763bd4de3a8b9966$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $d16da6e601d564a3$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $d16da6e601d564a3$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $d16da6e601d564a3$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $d16da6e601d564a3$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $d16da6e601d564a3$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $d16da6e601d564a3$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $d16da6e601d564a3$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $9986d07d28cc86ca$var$__assign = undefined && undefined.__assign || function() {
    $9986d07d28cc86ca$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9986d07d28cc86ca$var$__assign.apply(this, arguments);
};
var $9986d07d28cc86ca$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $9986d07d28cc86ca$var$DEBOUNCED_CHANGE_MS = 300;
function $9986d07d28cc86ca$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, (0, $5e6391609e4b352e$export$ebe90cb607ad99e)), $9986d07d28cc86ca$var$flatpickr.defaultConfig),
        l10n: (0, $983d310815fae63e$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $d16da6e601d564a3$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $d16da6e601d564a3$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $d16da6e601d564a3$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $d16da6e601d564a3$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $d16da6e601d564a3$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $d16da6e601d564a3$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $d16da6e601d564a3$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $d16da6e601d564a3$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $d16da6e601d564a3$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $1aad83eefaa11659$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $1aad83eefaa11659$export$61fc7d43ac8f84b0)(triggerChange, $9986d07d28cc86ca$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $763bd4de3a8b9966$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $d16da6e601d564a3$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $9986d07d28cc86ca$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $9986d07d28cc86ca$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $d16da6e601d564a3$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $d16da6e601d564a3$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $d16da6e601d564a3$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $d16da6e601d564a3$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $d16da6e601d564a3$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $9986d07d28cc86ca$var$flatpickr.defaultConfig.dateFormat || (0, $5e6391609e4b352e$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $9986d07d28cc86ca$var$flatpickr.defaultConfig.altFormat || (0, $5e6391609e4b352e$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $5e6391609e4b352e$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $1aad83eefaa11659$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $5e6391609e4b352e$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $1aad83eefaa11659$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $9986d07d28cc86ca$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, $9986d07d28cc86ca$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $9986d07d28cc86ca$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $9986d07d28cc86ca$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $d16da6e601d564a3$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $d16da6e601d564a3$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $8d7d2474ed9a5f7d$export$25245567f53f158f)((0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $d16da6e601d564a3$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $5e6391609e4b352e$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $1aad83eefaa11659$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $d16da6e601d564a3$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $763bd4de3a8b9966$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(isHourElem) && (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $9986d07d28cc86ca$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $9986d07d28cc86ca$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $9986d07d28cc86ca$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $9986d07d28cc86ca$var$_flatpickr([
            this
        ], config);
    };
}
var $9986d07d28cc86ca$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $9986d07d28cc86ca$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $9986d07d28cc86ca$var$_flatpickr([
        selector
    ], config);
    else return $9986d07d28cc86ca$var$_flatpickr(selector, config);
};
$9986d07d28cc86ca$var$flatpickr.defaultConfig = {};
$9986d07d28cc86ca$var$flatpickr.l10ns = {
    en: $9986d07d28cc86ca$var$__assign({}, (0, $983d310815fae63e$export$2e2bcd8739ae039)),
    default: $9986d07d28cc86ca$var$__assign({}, (0, $983d310815fae63e$export$2e2bcd8739ae039))
};
$9986d07d28cc86ca$var$flatpickr.localize = function(l10n) {
    $9986d07d28cc86ca$var$flatpickr.l10ns.default = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, $9986d07d28cc86ca$var$flatpickr.l10ns.default), l10n);
};
$9986d07d28cc86ca$var$flatpickr.setDefaults = function(config) {
    $9986d07d28cc86ca$var$flatpickr.defaultConfig = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, $9986d07d28cc86ca$var$flatpickr.defaultConfig), config);
};
$9986d07d28cc86ca$var$flatpickr.parseDate = (0, $d16da6e601d564a3$export$cfa2ef2687faeda2)({});
$9986d07d28cc86ca$var$flatpickr.formatDate = (0, $d16da6e601d564a3$export$ff1a0b75284ac636)({});
$9986d07d28cc86ca$var$flatpickr.compareDates = (0, $d16da6e601d564a3$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $9986d07d28cc86ca$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $9986d07d28cc86ca$var$flatpickr;
var $9986d07d28cc86ca$export$2e2bcd8739ae039 = $9986d07d28cc86ca$var$flatpickr;





var $dad224760cee6051$exports = {};
(function(global, factory) {
    factory($dad224760cee6051$exports);
})($dad224760cee6051$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var German = {
        weekdays: {
            shorthand: [
                "So",
                "Mo",
                "Di",
                "Mi",
                "Do",
                "Fr",
                "Sa"
            ],
            longhand: [
                "Sonntag",
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag"
            ]
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "M\xe4r",
                "Apr",
                "Mai",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dez"
            ],
            longhand: [
                "Januar",
                "Februar",
                "M\xe4rz",
                "April",
                "Mai",
                "Juni",
                "Juli",
                "August",
                "September",
                "Oktober",
                "November",
                "Dezember"
            ]
        },
        firstDayOfWeek: 1,
        weekAbbreviation: "KW",
        rangeSeparator: " bis ",
        scrollTitle: "Zum \xc4ndern scrollen",
        toggleTitle: "Zum Umschalten klicken",
        time_24hr: true
    };
    fp.l10ns.de = German;
    var de = fp.l10ns;
    exports1.German = German;
    exports1.default = de;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $34ba2808af177678$exports = {};
(function(global, factory) {
    factory($34ba2808af177678$exports);
})($34ba2808af177678$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var French = {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: [
                "dim",
                "lun",
                "mar",
                "mer",
                "jeu",
                "ven",
                "sam"
            ],
            longhand: [
                "dimanche",
                "lundi",
                "mardi",
                "mercredi",
                "jeudi",
                "vendredi",
                "samedi"
            ]
        },
        months: {
            shorthand: [
                "janv",
                "f\xe9vr",
                "mars",
                "avr",
                "mai",
                "juin",
                "juil",
                "ao\xfbt",
                "sept",
                "oct",
                "nov",
                "d\xe9c"
            ],
            longhand: [
                "janvier",
                "f\xe9vrier",
                "mars",
                "avril",
                "mai",
                "juin",
                "juillet",
                "ao\xfbt",
                "septembre",
                "octobre",
                "novembre",
                "d\xe9cembre"
            ]
        },
        ordinal: function(nth) {
            if (nth > 1) return "";
            return "er";
        },
        rangeSeparator: " au ",
        weekAbbreviation: "Sem",
        scrollTitle: "D\xe9filer pour augmenter la valeur",
        toggleTitle: "Cliquer pour basculer",
        time_24hr: true
    };
    fp.l10ns.fr = French;
    var fr = fp.l10ns;
    exports1.French = French;
    exports1.default = fr;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $2d773c0dc38d1892$exports = {};
(function(global, factory) {
    factory($2d773c0dc38d1892$exports);
})($2d773c0dc38d1892$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Italian = {
        weekdays: {
            shorthand: [
                "Dom",
                "Lun",
                "Mar",
                "Mer",
                "Gio",
                "Ven",
                "Sab"
            ],
            longhand: [
                "Domenica",
                "Luned\xec",
                "Marted\xec",
                "Mercoled\xec",
                "Gioved\xec",
                "Venerd\xec",
                "Sabato"
            ]
        },
        months: {
            shorthand: [
                "Gen",
                "Feb",
                "Mar",
                "Apr",
                "Mag",
                "Giu",
                "Lug",
                "Ago",
                "Set",
                "Ott",
                "Nov",
                "Dic"
            ],
            longhand: [
                "Gennaio",
                "Febbraio",
                "Marzo",
                "Aprile",
                "Maggio",
                "Giugno",
                "Luglio",
                "Agosto",
                "Settembre",
                "Ottobre",
                "Novembre",
                "Dicembre"
            ]
        },
        firstDayOfWeek: 1,
        ordinal: function() {
            return "\xb0";
        },
        rangeSeparator: " al ",
        weekAbbreviation: "Se",
        scrollTitle: "Scrolla per aumentare",
        toggleTitle: "Clicca per cambiare",
        time_24hr: true
    };
    fp.l10ns.it = Italian;
    var it = fp.l10ns;
    exports1.Italian = Italian;
    exports1.default = it;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $f182ee79b4a84e83$exports = {};
(function(global, factory) {
    factory($f182ee79b4a84e83$exports);
})($f182ee79b4a84e83$exports, function(exports1) {
    'use strict';
    var english = {
        weekdays: {
            shorthand: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            longhand: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ]
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            longhand: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ]
        },
        daysInMonth: [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ],
        firstDayOfWeek: 0,
        ordinal: function(nth) {
            var s = nth % 100;
            if (s > 3 && s < 21) return "th";
            switch(s % 10){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        },
        rangeSeparator: " to ",
        weekAbbreviation: "Wk",
        scrollTitle: "Scroll to increment",
        toggleTitle: "Click to toggle",
        amPM: [
            "AM",
            "PM"
        ],
        yearAriaLabel: "Year",
        monthAriaLabel: "Month",
        hourAriaLabel: "Hour",
        minuteAriaLabel: "Minute",
        time_24hr: false
    };
    exports1.default = english;
    exports1.english = english;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $99c23931b84cf5a0$var$DatePickerLocale = /*#__PURE__*/ function(DatePickerLocale) {
    DatePickerLocale["DE"] = "de";
    DatePickerLocale["FR"] = "fr";
    DatePickerLocale["IT"] = "it";
    DatePickerLocale["EN"] = "en";
    return DatePickerLocale;
}($99c23931b84cf5a0$var$DatePickerLocale || {});
class $99c23931b84cf5a0$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.fieldElement = this.querySelector('input') || undefined;
        const localeValue = this.getAttribute('data-tk-locale');
        this.localeKey = localeValue && $99c23931b84cf5a0$var$DatePickerLocale[localeValue.toUpperCase()] || "de";
        this.allowMobile = this.hasAttribute('data-tk-allow-mobile');
        this.config = {
            positionElement: this.fieldElement,
            disableMobile: !this.allowMobile,
            locale: this.localeKey,
            wrap: true,
            allowInput: true,
            onValueUpdate: this.handleValueUpdate.bind(this)
        };
    }
    connectedCallback() {
        if (!this.fieldElement) return;
        $99c23931b84cf5a0$export$2e2bcd8739ae039.initLanguages();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.flatpickr?.destroy();
    }
    handleValueUpdate() {
        this.fieldElement?.removeAttribute('data-tk-ignore-field');
        this.fieldElement?.dispatchEvent(new InputEvent('input'));
    }
    static initLanguages() {
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $dad224760cee6051$exports.German));
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $34ba2808af177678$exports.French));
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $2d773c0dc38d1892$exports.Italian));
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $f182ee79b4a84e83$exports.english));
    }
}


var $af701e7a05cc8252$exports = {};
(function(global, factory) {
    $af701e7a05cc8252$exports = factory();
})($af701e7a05cc8252$exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    var monthToStr = function(monthNumber, shorthand, locale) {
        return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
    };
    function clearNode(node) {
        while(node.firstChild)node.removeChild(node.firstChild);
    }
    function getEventTarget(event) {
        try {
            if (typeof event.composedPath === "function") {
                var path = event.composedPath();
                return path[0];
            }
            return event.target;
        } catch (error) {
            return event.target;
        }
    }
    var defaultConfig = {
        shorthand: false,
        dateFormat: "F Y",
        altFormat: "F Y",
        theme: "light"
    };
    function monthSelectPlugin(pluginConfig) {
        var config = __assign(__assign({}, defaultConfig), pluginConfig);
        return function(fp) {
            fp.config.dateFormat = config.dateFormat;
            fp.config.altFormat = config.altFormat;
            var self = {
                monthsContainer: null
            };
            function clearUnnecessaryDOMElements() {
                if (!fp.rContainer) return;
                clearNode(fp.rContainer);
                for(var index = 0; index < fp.monthElements.length; index++){
                    var element = fp.monthElements[index];
                    if (!element.parentNode) continue;
                    element.parentNode.removeChild(element);
                }
            }
            function build() {
                if (!fp.rContainer) return;
                self.monthsContainer = fp._createElement("div", "flatpickr-monthSelect-months");
                self.monthsContainer.tabIndex = -1;
                buildMonths();
                fp.rContainer.appendChild(self.monthsContainer);
                fp.calendarContainer.classList.add("flatpickr-monthSelect-theme-" + config.theme);
            }
            function buildMonths() {
                if (!self.monthsContainer) return;
                clearNode(self.monthsContainer);
                var frag = document.createDocumentFragment();
                for(var i = 0; i < 12; i++){
                    var month = fp.createDay("flatpickr-monthSelect-month", new Date(fp.currentYear, i), 0, i);
                    if (month.dateObj.getMonth() === new Date().getMonth() && month.dateObj.getFullYear() === new Date().getFullYear()) month.classList.add("today");
                    month.textContent = monthToStr(i, config.shorthand, fp.l10n);
                    month.addEventListener("click", selectMonth);
                    frag.appendChild(month);
                }
                self.monthsContainer.appendChild(frag);
                if (fp.config.minDate && fp.currentYear === fp.config.minDate.getFullYear()) fp.prevMonthNav.classList.add("flatpickr-disabled");
                else fp.prevMonthNav.classList.remove("flatpickr-disabled");
                if (fp.config.maxDate && fp.currentYear === fp.config.maxDate.getFullYear()) fp.nextMonthNav.classList.add("flatpickr-disabled");
                else fp.nextMonthNav.classList.remove("flatpickr-disabled");
            }
            function bindEvents() {
                fp._bind(fp.prevMonthNav, "click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    fp.changeYear(fp.currentYear - 1);
                    selectYear();
                    buildMonths();
                });
                fp._bind(fp.nextMonthNav, "click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    fp.changeYear(fp.currentYear + 1);
                    selectYear();
                    buildMonths();
                });
                fp._bind(self.monthsContainer, "mouseover", function(e) {
                    if (fp.config.mode === "range") fp.onMouseOver(getEventTarget(e), "flatpickr-monthSelect-month");
                });
            }
            function setCurrentlySelected() {
                if (!fp.rContainer) return;
                if (!fp.selectedDates.length) return;
                var currentlySelected = fp.rContainer.querySelectorAll(".flatpickr-monthSelect-month.selected");
                for(var index = 0; index < currentlySelected.length; index++)currentlySelected[index].classList.remove("selected");
                var targetMonth = fp.selectedDates[0].getMonth();
                var month = fp.rContainer.querySelector(".flatpickr-monthSelect-month:nth-child(" + (targetMonth + 1) + ")");
                if (month) month.classList.add("selected");
            }
            function selectYear() {
                var selectedDate = fp.selectedDates[0];
                if (selectedDate) {
                    selectedDate = new Date(selectedDate);
                    selectedDate.setFullYear(fp.currentYear);
                    if (fp.config.minDate && selectedDate < fp.config.minDate) selectedDate = fp.config.minDate;
                    if (fp.config.maxDate && selectedDate > fp.config.maxDate) selectedDate = fp.config.maxDate;
                    fp.currentYear = selectedDate.getFullYear();
                }
                fp.currentYearElement.value = String(fp.currentYear);
                if (fp.rContainer) {
                    var months = fp.rContainer.querySelectorAll(".flatpickr-monthSelect-month");
                    months.forEach(function(month) {
                        month.dateObj.setFullYear(fp.currentYear);
                        if (fp.config.minDate && month.dateObj < fp.config.minDate || fp.config.maxDate && month.dateObj > fp.config.maxDate) month.classList.add("flatpickr-disabled");
                        else month.classList.remove("flatpickr-disabled");
                    });
                }
                setCurrentlySelected();
            }
            function selectMonth(e) {
                e.preventDefault();
                e.stopPropagation();
                var eventTarget = getEventTarget(e);
                if (!(eventTarget instanceof Element)) return;
                if (eventTarget.classList.contains("flatpickr-disabled")) return;
                if (eventTarget.classList.contains("notAllowed")) return; // necessary??
                setMonth(eventTarget.dateObj);
                if (fp.config.closeOnSelect) {
                    var single = fp.config.mode === "single";
                    var range = fp.config.mode === "range" && fp.selectedDates.length === 2;
                    if (single || range) fp.close();
                }
            }
            function setMonth(date) {
                var selectedDate = new Date(fp.currentYear, date.getMonth(), date.getDate());
                var selectedDates = [];
                switch(fp.config.mode){
                    case "single":
                        selectedDates = [
                            selectedDate
                        ];
                        break;
                    case "multiple":
                        selectedDates.push(selectedDate);
                        break;
                    case "range":
                        if (fp.selectedDates.length === 2) selectedDates = [
                            selectedDate
                        ];
                        else {
                            selectedDates = fp.selectedDates.concat([
                                selectedDate
                            ]);
                            selectedDates.sort(function(a, b) {
                                return a.getTime() - b.getTime();
                            });
                        }
                        break;
                }
                fp.setDate(selectedDates, true);
                setCurrentlySelected();
            }
            var shifts = {
                37: -1,
                39: 1,
                40: 3,
                38: -3
            };
            function onKeyDown(_, __, ___, e) {
                var shouldMove = shifts[e.keyCode] !== undefined;
                if (!shouldMove && e.keyCode !== 13) return;
                if (!fp.rContainer || !self.monthsContainer) return;
                var currentlySelected = fp.rContainer.querySelector(".flatpickr-monthSelect-month.selected");
                var index = Array.prototype.indexOf.call(self.monthsContainer.children, document.activeElement);
                if (index === -1) {
                    var target = currentlySelected || self.monthsContainer.firstElementChild;
                    target.focus();
                    index = target.$i;
                }
                if (shouldMove) self.monthsContainer.children[(12 + index + shifts[e.keyCode]) % 12].focus();
                else if (e.keyCode === 13 && self.monthsContainer.contains(document.activeElement)) setMonth(document.activeElement.dateObj);
            }
            function closeHook() {
                var _a;
                if (((_a = fp.config) === null || _a === void 0 ? void 0 : _a.mode) === "range" && fp.selectedDates.length === 1) fp.clear(false);
                if (!fp.selectedDates.length) buildMonths();
            }
            // Help the prev/next year nav honor config.minDate (see 3fa5a69)
            function stubCurrentMonth() {
                config._stubbedCurrentMonth = fp._initialDate.getMonth();
                fp._initialDate.setMonth(config._stubbedCurrentMonth);
                fp.currentMonth = config._stubbedCurrentMonth;
            }
            function unstubCurrentMonth() {
                if (!config._stubbedCurrentMonth) return;
                fp._initialDate.setMonth(config._stubbedCurrentMonth);
                fp.currentMonth = config._stubbedCurrentMonth;
                delete config._stubbedCurrentMonth;
            }
            function destroyPluginInstance() {
                if (self.monthsContainer !== null) {
                    var months = self.monthsContainer.querySelectorAll(".flatpickr-monthSelect-month");
                    for(var index = 0; index < months.length; index++)months[index].removeEventListener("click", selectMonth);
                }
            }
            return {
                onParseConfig: function() {
                    fp.config.enableTime = false;
                },
                onValueUpdate: setCurrentlySelected,
                onKeyDown: onKeyDown,
                onReady: [
                    stubCurrentMonth,
                    clearUnnecessaryDOMElements,
                    build,
                    bindEvents,
                    setCurrentlySelected,
                    function() {
                        fp.config.onClose.push(closeHook);
                        fp.loadedPlugins.push("monthSelect");
                    }
                ],
                onDestroy: [
                    unstubCurrentMonth,
                    destroyPluginInstance,
                    function() {
                        fp.config.onClose = fp.config.onClose.filter(function(hook) {
                            return hook !== closeHook;
                        });
                    }
                ]
            };
        };
    }
    return monthSelectPlugin;
});


class $e018ac17002873dc$export$2e2bcd8739ae039 extends (0, $99c23931b84cf5a0$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.hideWeekNumbers = this.hasAttribute('data-tk-hide-week-numbers');
        this.minDate = this.getAttribute('data-tk-min-date');
        this.maxDate = this.getAttribute('data-tk-max-date');
        this.mode = this.getAttribute('data-tk-mode') || 'single';
        this.monthSelectorType = this.getAttribute('data-tk-month-selector-type') || 'dropdown';
        this.dateFormat = this.getAttribute('data-tk-date-format') || 'd.m.Y';
        this.conjunction = this.getAttribute('data-tk-conjunction') || ',';
        this.defaultDate = this.getAttribute('data-tk-default-date')?.split(';') || null;
        this.disableDates = this.getAttribute('data-tk-disable-dates')?.split(';') || [];
        this.disableWeekend = this.hasAttribute('data-tk-disable-weekend');
        if (this.getAttribute('data-tk-disable-dates-range')) this.disableDatesRange = JSON.parse(this.getAttribute('data-tk-disable-dates-range'));
        this.enableTime = this.hasAttribute('data-tk-enable-time');
        this.enableMonthSelect = this.hasAttribute('data-tk-enable-month-select');
    }
    connectedCallback() {
        super.connectedCallback();
        const datePickerConfig = {
            weekNumbers: !this.hideWeekNumbers,
            dateFormat: this.dateFormat,
            minDate: this.minDate,
            maxDate: this.maxDate,
            mode: this.mode,
            monthSelectorType: this.monthSelectorType,
            conjunction: this.conjunction,
            defaultDate: this.defaultDate,
            disable: this.disableDateRanges(),
            enableTime: this.enableTime,
            time_24hr: true,
            onReady: (_selectedDates, _dateStr, instance)=>{
                !this.enableMonthSelect && this.createCustomActionButtons(instance);
            },
            plugins: []
        };
        if (this.enableMonthSelect) {
            datePickerConfig.plugins.push((0, (/*@__PURE__*/$parcel$interopDefault($af701e7a05cc8252$exports)))({
                shorthand: true,
                dateFormat: this.dateFormat.includes('Y') ? 'm.Y' : 'm',
                altFormat: this.dateFormat.includes('Y') ? 'm.Y' : 'm'
            }));
            datePickerConfig.weekNumbers = false;
        }
        const config = {
            ...this.config,
            ...datePickerConfig
        };
        this.flatpickr = (0, $9986d07d28cc86ca$export$2e2bcd8739ae039)(this, config);
    }
    renderButton(label, className, action) {
        const button = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            <button class="${className}">
                ${label}
            </button>
        `);
        this.pushListener({
            event: 'click',
            element: button,
            action: action
        });
        return button;
    }
    createCustomActionButtons(instance) {
        const { calendarContainer: calendarContainer } = instance;
        const wrapper = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="flatpickr-calendar__actions-area"></div>');
        const resetButton = this.renderButton(window.opacc.projectDatepickerTexts.reset, 'tk-button tk-button--secondary tk-button--size-s', this.resetDatePicker.bind(this));
        const todayButton = this.renderButton(window.opacc.projectDatepickerTexts.today, 'tk-button tk-button--secondary tk-button--size-s', this.jumpToToday.bind(this));
        wrapper.appendChild(todayButton);
        wrapper.appendChild(resetButton);
        calendarContainer.appendChild(wrapper);
    }
    jumpToToday() {
        const today = new Date();
        this.flatpickr?.setDate(today, true);
        this.flatpickr?.jumpToDate(today);
    }
    resetDatePicker() {
        this.flatpickr?.clear();
    }
    disableDateRanges() {
        const disableWeekend = (date)=>date.getDay() === 0 || date.getDay() === 6;
        this.disableDates = this.disableDates.map((element)=>element.replace('\n', '').trim());
        return [
            ...this.disableDatesRange ?? [],
            ...this.disableDates ?? [],
            ...this.disableWeekend ? [
                disableWeekend.bind(this)
            ] : []
        ];
    }
}



var $9a3403e3213d867d$var$HoverState = /*#__PURE__*/ function(HoverState) {
    HoverState["ACTIVE"] = "active";
    HoverState["INACTIVE"] = "inactive";
    return HoverState;
}($9a3403e3213d867d$var$HoverState || {});
class $9a3403e3213d867d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.fieldElement = this.querySelector('input, select, textarea');
        this.labelElement = this.querySelector('label') || undefined;
        this.isMaterial = this.hasAttribute('data-tk-is-material');
        this.materialClass = this.getAttribute('data-tk-material-class') || 'tk-form-material';
        this.materialNumberInputClass = this.getAttribute('data-tk-material-number-input-class') || 'tk-form-material--number';
        this.materialLabelInsideClass = this.getAttribute('data-tk-material-label-inside-class') || 'tk-form-material--label-inside';
        this.materialSelectFocussedClass = this.getAttribute('data-tk-material-select-focussed-class') || 'tk-form-select--focussed';
        this.materialLoadedClass = this.getAttribute('data-tk-material-loaded-class') || 'tk-form-material--loaded';
        this.isPasswordInput = this.hasAttribute('data-tk-toggle-password');
        this.disableOnAddonClick = this.hasAttribute('data-tk-disable-on-addon-click');
        this.addonElement = this.querySelector('[data-tk-addon]') || undefined;
        this.waitForSurroundingContent = this.closest('[data-wait-for-surrounding-content]') || undefined;
        this.addonSuffixDistance = 0;
        this.addonPrefixDistance = 0;
        this.addonDefaultPadding = parseInt(this.getAttribute('data-tk-addon-default-padding') || '0', 10) || 4;
        this.onTransitionEnd = ()=>{};
        this.isBoolean = this.hasAttribute('data-tk-boolean');
        this.checkboxElement = this.querySelector('input[type="checkbox"]') || undefined;
        this.hiddenElement = this.querySelector('input[type="hidden"]') || undefined;
        this.defaultValue = this.hiddenElement?.value || '0';
        this.mask = this.getAttribute('data-tk-mask') || undefined;
        this.hintMaxLength = Number(this.getAttribute('data-tk-hint-max-length')) || undefined;
        this.hintWarningClassName = this.getAttribute('data-tk-hint-warning-class-name') || 'text--warning';
        this.hintCriticalClassName = this.getAttribute('data-tk-hint-critical-class-nameh') || 'text--error';
    }
    connectedCallback() {
        if (this.isNumberInput() || this.waitForSurroundingContent) {
            this.onDomContentLoaded();
            return;
        }
        this.checkRequiredAttribute();
        this.registerAddonClickedListener();
        this.registerAddonHoverListener();
        this.registerShowPasswordClickedListener();
        this.initMaterialInput();
        this.observeDisabledAttribute();
        this.registerMaskListener();
        this.registerHintMaxLengthListener();
        if (!this.isBoolean) return;
        this.registerBooleanListener();
        this.checkboxElement && this.toggleBoolean(this.checkboxElement);
    }
    /**
     * For the Material Number Input or forms inside of tables, it is necessary that all surrounding elements have been
     * fullyloaded before the Material Number Element itself is displayed.
     * This is because the position of the label in the collapsed state
     * needs to be calculated for the Material Number Input. This calculation depends on the surrounding elements
     */ onDomContentLoaded() {
        document.addEventListener('DOMContentLoaded', ()=>{
            this.checkRequiredAttribute();
            this.registerAddonClickedListener();
            this.registerAddonHoverListener();
            this.registerShowPasswordClickedListener();
            this.initMaterialInput();
            this.observeDisabledAttribute();
        });
    }
    // #region Required
    checkRequiredAttribute() {
        if (!this.labelElement || !this.fieldElement || !this.fieldElement.hasAttribute('required')) return;
        this.labelElement.textContent = `${this.labelElement.textContent} *`;
    }
    // #endregion
    // #region disabled
    observeDisabledAttribute() {
        if (!this.fieldElement || !this.labelElement) return;
        // inital check
        this.checkDisabledAttribute();
        const observerConfig = {
            attributes: true,
            attributeFilter: [
                'disabled'
            ]
        };
        const onCheckDiabledAttribute = this.checkDisabledAttribute.bind(this);
        const observer = new MutationObserver(onCheckDiabledAttribute);
        observer.observe(this.fieldElement, observerConfig);
    }
    checkDisabledAttribute() {
        const addDisabledClass = this.fieldElement.hasAttribute('disabled');
        this.classList.toggle('tk-form-input--disabled', addDisabledClass);
    }
    // #endregion
    // #region Addon
    registerAddonClickedListener() {
        if (!this.addonElement || this.disableOnAddonClick) return;
        const addonClickHandler = this.onAddonClicked.bind(this);
        this.pushListener({
            event: 'click',
            element: this.addonElement,
            action: addonClickHandler
        });
    }
    registerAddonHoverListener() {
        if (!this.addonElement) return;
        const onHoverStartHandler = this.onAddonHover.bind(this, "active");
        this.pushListener({
            event: 'mouseenter',
            element: this.addonElement,
            action: onHoverStartHandler
        });
        const onHoverEndHandler = this.onAddonHover.bind(this, "inactive");
        this.pushListener({
            event: 'mouseleave',
            element: this.addonElement,
            action: onHoverEndHandler
        });
    }
    registerBooleanListener() {
        if (!this.checkboxElement || !this.hiddenElement) return;
        const onInput = this.handleBoolean.bind(this);
        this.pushListener({
            event: 'input',
            element: this.checkboxElement,
            action: onInput
        });
    }
    registerHintMaxLengthListener() {
        if (!this.fieldElement || !this.hintMaxLength) return;
        const action = this.handleHintMaxLength.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: action
        });
    }
    handleBoolean(event) {
        const target = event.target;
        this.toggleBoolean(target);
    }
    toggleBoolean(element) {
        if (element.checked) this.hiddenElement.value = element.value;
        else this.hiddenElement.value = this.defaultValue;
    }
    onAddonHover(hoverState) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error('No Input element found');
        this.classList.toggle('tk-form--addon-hover', hoverState === "active" && !this.fieldElement.disabled);
    }
    onAddonClicked() {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error('No Input element found');
        if (this.isPasswordInput) return;
        this.fieldElement.focus();
        const lastCharPosition = this.fieldElement.value.length;
        const isNumberInput = this.fieldElement.type === 'number';
        if (isNumberInput) this.fieldElement.setAttribute('type', 'text');
        this.fieldElement.setSelectionRange(lastCharPosition, lastCharPosition);
        if (isNumberInput) this.fieldElement.setAttribute('type', 'number');
    }
    registerShowPasswordClickedListener() {
        if (!this.isPasswordInput || !this.addonElement) return;
        const passwordShowClickHandler = this.onPasswordShowClicked.bind(this);
        this.pushListener({
            event: 'mousedown',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'mouseup',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'touchstart',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'touchend',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
    }
    onPasswordShowClicked(event) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement)) throw new Error('Missing input element');
        if (event.type === 'mousedown' || event.type === 'touchstart') this.fieldElement.type = 'text';
        else this.fieldElement.type = 'password';
    }
    // #endregion
    // #region Material
    initMaterialInput() {
        if (!this.isMaterial) return;
        if (!this.fieldElement) throw new Error('No element found');
        this.classList.add(this.materialClass);
        if (this.isNumberInput()) this.classList.add(this.materialNumberInputClass);
        this.registerLabelTransitionEndListener();
        this.calculateAddonWidth();
        this.setMaterialLabelState();
        this.registerMaterialValueChangeListener();
        this.registerMaterialSelectFocusChangeListener();
    }
    /**
     * This function is mainly used to check whether a valid value has been
     * set for the data-tk-addon attribute
     * @returns addonType: string representing the addon type
     */ getAddonType() {
        if (!this.addonElement) throw new Error('Missing addon');
        const addonType = this.addonElement.getAttribute('data-tk-addon');
        if (addonType !== 'prefix' && addonType !== 'suffix') throw new Error('Wrong addon type');
        return addonType;
    }
    /**
     * Checks whether the element contains a value or not. This information is required
     * to determine whether the label should be displayed inside or outside the element.
     * @returns isEmptyElement: boolean
     */ checkForValue() {
        let isEmptyElement;
        if (this.fieldElement instanceof HTMLSelectElement) {
            const selectedOption = this.querySelector('option:checked');
            const isPlaceholderOption = selectedOption?.hasAttribute('data-tk-empty-option');
            isEmptyElement = isPlaceholderOption;
        } else isEmptyElement = this.fieldElement?.value === '';
        return isEmptyElement;
    }
    /**
     * This function implements the material functionality by displaying the label either
     * inside or outside the control, depending on the content
     */ setMaterialLabelState() {
        // check input value
        const isEmptyMaterialInput = this.checkForValue();
        if (isEmptyMaterialInput) {
            this.classList.add(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error('Missing label element');
            if (this.isNumberInput()) this.setupMaterialNumberLabelStyle();
            if (!this.isNumberInput()) this.setupMaterialDefaultLabelStyle();
        } else {
            this.classList.remove(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error('Missing label element');
            this.labelElement.removeAttribute('style');
        }
    }
    /**
     * This function calculates the label position for a material input that is not of type
     * number and where the label is located within the input
     */ setupMaterialDefaultLabelStyle() {
        if (this.addonPrefixDistance === 0 && this.addonSuffixDistance === 0) return;
        this.labelElement.style.marginLeft = this.addonPrefixDistance > 0 ? `${this.addonPrefixDistance + this.addonDefaultPadding}px` : '0px';
        this.labelElement.style.marginRight = this.addonSuffixDistance > 0 ? `${this.addonSuffixDistance + this.addonDefaultPadding}px` : '0px';
        this.labelElement.style.paddingInline = '0';
    }
    /**
     * This function calculates the label position for a material input of type Number where
     *  the label is located within the input
     */ setupMaterialNumberLabelStyle() {
        this.labelElement.style.paddingInline = '0';
        const labelWidthWithPadding = this.labelElement.getBoundingClientRect().width;
        const computedLabelStyle = window.getComputedStyle(this.labelElement);
        const labelPaddingLeft = parseFloat(computedLabelStyle.paddingLeft);
        const labelPaddingRight = parseFloat(computedLabelStyle.paddingRight);
        const labelWidth = labelWidthWithPadding - labelPaddingLeft - labelPaddingRight;
        const formControlWidth = this.getBoundingClientRect().width;
        const computetInputStyle = window.getComputedStyle(this.fieldElement);
        const inputPaddingRight = parseFloat(computetInputStyle.paddingRight);
        const addonWidth = this.addonElement && this.getAddonType() === 'suffix' ? this.addonElement.getBoundingClientRect().width : 0;
        const xOffset = Math.round(formControlWidth - labelWidth - addonWidth - inputPaddingRight);
        this.labelElement.style.paddingLeft = `${xOffset}px`;
    }
    /**
     * This function checks whether the current control has an addon. If so, depending
     * on the type of control, it checks whether the material label requires additional
     * spacing in the folded state
     */ calculateAddonWidth() {
        if (!this.addonElement) return;
        if (this.fieldElement instanceof HTMLSelectElement) return;
        /* The text is displayed right-aligned for the number inputs.
        They must therefore be treated separately */ const isNumberInput = this.isNumberInput();
        const addonType = this.getAddonType();
        if (!isNumberInput && addonType === 'prefix') this.addonPrefixDistance = this.addonElement.offsetWidth;
        else if (isNumberInput && addonType === 'suffix') this.addonSuffixDistance = this.addonElement.offsetWidth;
    }
    /**
     * Checks whether the input is of type Number. This information is required because
     * the text does not start on the left when the number input is collapsed
     * @returns boolean: representing is input of type number
     */ isNumberInput() {
        if (!(this.fieldElement instanceof HTMLInputElement)) return false;
        return this.fieldElement && this.fieldElement.type === 'number';
    }
    /**
     * Listener for material control value changes
     */ registerMaterialValueChangeListener() {
        const onValueChanged = this.setMaterialLabelState.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: onValueChanged
        });
    }
    /**
     * Is required so that a class can be added to the focused material select
     * element that colors the text of the select white
     */ registerMaterialSelectFocusChangeListener() {
        if (!(this.fieldElement instanceof HTMLSelectElement)) return;
        const onFocusChanged = this.onMaterialSelectFocusChanged.bind(this);
        this.pushListener({
            event: 'focusin',
            element: this.fieldElement,
            action: onFocusChanged
        });
        this.pushListener({
            event: 'focusout',
            element: this.fieldElement,
            action: onFocusChanged
        });
    }
    /**
     * This function is used to add a class to the focused material select, which sets
     * the font to white if no option has been selected
     * @param event: Used to determin if focus has been set or removed
     */ onMaterialSelectFocusChanged(event) {
        const { type: type } = event;
        if (type === 'focusin') this.classList.add(this.materialSelectFocussedClass);
        else this.classList.remove(this.materialSelectFocussedClass);
    }
    /**
     * This function fades in the material element as soon as the label is in
     * the correct position
     */ registerLabelTransitionEndListener() {
        if (!this.labelElement) throw new Error('Missing label element');
        this.onTransitionEnd = this.addMaterialLoadedModifier.bind(this);
        this.pushListener({
            event: 'transitionend',
            element: this.labelElement,
            action: this.onTransitionEnd
        });
    }
    addMaterialLoadedModifier() {
        this.classList.add(this.materialLoadedClass);
        this.labelElement.removeEventListener('transitionend', this.onTransitionEnd);
    }
    // #endregion
    registerMaskListener() {
        if (!this.mask || !(this.fieldElement instanceof HTMLInputElement)) return;
        const options = JSON.parse(this.mask);
        const onMaskInput = this.onMaskInput.bind(this, options);
        try {
            this.pushListener({
                event: 'input',
                element: this.fieldElement,
                action: onMaskInput
            });
            this.pushListener({
                event: 'paste',
                element: this.fieldElement,
                action: onMaskInput
            });
        } catch (error) {
            console.warn('Invalid mask config:', this.mask, error);
        }
    }
    onMaskInput(options, event) {
        const target = event.currentTarget;
        if (options.type === 'slug') {
            const normalizeCharMap = {
                "\xe9": 'e',
                "\xe8": 'e',
                "\xf6": 'oe',
                "\xe4": 'ae',
                "\xfc": 'ue',
                "\xe0": 'a',
                "\xee": 'i'
            };
            const normalized = target.value.split('').map((char)=>normalizeCharMap[char] ?? char).join('');
            const value = normalized.toLowerCase().replace(/[^a-z0-9\s_-]/g, '') // only lower case letters, numbers, spaces, -, _
            .replace(/[\s_]+/g, '-') // Spaces or underscores → hyphen
            .replace(/-+/g, '-') // Avoid double hyphens
            .replace(/^-+|-+$/g, ''); // no hyphens at the beginning or end
            target.value = value;
            return;
        }
        let value = target.value.replace(/[^a-zA-Z0-9]/g, '');
        if (options.uppercase) value = value.toUpperCase();
        const result = [];
        let idx = 0;
        for(let i = 0; i < options.blocks.length; i++){
            const blockLen = options.blocks[i];
            const part = value.substring(idx, idx + blockLen);
            if (!part) break;
            result.push(part);
            idx += blockLen;
        }
        const withDelimiters = result.map((part, i)=>{
            if (i < options.delimiters.length) return part + options.delimiters[i];
            return part;
        });
        target.value = withDelimiters.join('').substring(0, target.maxLength || 100);
    }
    handleHintMaxLength(event) {
        if (!this.hintMaxLength) return;
        const target = event.currentTarget;
        const length = target.value.length;
        const wrapperElement = this.querySelector('[data-tk-hint-max-length-wrapper]');
        const counterElement = this.querySelector('[data-tk-hint-max-length-counter]');
        if (!wrapperElement || !counterElement) return;
        counterElement.textContent = String(length);
        wrapperElement.classList.toggle(this.hintWarningClassName, length >= this.hintMaxLength * 0.9);
        wrapperElement.classList.toggle(this.hintCriticalClassName, length >= this.hintMaxLength);
    }
}




const $fbcf93c2a0aa5bcb$export$37cc283d8fbd3462 = (value)=>{
    const bytes = new TextEncoder().encode(value);
    return btoa(String.fromCharCode(...bytes));
};
const $fbcf93c2a0aa5bcb$export$c537b38001c583b7 = (base64)=>{
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (char)=>char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
};
const $fbcf93c2a0aa5bcb$var$isBase64 = (value)=>{
    try {
        return $fbcf93c2a0aa5bcb$export$37cc283d8fbd3462($fbcf93c2a0aa5bcb$export$c537b38001c583b7(value)) === value;
    } catch  {
        return false;
    }
};
var $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039 = $fbcf93c2a0aa5bcb$var$isBase64;


const $1653b55d89a7adce$var$getDefaultErrorFnc = (error)=>{
    throw new Error(`Request failed: ${error}`);
};
const $1653b55d89a7adce$export$a4101276b4831ec4 = (checkForReadOnlyContext = false)=>{
    const asyncUrl = '/WebPortal/async.aspx';
    if (!window.opacc || !window.opacc.systemUrls || !checkForReadOnlyContext || !window.opacc.systemUrls.asyncReadOnly) return asyncUrl;
    return window.opacc.systemUrls.asyncReadOnly;
};
const $1653b55d89a7adce$var$prepareJsonResponse = (response, showMessages)=>{
    const data = (0, $fbcf93c2a0aa5bcb$export$c537b38001c583b7)(response.data);
    const html = document.createElement('div');
    html.innerHTML = data;
    const json = response.contentType === 'application/json' && html.innerText !== '' ? JSON.parse(html.innerText) : {};
    showMessages && (0, $1221feb2184dfefe$export$5b256beea4c7e9b5)(response.messages, json);
    return {
        status: response.status,
        messages: response.messages,
        dataAsBase64: response.data,
        contentType: response,
        success: response.status === 'ok',
        dataAsHtml: response.contentType === 'text/html' ? html.innerText : '',
        dataAsJson: json,
        data: data
    };
};
const $1653b55d89a7adce$var$recordToURLSearchParams = (data)=>{
    const searchParams = new URLSearchParams();
    Object.entries(data).forEach(([key, value])=>{
        searchParams.append(key, value || '');
    });
    return searchParams;
};
const $1653b55d89a7adce$var$formDataToURLSearchParams = (formData)=>{
    const searchParams = new URLSearchParams();
    formData.forEach((value, key)=>{
        searchParams.append(key, value);
    });
    return searchParams;
};
const $1653b55d89a7adce$export$d5a8517da06db2d = async ({ requestURL: requestURL, resolveHandler: resolveHandler, rejectHandler: rejectHandler = $1653b55d89a7adce$var$getDefaultErrorFnc, payload: payload, decodeJSONResponse: decodeJSONResponse = true, cache: cache = 'default', showMessages: showMessages = true, signal: signal })=>{
    const headers = new Headers({
        'x-requested-with': 'XMLHttpRequest',
        'response-type': 'json'
    });
    let body;
    if (payload) {
        headers.set('content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
        if (payload instanceof URLSearchParams) body = payload;
        else if (payload instanceof FormData) body = $1653b55d89a7adce$var$formDataToURLSearchParams(payload);
        else if (payload instanceof Object) body = $1653b55d89a7adce$var$recordToURLSearchParams(payload);
    }
    const init = {
        method: payload ? 'POST' : 'GET',
        headers: headers,
        cache: cache,
        credentials: 'include',
        body: body,
        signal: signal
    };
    try {
        const response = await fetch(requestURL, init);
        const contentType = response.headers.get('content-type');
        const data = contentType?.includes('application/json') ? await response.json() : await response.text();
        const preparedData = decodeJSONResponse ? $1653b55d89a7adce$var$prepareJsonResponse(data, showMessages) : data;
        resolveHandler(preparedData);
    } catch (error) {
        if (error instanceof Error && error.name === 'AbortError') return;
        rejectHandler(error);
    }
};
const $1653b55d89a7adce$export$24835cb787452b46 = async (params)=>{
    const requestManager = document.querySelector('[data-tk-request-manager]');
    if (requestManager) return requestManager.addRequest(params);
    return $1653b55d89a7adce$export$d5a8517da06db2d(params);
};
const $1653b55d89a7adce$export$38e06f4bcf141755 = async (params)=>{
    return new Promise((resolve, reject)=>{
        $1653b55d89a7adce$export$d5a8517da06db2d({
            ...params,
            resolveHandler: (response)=>{
                resolve(response.dataAsJson);
            },
            rejectHandler: reject
        });
    });
};






class $cb17fd7e698c018c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.listWrapperClassName = this.getAttribute('data-tk-zip-list-class') || 'tk-form-zipcity__list';
        this.fieldCountry = this.querySelector('[data-tk-zip-country]') || undefined;
        this.fieldZip = this.querySelector('[data-tk-zip-zip]') || undefined;
        this.fieldCity = this.querySelector('[data-tk-zip-city]') || undefined;
        this.lastSearchTerm = '';
        this.selectedField = undefined;
        this.listWrapper = document.createElement('div');
        this.listWrapper.classList.add(this.listWrapperClassName);
        this.listWrapper.hidden = true;
        this.loadingSpinnerTimeout = null;
        this.clearDataTimeout = null;
        this.inputObject = {
            inputField: undefined,
            dropdown: this.listWrapper,
            listItemSelected: undefined,
            data: []
        };
    }
    connectedCallback() {
        this.registerListener();
    }
    registerListener() {
        if (!this.fieldZip && !this.fieldCity) return;
        const onInputHandler = this.searchZipCity.bind(this);
        const onClickHandler = this.toggleDropdown.bind(this);
        const onSelectHandler = this.selectItem.bind(this);
        const onChangeHandler = this.clearFormFields.bind(this);
        const onInputKeyNavigationHandler = this.inputKeyNavigation.bind(this);
        const onDropdownKeyNavigationHandler = this.dropdownKeyNavigation.bind(this);
        this.pushListener({
            event: 'click',
            element: this.fieldZip,
            action: onClickHandler
        });
        this.pushListener({
            event: 'click',
            element: this.fieldCity,
            action: onClickHandler
        });
        this.pushListener({
            event: 'click',
            element: this.inputObject.dropdown,
            action: onSelectHandler
        });
        this.pushListener({
            event: 'input',
            element: this.fieldZip,
            action: onInputHandler
        });
        this.pushListener({
            event: 'input',
            element: this.fieldCity,
            action: onInputHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.fieldZip,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.fieldCity,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.inputObject.dropdown,
            action: onDropdownKeyNavigationHandler
        });
        if (this.fieldCountry) this.pushListener({
            event: 'change',
            element: this.fieldCountry,
            action: onChangeHandler
        });
    }
    inputKeyNavigation(event) {
        if (!(event.code === 'Tab' || event.code === 'Enter' || event.code === 'ArrowDown')) return;
        this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.dropdown?.classList.remove('hide');
        this.inputObject.listItemSelected.focus();
        event.preventDefault();
    }
    dropdownKeyNavigation(event) {
        const keyActions = {
            ArrowDown: ()=>this.handleArrowKey(true),
            ArrowUp: ()=>this.handleArrowKey(false),
            Enter: ()=>this.selectItem(event),
            Space: ()=>this.selectItem(event),
            Tab: ()=>this.hideDropdown(true),
            Escape: ()=>this.hideDropdown(true)
        };
        const action = keyActions[event.code];
        if (!action) return;
        action();
        event.preventDefault();
    }
    handleArrowKey(isDown) {
        if (this.inputObject.listItemSelected) {
            const nextElement = isDown ? this.inputObject.listItemSelected.nextElementSibling : this.inputObject.listItemSelected.previousElementSibling;
            if (nextElement instanceof HTMLElement) this.inputObject.listItemSelected = nextElement;
        } else this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.listItemSelected.focus();
        this.setScroller();
    }
    hideDropdown(isHidden = false) {
        if (this.inputObject.dropdown) {
            if (!isHidden) {
                this.showLoadingAnimation();
                this.listWrapper.style.border = 'unset';
            }
            this.inputObject.dropdown.hidden = isHidden;
        }
    }
    toggleDropdown() {
        if (this.inputObject.dropdown && this.inputObject.dropdown.hasChildNodes()) this.inputObject.dropdown.hidden = !this.inputObject.dropdown.hidden;
    }
    setScroller() {
        const { dropdown: dropdown, listItemSelected: listItemSelected } = this.inputObject;
        if (!dropdown || !listItemSelected) return;
        const index = Array.from(dropdown.children).indexOf(listItemSelected);
        const elHeight = listItemSelected.offsetHeight;
        const { scrollTop: scrollTop } = dropdown;
        const viewport = scrollTop + dropdown.offsetHeight;
        const elOffset = elHeight * index;
        if (elOffset >= scrollTop && elOffset + elHeight <= viewport) return;
        dropdown.scrollTop = elOffset;
    }
    setInputObject() {
        if (!this.selectedField?.parentElement?.querySelector(`.${this.listWrapperClassName}`)) this.selectedField?.insertAdjacentElement('afterend', this.listWrapper);
        this.inputObject.inputField = this.selectedField;
    }
    searchZipCity(event) {
        this.selectedField = event.target;
        const value = this.selectedField.value.trim();
        if (value.length < 2) {
            this.clearDataTimeout && clearTimeout(this.clearDataTimeout);
            this.clearDataTimeout = setTimeout(()=>{
                this.clearData();
            }, 300);
            return;
        }
        this.lastSearchTerm = value;
        this.setInputObject();
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.callApi(value);
        }, 300);
    }
    callApi(value) {
        if (!this.inputObject.dropdown) return;
        this.hideDropdown(false);
        if (this.lastSearchTerm !== value) return;
        const zipCity = this.parseZipCity(value);
        const apiUrl = `${window.location.origin}/api/portal/v1/zipsearch`;
        const urlObject = new URL(apiUrl);
        const { searchParams: searchParams } = urlObject;
        Object.entries(zipCity).forEach(([key, value])=>{
            searchParams.set(key, value);
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: urlObject.toString(),
            resolveHandler: this.refreshResultList.bind(this),
            decodeJSONResponse: false
        });
    }
    parseZipCity(value) {
        let zip;
        let city;
        const country = this.fieldCountry?.value?.toLowerCase() || 'ch';
        const arr = value.split(' ');
        const numberRegex = /^[0-9]+$/;
        const regexTest = arr.find((elem)=>numberRegex.test(elem));
        if (regexTest === undefined) zip = '';
        else zip = regexTest;
        if (!zip) {
            if (arr.length > 1) zip = +arr[1] || '';
        }
        zip = zip.toString();
        city = value.replace(zip, '').trim();
        if (city === 'undefined') city = '';
        return {
            zip: zip,
            city: city,
            country: country
        };
    }
    refreshResultList(response) {
        if (!response) return;
        this.clearData();
        if (Array.isArray(response)) response.forEach((element)=>{
            const listItemTpl = `
                <button type="button" class="tk-form-list-item"
                    data-tk-country="${element.country}"
                    data-tk-zip="${element.zip}"
                    data-tk-city="${element.city}"
                    tabindex="-1"
                >
                    <span class="tk-form__label">
                        ${element.zip} ${element.city}
                    </span>
                </button>`;
            this.inputObject.dropdown.insertAdjacentHTML('beforeend', listItemTpl);
            this.inputObject.data?.push({
                zip: element.zip,
                city: element.city,
                country: element.country
            });
        });
        if (this.inputObject.data.length === 0) {
            const listItemTpl = `
                <div class="spacer-p-2">
                    <div class="tk-message tk-message--info tk-message--fullwidth">
                        <span class="tk-message__icon">
                            <i class="tk-icon-warning"></i>
                        </span>
                        <span class="tk-message__label">${(0, $86b3c5b6d66bd808$export$97a703132b664051).noMatchFound}</span>
                    </div>
                </div>`;
            this.inputObject.dropdown.insertAdjacentHTML('beforeend', listItemTpl);
        }
        this.listWrapper.style.border = '';
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.inputObject.dropdown.hidden = false;
    }
    selectItem(event) {
        let selectedItem = event.target;
        selectedItem = selectedItem.closest('[data-tk-zip]');
        if (!selectedItem) return;
        const zip = selectedItem.getAttribute('data-tk-zip');
        const city = selectedItem.getAttribute('data-tk-city');
        const country = selectedItem.getAttribute('data-tk-country');
        if (this.fieldZip) this.fieldZip.value = zip;
        if (this.fieldCity) this.fieldCity.value = city;
        if (this.fieldCountry) this.fieldCountry.value = country;
        this.inputObject.inputField.focus();
        this.clearData();
    }
    clearFormFields() {
        this.clearData();
        this.fieldCity.value = '';
        this.fieldZip.value = '';
    }
    clearData() {
        if (this.inputObject.dropdown) {
            this.hideDropdown(true);
            this.inputObject.dropdown.replaceChildren();
        }
        this.inputObject.data = [];
    }
    showLoadingAnimation() {
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.loadingSpinnerTimeout = setTimeout(()=>{
            this.listWrapper.innerHTML = `
                <div class="tk-progress tk-progress--infinite tk-progress--breakout">
                    <div class="tk-progress__bar"></div>
                </div>`;
        }, 300);
    }
    static async isValidZipCity(form) {
        const apiUrl = `${window.location.origin}/api/portal/v1/zipsearch`;
        const zipCityElem = {
            country: form.querySelector('[data-tk-zip-country]') || '',
            zip: form.querySelector('[data-tk-zip-zip]') || '',
            city: form.querySelector('[data-tk-zip-city]') || ''
        };
        const zipCityValue = {
            country: zipCityElem.country.value,
            zip: zipCityElem.zip.value,
            city: zipCityElem.city.value
        };
        const urlObject = new URL(apiUrl);
        const { searchParams: searchParams } = urlObject;
        Object.entries(zipCityValue).forEach(([key, value])=>{
            searchParams.set(key, value);
        });
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: urlObject.toString(),
                decodeJSONResponse: false,
                resolveHandler: (response)=>{
                    let isValid = false;
                    if (Array.isArray(response)) response.some((item)=>{
                        isValid = $cb17fd7e698c018c$export$2e2bcd8739ae039.shallowObjectEquality(zipCityValue, item);
                        return isValid;
                    });
                    resolve(isValid);
                }
            });
        });
    }
    static shallowObjectEquality(object1, object2) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);
        let isEqual = true;
        if (keys1.length !== keys2.length) {
            isEqual = false;
            return isEqual;
        }
        keys1.forEach((key)=>{
            if (object1[key] !== object2[key]) {
                isEqual = false;
                return isEqual;
            }
        });
        return isEqual;
    }
}


var $21a7ddce6a8de4e2$var$matchType = /*#__PURE__*/ function(matchType) {
    matchType["Some"] = "SOME";
    matchType["Full"] = "FULLMATCH";
    return matchType;
}($21a7ddce6a8de4e2$var$matchType || {});
class $21a7ddce6a8de4e2$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.validationList = [];
        this.form = this.querySelector('form') || undefined;
        this.fieldWrapperSelector = this.getAttribute('data-tk-field-wrapper-selector') || '[data-tk-field-wrapper]';
        this.formErrorClassName = this.getAttribute('data-tk-form-error-class-name') || 'tk-form--error';
        this.fieldHintClassName = this.getAttribute('data-tk-field-hint-class-name') || 'tk-form__hint';
        this.shouldValidateInline = this.hasAttribute('data-tk-should-validate-inline');
        this.passwordStrengthMeter = this.querySelector('[data-tk-password-strength-meter]') || undefined;
        this.passwordNewElement = this.querySelector('[data-tk-password-new]') || undefined;
        this.passwordRepeatElement = this.querySelector('[data-tk-password-repeat]') || undefined;
        this.passwordValidClassName = this.getAttribute('data-tk-password-valid-class-name') || 'tk-form--valid';
        this.passwordInvalidClassName = this.getAttribute('data-tk-password-valid-class-name') || 'tk-form--invalid';
        this.googleRecaptcha = this.querySelector('[data-tk-google-recaptcha]') || undefined;
        // Selects an element that is clicked when the enter key is pressed
        this.preventEnterDefaultAction = this.getAttribute('data-tk-enter-data-attribute-selector') || undefined;
    }
    connectedCallback() {
        if (!this.form) return;
        this.validationList = [];
        this.setNoValidateForm();
        this.searchFieldElements();
        this.registerSubmitListener();
        this.registerPasswordListener();
        this.shouldValidateInline && this.registerFieldValidationListener();
    }
    setNoValidateForm() {
        if (!this.form) return;
        this.form.noValidate = true;
    }
    searchFieldElements() {
        const formElements = this.querySelectorAll('input, select, textarea');
        const formElementList = Array.from(formElements);
        const filteredFormElements = formElementList.filter((element)=>!element.disabled);
        filteredFormElements.forEach((element)=>{
            const wrapper = element.closest(this.fieldWrapperSelector);
            wrapper && this.validationList.push({
                element: element,
                wrapper: wrapper,
                messages: $21a7ddce6a8de4e2$export$2e2bcd8739ae039.generateValidityMessages(element)
            });
        });
    }
    registerSubmitListener() {
        if (!this.form) return;
        const onSubmitHandler = this.validateForm.bind(this);
        this.pushListener({
            event: 'submit',
            element: this.form,
            action: onSubmitHandler
        });
    }
    registerPasswordListener() {
        if (!(this.passwordStrengthMeter && this.passwordNewElement && this.passwordRepeatElement)) return;
        const onValidatePassword = this.validatePassword.bind(this);
        this.pushListener({
            event: 'input',
            element: this.passwordNewElement,
            action: onValidatePassword
        });
        this.pushListener({
            event: 'input',
            element: this.passwordRepeatElement,
            action: onValidatePassword
        });
    }
    registerFieldValidationListener() {
        this.validationList.forEach((item)=>{
            const onValidation = this.validateField.bind(this, item);
            this.pushListener({
                event: 'blur',
                element: item.element,
                action: onValidation
            });
            this.pushListener({
                event: 'input',
                element: item.element,
                action: onValidation
            });
        });
    }
    async validateRecaptcha() {
        if (!this.googleRecaptcha) return true;
        return new Promise((resolve)=>{
            window.grecaptcha.ready(async ()=>{
                const siteKey = this.googleRecaptcha.getAttribute('data-tk-site-key');
                if (!siteKey) return resolve(false);
                const token = await window.grecaptcha.execute(siteKey, {
                    action: 'submit'
                });
                if (!token) return resolve(false);
                this.googleRecaptcha.value = token;
                resolve(true);
            });
        });
    }
    async validateZipCity() {
        const validationList = [];
        const fieldElements = this.querySelectorAll('[data-tk-field-check-zip-city]');
        if (fieldElements.length === 0) return true;
        const apiPromises = Array.from(fieldElements).map(async (element)=>{
            const input = element.querySelector('input');
            if (!input) return true;
            const isValid = await (0, $cb17fd7e698c018c$export$2e2bcd8739ae039).isValidZipCity(this.form);
            const validationItem = this.validationList.find((item)=>item.wrapper === element);
            if (!isValid && validationItem) {
                this.removeMessage(validationItem);
                this.createElementMessage(validationItem, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).typeMismatch);
            }
            return isValid;
        });
        const results = await Promise.all(apiPromises);
        validationList.push(...results);
        return validationList.every((item)=>item);
    }
    async validateByAPI() {
        const validationList = [];
        const fieldElements = this.querySelectorAll('[data-tk-field-check-api]');
        if (fieldElements.length === 0) return true;
        const apiPromises = Array.from(fieldElements).map(async (element)=>{
            const apiURL = element.getAttribute('data-tk-field-check-api');
            const input = element.querySelector('input');
            if (!input || !apiURL || input.value === '') return true;
            const response = await $21a7ddce6a8de4e2$export$2e2bcd8739ae039.fetchExistAPI(apiURL, input.value);
            const { isValid: isValid } = response.dataAsJson;
            const validationItem = this.validationList.find((item)=>item.wrapper === element);
            if (!isValid && validationItem) {
                this.removeMessage(validationItem);
                this.createElementMessage(validationItem, (0, $86b3c5b6d66bd808$export$35e6ad2b040b8403).existigName);
            }
            return isValid;
        });
        const results = await Promise.all(apiPromises);
        validationList.push(...results);
        return validationList.every((item)=>item);
    }
    static async fetchExistAPI(url, value) {
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                payload: {
                    value: value
                },
                resolveHandler: (response)=>{
                    resolve(response);
                }
            });
        });
    }
    async validateForm(event) {
        event.preventDefault();
        const isFormValid = await this.isFormValid();
        if (!isFormValid) return;
        if (this.preventEnterDefaultAction) {
            const elemntToClick = document.querySelector(`[${this.preventEnterDefaultAction}]`);
            elemntToClick?.querySelector('button')?.click();
            return;
        }
        this.form?.submit();
    }
    async isFormValid() {
        await this.validateFields();
        const areFieldsValid = this.validationList.every((item)=>item.element.validity.valid);
        if (!areFieldsValid) return false;
        const isValid = await this.validateByAPI() && await this.validateZipCity();
        const isRecaptchaValid = await this.validateRecaptcha();
        return (!this.passwordStrengthMeter || this.checkPasswordStengthMeter()) && this.checkPasswordMatching() && isValid && isRecaptchaValid;
    }
    async validateFields() {
        this.validationList.forEach((item)=>{
            this.validateField(item);
        });
        this.firstElementToScrollTo = undefined;
    }
    validateField(item) {
        this.removeMessage(item);
        if (!item.element.validity.valid) this.showMessage(item);
    }
    showMessage(item) {
        const validityList = $21a7ddce6a8de4e2$export$2e2bcd8739ae039.createValidityDictionary(item.element);
        const invalidMessage = validityList.find((validity)=>validity.value);
        const message = invalidMessage ? item.messages.find((message)=>message.key === invalidMessage.key)?.value || '' : item.element.validationMessage;
        this.createElementMessage(item, message);
    }
    createElementMessage(item, message) {
        const spanElement = document.createElement('span');
        spanElement.classList.add(this.fieldHintClassName);
        spanElement.textContent = $21a7ddce6a8de4e2$export$2e2bcd8739ae039.replacePlaceholders(message, item.element);
        item.messageElement = spanElement;
        item.wrapper.classList.add(this.formErrorClassName);
        item.wrapper.insertAdjacentElement('beforeend', spanElement);
        if (this.firstElementToScrollTo) return;
        this.firstElementToScrollTo = item.messageElement;
        this.firstElementToScrollTo.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
    removeMessage(item) {
        const spanElement = item.messageElement;
        if (!spanElement) return;
        spanElement.remove();
        item.wrapper.classList.remove(this.formErrorClassName);
    }
    static createValidityDictionary(element) {
        const { validity: validity } = element;
        const validityList = [];
        for(const key in validity){
            const validityItem = {
                key: key,
                value: Boolean(validity[key])
            };
            validityList.push(validityItem);
        }
        return validityList;
    }
    static generateValidityMessages(element) {
        const list = [];
        const customErrorPrefix = 'data-tk-error-msg-';
        const attributeList = element.getAttributeNames().filter((name)=>name.startsWith(customErrorPrefix));
        attributeList.forEach((key)=>{
            const keyFormatted = key.replace(customErrorPrefix, '').replace(/-./g, (x)=>x[1].toUpperCase());
            const value = element.getAttribute(key);
            value && list.push({
                key: keyFormatted,
                value: value
            });
        });
        if (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91) {
            const messages = (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91);
            Object.entries(messages).forEach((entry)=>{
                const [key, value] = entry;
                const foundMessage = list.filter((item)=>item.key === key);
                !foundMessage.length && list.push({
                    key: key,
                    value: value
                });
            });
        }
        return list;
    }
    static replacePlaceholders(value, element) {
        const dictionary = {
            '{minLength}': element.getAttribute('minlength') || '',
            '{maxLength}': element.getAttribute('maxlength') || '',
            '{length}': element.value.length.toString() || '',
            '{step}': element.getAttribute('step') || '',
            '{min}': element.getAttribute('min') || '',
            '{max}': element.getAttribute('max') || '',
            '{currentValue}': element.value
        };
        const re = new RegExp(Object.keys(dictionary).join('|'), 'gi');
        return value.replace(re, (matched)=>dictionary[matched]);
    }
    checkPasswordStengthMeter() {
        const patterns = this.getPasswordPatterns();
        return patterns.every((item)=>item.element?.classList.contains(this.passwordValidClassName));
    }
    checkPasswordMatching() {
        let isValid;
        const newPasswordItem = this.validationList.find((item)=>item.element === this.passwordNewElement);
        const repeatPasswordItem = this.validationList.find((item)=>item.element === this.passwordRepeatElement);
        if (!newPasswordItem || !repeatPasswordItem) return true;
        if (newPasswordItem.element.value !== repeatPasswordItem.element.value) {
            this.removeMessage(repeatPasswordItem);
            this.createElementMessage(repeatPasswordItem, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).passwordNotMatching);
            isValid = false;
        } else isValid = true;
        return isValid;
    }
    validatePassword(event) {
        const target = event.currentTarget;
        const patterns = this.getPasswordPatterns();
        patterns.forEach((item)=>{
            const regex = new RegExp(item.pattern || '', item.matchtype === "FULLMATCH" ? 'g' : '');
            const regexpMatch = target.value.match(regex);
            if (item.matchtype === "SOME") {
                if (regexpMatch) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
            if (item.matchtype === "FULLMATCH") {
                if (regexpMatch?.length === target.value.length) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
        });
    }
    getPasswordPatterns() {
        const characterPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-character-pattern]');
        const upperPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-upper-pattern]');
        const numberPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-number-pattern]');
        const allowedSymbolPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-allowed-symbols-pattern]');
        const characterPattern = characterPatternElement?.getAttribute('data-tk-pwd-character-pattern');
        const upperPattern = upperPatternElement?.getAttribute('data-tk-pwd-upper-pattern');
        const numberPattern = numberPatternElement?.getAttribute('data-tk-pwd-number-pattern');
        const allowedSymbolPattern = allowedSymbolPatternElement?.getAttribute('data-tk-pwd-allowed-symbols-pattern');
        return [
            {
                pattern: characterPattern,
                element: characterPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: upperPattern,
                element: upperPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: numberPattern,
                element: numberPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: allowedSymbolPattern,
                element: allowedSymbolPatternElement,
                matchtype: "FULLMATCH"
            }
        ];
    }
}



class $7217ff2f9b2d295c$export$2e2bcd8739ae039 extends (0, $21a7ddce6a8de4e2$export$2e2bcd8739ae039) {
    validateField(item) {
        this.removeMessage(item);
        // Always check email fields first to properly clear/set custom validity
        if (item.element instanceof HTMLInputElement && item.element.type.toLowerCase() === 'email') {
            this.validateEmailField(item);
            return;
        }
        if (!item.element.validity.valid) this.showMessage(item);
    }
    validateEmailField(item) {
        const element = item.element;
        if (!(element instanceof HTMLInputElement) || element.type.toLowerCase() !== 'email') return;
        const value = element.value.trim();
        if (value === '') {
            element.setCustomValidity('');
            return;
        }
        const atIndex = value.indexOf('@');
        const dotIndex = value.lastIndexOf('.');
        const hasValidFormat = atIndex > 0 && dotIndex > atIndex + 1 && dotIndex < value.length - 1;
        if (hasValidFormat) {
            element.setCustomValidity('');
            return;
        }
        const customTypeMismatchMessage = element.getAttribute('data-tk-error-msg-type-mismatch') || '';
        const fallbackMessage = (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).typeMismatch || element.validationMessage;
        const message = customTypeMismatchMessage || fallbackMessage;
        element.setCustomValidity(message);
        this.createElementMessage(item, message);
    }
}





/**
 * data-tk-dialog-jump-forward
 * data-tk-dialog-jump-backward
 * data-tk-dialog-jump-to
 * data-tk-dialog-close
 * data-tk-dialog-close-and-reset
 * data-tk-close-on-backdrop-click
 */ var $2215c02a950e9fbf$var$DialogActions = /*#__PURE__*/ function(DialogActions) {
    DialogActions["JUMP_FORWARD"] = "jump_forward";
    DialogActions["JUMP_BACKWARD"] = "jump_backward";
    DialogActions["JUMP_TO"] = "jump_to";
    DialogActions["RESET_FORM"] = "reset_form";
    return DialogActions;
}($2215c02a950e9fbf$var$DialogActions || {});
class $2215c02a950e9fbf$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.dialogs = [], this.currentDialog = 0, this.shouldOpen = false, this.closeOnBackdropClick = true;
        this.tag = this.getAttribute('data-tk-tag') || 'dialog';
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.button = this.querySelector('button') || undefined;
        this.shouldOpen = this.hasAttribute('data-tk-open');
        this.closeOnBackdropClick = this.hasAttribute('data-tk-close-on-backdrop-click') ? JSON.parse(this.getAttribute('data-tk-close-on-backdrop-click')) : true;
        this.shouldMaxWidth = this.hasAttribute('data-tk-should-max-width');
        this.dialogClassName = this.getAttribute('data-tk-dialog-class-name') || 'tk-dialog';
        this.dialogInnerClassName = this.getAttribute('data-tk-dialog-inner-class-name') || 'tk-dialog__inner';
        this.dialogCloseClassName = this.getAttribute('data-tk-dialog-close-class-name') || 'tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close';
        this.maxWidthClassName = this.getAttribute('data-tk-max-width-class-name') || 'tk-dialog--max-width';
        this.formDataString = this.getAttribute('data-tk-form-data') || undefined;
        this.isPopup = this.hasAttribute('data-tk-is-popup');
        this.isConfirm = this.hasAttribute('data-tk-is-confirm');
        this.confirmTitle = this.getAttribute('data-tk-confirm-title') || undefined;
        this.confirmDescription = this.getAttribute('data-tk-confirm-description') || undefined;
        this.confirmCancelIcon = this.getAttribute('data-tk-confirm-cancel-icon') || 'cross';
        this.confirmCancelLabel = this.getAttribute('data-tk-confirm-cancel-label') || undefined;
        this.confirmSubmitIcon = this.getAttribute('data-tk-confirm-submit-icon') || 'check';
        this.confirmSubmitLabel = this.getAttribute('data-tk-confirm-submit-label') || undefined;
        this.forceReloadContent = this.hasAttribute('data-tk-force-reload-content');
    }
    connectedCallback() {
        if (!this.url) throw new Error('Dialog: URL is missing!');
        this.registerClickListener();
        this.checkAutoOpen();
    }
    registerClickListener() {
        if (!this.button) return;
        const onClick = this.openDialog.bind(this, this.url);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerFormListener(form) {
        const onSubmit = this.handleForm.bind(this, form);
        this.pushListener({
            event: 'submit',
            element: form,
            action: onSubmit
        });
    }
    registerCloseListener() {
        const onClick = this.closeDialog.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: onClick
        });
    }
    createDialog(url) {
        const dialog = $2215c02a950e9fbf$export$2e2bcd8739ae039.renderDialog({
            className: `${this.dialogClassName} ${this.shouldMaxWidth ? this.maxWidthClassName : ''}`,
            closeClassName: this.dialogCloseClassName,
            innerClassName: this.dialogInnerClassName,
            tag: this.tag,
            isConfirm: this.isConfirm,
            confirmURL: url,
            confirmTitle: this.confirmTitle,
            confirmDescription: this.confirmDescription,
            confirmCancelIcon: this.confirmCancelIcon,
            confirmCancelLabel: this.confirmCancelLabel,
            confirmSubmitIcon: this.confirmSubmitIcon,
            confirmSubmitLabel: this.confirmSubmitLabel
        });
        const onClosed = this.closedDialog.bind(this);
        this.pushListener({
            event: 'close',
            element: dialog,
            action: onClosed
        });
        this.currentDialog = this.forceReloadContent ? 0 : this.dialogs.push({
            url: url,
            dialog: dialog
        }) - 1;
        return dialog;
    }
    getContent(url) {
        if (this.isConfirm) {
            this.closeCurrentDialog();
            const dialog = this.createDialog(url);
            $2215c02a950e9fbf$export$2e2bcd8739ae039.open(dialog, this.isPopup);
            this.hookAfterShowModal(dialog);
        } else (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url)
        });
    }
    getContentWithData(url, payload) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: payload
        });
    }
    handleResponseSuccess(url, response) {
        if (!response || !response.success) return;
        this.closeCurrentDialog();
        const dialog = this.createDialog(url);
        const content = dialog.querySelector('[data-tk-dialog-content]');
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(dialog, this.isPopup);
        this.hookAfterShowModal(dialog);
        const form = content.querySelector('form');
        form && this.registerFormListener(form);
    }
    openDialog(url) {
        this.handleUrlAndDialogs(url);
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    closeDialog(event) {
        const dialogItem = this.dialogs.at(this.currentDialog);
        // Used to check if the event isn't triggered by the enter key
        const isRealClickEvent = event.pointerId !== -1;
        if (!dialogItem || !isRealClickEvent) return;
        const { dialog: dialog } = dialogItem;
        if (this.closeOnBackdropClick) $2215c02a950e9fbf$export$2e2bcd8739ae039.closeDialogIfOutside(dialog, event, this.forceReloadContent);
    }
    hookAfterShowModal(dialog) {
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog, this.forceReloadContent));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close-and-reset]', (button)=>this.handleActions("reset_form", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-forward]', (button)=>this.handleActions("jump_forward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-backward]', (button)=>this.handleActions("jump_backward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-to]', (button)=>this.handleActions("jump_to", button));
    }
    static attachButtonClickHandler(dialog, selector, callback) {
        const buttons = dialog.querySelectorAll(selector);
        buttons.forEach((button)=>{
            button.addEventListener('click', ()=>callback(button));
        });
    }
    handleActions(action, button) {
        const handler = {
            jump_forward: ()=>this.forward(button),
            jump_backward: ()=>this.backward(),
            jump_to: ()=>this.jumpTo(button),
            reset_form: ()=>this.resetForm(button)
        };
        handler[action]();
    }
    closeCurrentDialog() {
        const dialogItem = this.dialogs.at(this.currentDialog);
        if (!dialogItem) return;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialogItem.dialog, this.forceReloadContent);
    }
    handleUrlAndDialogs(url) {
        const existsURL = this.dialogs.some((dialogItem)=>dialogItem.url === url);
        if (existsURL) {
            const nextDialog = this.getDialogByURL(url);
            if (!nextDialog) return;
            $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialog);
        } else try {
            const payload = JSON.parse(this.formDataString || '{}');
            Object.keys(payload).length > 0 ? this.getContentWithData(url, payload) : this.getContent(url);
        } catch (error) {
            throw new Error(`Dialog: ${error}`);
        }
    }
    forward(button) {
        // Check if already exists
        const url = button.getAttribute('data-tk-url');
        if (!url) throw new Error('Dialog: URL is missing!');
        this.closeCurrentDialog();
        this.handleUrlAndDialogs(url);
        this.currentDialog += 1;
    }
    backward() {
        const nextDialogItem = this.dialogs.at(this.currentDialog - 1);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialogItem.dialog);
        this.currentDialog -= 1;
    }
    jumpTo(button) {
        const index = Number(button.getAttribute('data-tk-dialog-jump-to'));
        const nextDialogItem = this.dialogs.at(index);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialogItem.dialog);
        this.currentDialog = index;
    }
    resetForm(button) {
        button.form?.reset();
        this.closeCurrentDialog();
    }
    handleForm(form, event) {
        const shouldSwitchToNext = form.hasAttribute('data-tk-switch-to-next');
        if (!shouldSwitchToNext) return;
        event.preventDefault();
        const formData = new FormData(form);
        const url = form.action;
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: formData
        });
    }
    getDialogByURL(url) {
        const dialogItem = this.dialogs.find((item)=>item.url === url);
        return dialogItem?.dialog;
    }
    closedDialog() {
        const allDialogClosed = this.dialogs.every((item)=>!item.dialog.open);
        if (!allDialogClosed) return;
        this.currentDialog = 0;
        this.removeListener(window);
    }
    static renderDialog(options) {
        const { tag: tag, className: className = 'tk-dialog', closeClassName: closeClassName = 'tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close', innerClassName: innerClassName = 'tk-dialog__inner', content: content, isConfirm: isConfirm = false, confirmURL: confirmURL, confirmTitle: confirmTitle, confirmDescription: confirmDescription, confirmCancelIcon: confirmCancelIcon, confirmCancelLabel: confirmCancelLabel, confirmSubmitIcon: confirmSubmitIcon, confirmSubmitLabel: confirmSubmitLabel, forceClosing: forceClosing } = options;
        const dialog = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            ${isConfirm ? `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            <form action="${confirmURL}" method="post">
                                <h3>${confirmTitle}</h3>
                                <p>${confirmDescription}</p>
                                <div class="flex flex--gap-x-2 flex--justify-end spacer-mt-9">
                                    <button type="button" class="tk-button tk-button--secondary" data-tk-dialog-close>
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmCancelIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmCancelLabel}</span>
                                    </button>
                                    <button type="submit" class="tk-button tk-button--primary">
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmSubmitIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmSubmitLabel}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </${tag}>
                ` : `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            ${content}
                        </div>
                    </${tag}>
                `}
        `);
        document.body.insertAdjacentElement('beforeend', dialog);
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog, forceClosing));
        return dialog;
    }
    static open(element, isPopup = false) {
        if (element instanceof HTMLDialogElement) isPopup ? element.show() : element.showModal();
        else element.classList.add('tk-dialog--open');
    }
    static close(element, forceClosing = false) {
        forceClosing && $2215c02a950e9fbf$export$2e2bcd8739ae039.destoryInstances(element);
        if (element instanceof HTMLDialogElement) element.close();
        else {
            element.classList.remove('tk-dialog--open');
            element.dispatchEvent(new Event('close'));
        }
        const contextMenus = element.querySelectorAll('[data-tk-context-menu]');
        contextMenus.forEach((menu)=>menu.close());
        forceClosing && element.remove();
    }
    static closeDialogIfOutside(element, event, forceClosing = false) {
        /**
         * Checking the coordinates of the client for the value 0 and the
         * HTMLSelectElement or HTMLOptionElement element ensures that the
         * dialogue does not close in Mozilla. This is a bug in Firefox
         * that has not yet been fixed.
         */ if (event.clientX === 0 && event.clientY === 0 && (event.target instanceof HTMLSelectElement || event.target instanceof HTMLOptionElement)) return;
        const dialogDimensions = element.getBoundingClientRect();
        if (event.clientX < dialogDimensions.left || event.clientX > dialogDimensions.right || event.clientY < dialogDimensions.top || event.clientY > dialogDimensions.bottom) $2215c02a950e9fbf$export$2e2bcd8739ae039.close(element, forceClosing);
    }
    checkAutoOpen() {
        if (!this.shouldOpen) return;
        this.openDialog(this.url);
    }
    renewDialogContent(dialog, url) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.getRenewDialogContent.bind(this, dialog)
        });
    }
    getRenewDialogContent(openDialog, response) {
        const dialogInner = openDialog.querySelector('[data-tk-dialog-content]');
        dialogInner.innerHTML = response.dataAsHtml;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(openDialog);
        this.hookAfterShowModal(openDialog);
    }
    static destoryInstances(element) {
        const richtexts = element.querySelectorAll('[data-cms-richtext]');
        const datepickers = element.querySelectorAll('[data-tk-form-datepicker]');
        richtexts.forEach((richtext)=>{
            const item = richtext;
            item.editors?.forEach((editor)=>{
                editor.destroy();
            });
        });
        datepickers.forEach((datepicker)=>{
            datepicker.flatpickr?.destroy();
        });
    }
}


class $5a26c1218729bf34$export$2e2bcd8739ae039 extends (0, $2215c02a950e9fbf$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.dialogCloseClassName = this.getAttribute('data-tk-dialog-close-class-name') || 'tk-button tk-button--tertiary tk-button--size-l tk-button--only-icon tk-dialog__close';
    }
}


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;



function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
}


function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? (0, $2835f189066da699$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b49248e188a52b8b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $2835f189066da699$export$2e2bcd8739ae039)(node) || !(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node)) return (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(node);
    else return (0, $c829ab0279467772$export$2e2bcd8739ae039)(node);
}






function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)).left + (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $2835f189066da699$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9873d63ab8539814$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b71097fc0b0e5f5c$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e951d80a0194865c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node) && (0, $9873d63ab8539814$export$2e2bcd8739ae039)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(node));
}





function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c48b941fd834c962$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9873d63ab8539814$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(target)));
}







function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    if (isIE && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element);
    if ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $27c48183f07ddbe8$export$2e2bcd8739ae039)(offsetParent) && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}


var $935c50c8659545b7$export$1e95b668f3b82d = 'top';
var $935c50c8659545b7$export$40e543e69a8b3fbb = 'bottom';
var $935c50c8659545b7$export$79ffe56a765070d2 = 'right';
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = 'left';
var $935c50c8659545b7$export$dfb5619354ba860 = 'auto';
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = 'start';
var $935c50c8659545b7$export$bd5df0f255a350f8 = 'end';
var $935c50c8659545b7$export$390fd549c5303b4d = 'clippingParents';
var $935c50c8659545b7$export$d7b7311ec04a3e8f = 'viewport';
var $935c50c8659545b7$export$ae5ab1c730825774 = 'popper';
var $935c50c8659545b7$export$ca50aac9f3ba507f = 'reference';
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = 'beforeRead';
var $935c50c8659545b7$export$aafa59e2e03f2942 = 'read';
var $935c50c8659545b7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = 'beforeMain';
var $935c50c8659545b7$export$f22da7240b7add18 = 'main';
var $935c50c8659545b7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $935c50c8659545b7$export$68d8715fc104d294 = 'write';
var $935c50c8659545b7$export$70a6e5159acce2e6 = 'afterWrite';
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];


function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $935c50c8659545b7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(reference) ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $455dca0e08f2a815$export$2e2bcd8739ae039)((0, $81912adbd60ec5c0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b01cf64433a5b37b$export$2e2bcd8739ae039)(reference, (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $ad01075005a54bff$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6d2b77c34ff005f5$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};



function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $935c50c8659545b7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $935c50c8659545b7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $935c50c8659545b7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $935c50c8659545b7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $935c50c8659545b7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $935c50c8659545b7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};










var $063d2297888fea12$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var sideY = (0, $935c50c8659545b7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(popper);
            if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || placement === (0, $935c50c8659545b7$export$79ffe56a765070d2)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideY = (0, $935c50c8659545b7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || placement === (0, $935c50c8659545b7$export$40e543e69a8b3fbb)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideX = (0, $935c50c8659545b7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};





function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $935c50c8659545b7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8d644778f0e020f0$var$offset
};


var $d79ddf39683d3f91$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}



var $5887002dcefa0743$var$hash = {
    start: 'end',
    end: 'start'
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}







function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b49248e188a52b8b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6be351e83d6bf643$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) ? (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $7da9d5689cacb0a6$export$2e2bcd8739ae039)(element, strategy)) : (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $ab4ea6dd03061fae$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) ? (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) && (0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)(), paddingObject);
}


function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $935c50c8659545b7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $935c50c8659545b7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? (0, $935c50c8659545b7$export$ca50aac9f3ba507f) : (0, $935c50c8659545b7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $93ee5964b4e9d426$export$2e2bcd8739ae039)((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $1cd357ee33805adc$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $935c50c8659545b7$export$79ffe56a765070d2),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $935c50c8659545b7$export$1e95b668f3b82d),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $935c50c8659545b7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $935c50c8659545b7$export$368f9a87e87fa4e1) : (0, $935c50c8659545b7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $935c50c8659545b7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860) ? (0, $bec6b628c79c2a3d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $935c50c8659545b7$export$79ffe56a765070d2) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(min, (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e82c9e5baaa8e9af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4faf3481d1df2f95$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $935c50c8659545b7$export$1e95b668f3b82d),
        (0, $935c50c8659545b7$export$79ffe56a765070d2),
        (0, $935c50c8659545b7$export$40e543e69a8b3fbb),
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};




var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039),
    (0, $8d644778f0e020f0$export$2e2bcd8739ae039),
    (0, $dabd09962ff7b702$export$2e2bcd8739ae039),
    (0, $4804c92787f86449$export$2e2bcd8739ae039),
    (0, $20e743289f291887$export$2e2bcd8739ae039),
    (0, $7d3d400f3b7c97f3$export$2e2bcd8739ae039)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $c55de979aca75bc6$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $c55de979aca75bc6$var$BOX_CLASS = "tippy-box";
var $c55de979aca75bc6$var$CONTENT_CLASS = "tippy-content";
var $c55de979aca75bc6$var$BACKDROP_CLASS = "tippy-backdrop";
var $c55de979aca75bc6$var$ARROW_CLASS = "tippy-arrow";
var $c55de979aca75bc6$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $c55de979aca75bc6$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $c55de979aca75bc6$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $c55de979aca75bc6$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $c55de979aca75bc6$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $c55de979aca75bc6$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $c55de979aca75bc6$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $c55de979aca75bc6$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $c55de979aca75bc6$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $c55de979aca75bc6$var$normalizeToArray(value) {
    return [].concat(value);
}
function $c55de979aca75bc6$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $c55de979aca75bc6$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $c55de979aca75bc6$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $c55de979aca75bc6$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $c55de979aca75bc6$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $c55de979aca75bc6$var$div() {
    return document.createElement('div');
}
function $c55de979aca75bc6$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $c55de979aca75bc6$var$isType(value, type);
    });
}
function $c55de979aca75bc6$var$isNodeList(value) {
    return $c55de979aca75bc6$var$isType(value, 'NodeList');
}
function $c55de979aca75bc6$var$isMouseEvent(value) {
    return $c55de979aca75bc6$var$isType(value, 'MouseEvent');
}
function $c55de979aca75bc6$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $c55de979aca75bc6$var$getArrayOfElements(value) {
    if ($c55de979aca75bc6$var$isElement(value)) return [
        value
    ];
    if ($c55de979aca75bc6$var$isNodeList(value)) return $c55de979aca75bc6$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $c55de979aca75bc6$var$arrayFrom(document.querySelectorAll(value));
}
function $c55de979aca75bc6$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $c55de979aca75bc6$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $c55de979aca75bc6$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $c55de979aca75bc6$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $c55de979aca75bc6$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $c55de979aca75bc6$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $c55de979aca75bc6$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $c55de979aca75bc6$var$currentInput = {
    isTouch: false
};
var $c55de979aca75bc6$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $c55de979aca75bc6$var$onDocumentTouchStart() {
    if ($c55de979aca75bc6$var$currentInput.isTouch) return;
    $c55de979aca75bc6$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $c55de979aca75bc6$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $c55de979aca75bc6$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $c55de979aca75bc6$var$lastMouseMoveTime < 20) {
        $c55de979aca75bc6$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $c55de979aca75bc6$var$onDocumentMouseMove);
    }
    $c55de979aca75bc6$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $c55de979aca75bc6$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($c55de979aca75bc6$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $c55de979aca75bc6$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $c55de979aca75bc6$var$onDocumentTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $c55de979aca75bc6$var$onWindowBlur);
}
var $c55de979aca75bc6$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $c55de979aca75bc6$var$isIE11 = $c55de979aca75bc6$var$isBrowser ? !!window.msCrypto : false;
function $c55de979aca75bc6$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $c55de979aca75bc6$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $c55de979aca75bc6$var$getDevMessage(message) {
    return $c55de979aca75bc6$var$clean("\n  %ctippy.js\n\n  %c" + $c55de979aca75bc6$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $c55de979aca75bc6$var$getFormattedMessage(message) {
    return [
        $c55de979aca75bc6$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $c55de979aca75bc6$var$visitedMessages;
function $c55de979aca75bc6$var$resetVisitedMessages() {
    $c55de979aca75bc6$var$visitedMessages = new Set();
}
function $c55de979aca75bc6$var$warnWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$errorWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console2;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $c55de979aca75bc6$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $c55de979aca75bc6$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $c55de979aca75bc6$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $c55de979aca75bc6$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $c55de979aca75bc6$var$defaultProps = Object.assign({
    appendTo: $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $c55de979aca75bc6$var$pluginProps, $c55de979aca75bc6$var$renderProps);
var $c55de979aca75bc6$var$defaultKeys = Object.keys($c55de979aca75bc6$var$defaultProps);
var $c55de979aca75bc6$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $c55de979aca75bc6$var$defaultProps[key] = partialProps[key];
    });
};
function $c55de979aca75bc6$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $c55de979aca75bc6$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $c55de979aca75bc6$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($c55de979aca75bc6$var$getExtendedPassedProps(Object.assign({}, $c55de979aca75bc6$var$defaultProps, {
        plugins: plugins
    }))) : $c55de979aca75bc6$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $c55de979aca75bc6$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $c55de979aca75bc6$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $c55de979aca75bc6$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $c55de979aca75bc6$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $c55de979aca75bc6$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $c55de979aca75bc6$var$removeProperties($c55de979aca75bc6$var$defaultProps, Object.keys($c55de979aca75bc6$var$pluginProps));
        var didPassUnknownProp = !$c55de979aca75bc6$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $c55de979aca75bc6$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $c55de979aca75bc6$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $c55de979aca75bc6$var$dangerouslySetInnerHTML(element, html) {
    element[$c55de979aca75bc6$var$innerHTML()] = html;
}
function $c55de979aca75bc6$var$createArrowElement(value) {
    var arrow = $c55de979aca75bc6$var$div();
    if (value === true) arrow.className = $c55de979aca75bc6$var$ARROW_CLASS;
    else {
        arrow.className = $c55de979aca75bc6$var$SVG_ARROW_CLASS;
        if ($c55de979aca75bc6$var$isElement(value)) arrow.appendChild(value);
        else $c55de979aca75bc6$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $c55de979aca75bc6$var$setContent(content, props) {
    if ($c55de979aca75bc6$var$isElement(props.content)) {
        $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $c55de979aca75bc6$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $c55de979aca75bc6$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$ARROW_CLASS) || node.classList.contains($c55de979aca75bc6$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$BACKDROP_CLASS);
        })
    };
}
function $c55de979aca75bc6$var$render(instance) {
    var popper = $c55de979aca75bc6$var$div();
    var box = $c55de979aca75bc6$var$div();
    box.className = $c55de979aca75bc6$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $c55de979aca75bc6$var$div();
    content.className = $c55de979aca75bc6$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $c55de979aca75bc6$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $c55de979aca75bc6$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $c55de979aca75bc6$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$c55de979aca75bc6$var$render.$$tippy = true;
var $c55de979aca75bc6$var$idCounter = 1;
var $c55de979aca75bc6$var$mouseMoveListeners = []; // Used by `hideAll()`
var $c55de979aca75bc6$var$mountedInstances = [];
function $c55de979aca75bc6$var$createTippy(reference, passedProps) {
    var props = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, $c55de979aca75bc6$var$defaultProps, $c55de979aca75bc6$var$getExtendedPassedProps($c55de979aca75bc6$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $c55de979aca75bc6$var$idCounter++;
    var popperInstance = null;
    var plugins = $c55de979aca75bc6$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $c55de979aca75bc6$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $c55de979aca75bc6$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $c55de979aca75bc6$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $c55de979aca75bc6$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $c55de979aca75bc6$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $c55de979aca75bc6$var$mouseMoveListeners = $c55de979aca75bc6$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($c55de979aca75bc6$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $c55de979aca75bc6$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $c55de979aca75bc6$var$actualContains(el, actualTarget);
        })) {
            if ($c55de979aca75bc6$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $c55de979aca75bc6$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $c55de979aca75bc6$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $c55de979aca75bc6$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $c55de979aca75bc6$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($c55de979aca75bc6$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $c55de979aca75bc6$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $c55de979aca75bc6$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $c55de979aca75bc6$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $c55de979aca75bc6$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $98a9ef6d31ff03cd$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $c55de979aca75bc6$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $c55de979aca75bc6$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($c55de979aca75bc6$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, prevProps, $c55de979aca75bc6$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $c55de979aca75bc6$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $c55de979aca75bc6$var$currentInput.isTouch && !instance.props.touch;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 0, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $c55de979aca75bc6$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $c55de979aca75bc6$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 1, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $c55de979aca75bc6$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $c55de979aca75bc6$var$mountedInstances = $c55de979aca75bc6$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $c55de979aca75bc6$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $c55de979aca75bc6$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $c55de979aca75bc6$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $c55de979aca75bc6$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $c55de979aca75bc6$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $c55de979aca75bc6$var$isElement(targets) ? instances[0] : instances;
}
$c55de979aca75bc6$var$tippy.defaultProps = $c55de979aca75bc6$var$defaultProps;
$c55de979aca75bc6$var$tippy.setDefaultProps = $c55de979aca75bc6$var$setDefaultProps;
$c55de979aca75bc6$var$tippy.currentInput = $c55de979aca75bc6$var$currentInput;
var $c55de979aca75bc6$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $c55de979aca75bc6$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $c55de979aca75bc6$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $c55de979aca75bc6$var$applyStylesModifier = Object.assign({}, (0, $312913fa2edc14b2$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $c55de979aca75bc6$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $c55de979aca75bc6$var$tippy($c55de979aca75bc6$var$div(), Object.assign({}, $c55de979aca75bc6$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $c55de979aca75bc6$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $c55de979aca75bc6$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $c55de979aca75bc6$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $c55de979aca75bc6$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $c55de979aca75bc6$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $c55de979aca75bc6$var$tippy(targets, parentProps);
    var normalizedReturnValue = $c55de979aca75bc6$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $c55de979aca75bc6$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($c55de979aca75bc6$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $c55de979aca75bc6$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $c55de979aca75bc6$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $c55de979aca75bc6$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $c55de979aca75bc6$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $c55de979aca75bc6$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $c55de979aca75bc6$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $c55de979aca75bc6$var$createBackdropElement() {
    var backdrop = $c55de979aca75bc6$var$div();
    backdrop.className = $c55de979aca75bc6$var$BACKDROP_CLASS;
    $c55de979aca75bc6$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $c55de979aca75bc6$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $c55de979aca75bc6$var$activeInstances = [];
function $c55de979aca75bc6$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $c55de979aca75bc6$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $c55de979aca75bc6$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $c55de979aca75bc6$var$storeMouseCoords);
}
function $c55de979aca75bc6$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $c55de979aca75bc6$var$storeMouseCoords);
}
var $c55de979aca75bc6$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $c55de979aca75bc6$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $c55de979aca75bc6$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $c55de979aca75bc6$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $c55de979aca75bc6$var$activeInstances = $c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $c55de979aca75bc6$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($c55de979aca75bc6$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) $c55de979aca75bc6$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $c55de979aca75bc6$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $c55de979aca75bc6$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $c55de979aca75bc6$var$getInlineBoundingClientRect($c55de979aca75bc6$var$getBasePlacement(placement), reference.getBoundingClientRect(), $c55de979aca75bc6$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($c55de979aca75bc6$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) {
                    var rects = $c55de979aca75bc6$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $c55de979aca75bc6$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $c55de979aca75bc6$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $c55de979aca75bc6$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $c55de979aca75bc6$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $c55de979aca75bc6$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$c55de979aca75bc6$var$tippy.setDefaultProps({
    render: $c55de979aca75bc6$var$render
});
var $c55de979aca75bc6$export$2e2bcd8739ae039 = $c55de979aca75bc6$var$tippy;



class $b4b8cee06c4cfcc8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorTooltipContent = 'data-tk-tooltip-content', this.selectorTooltipOptions = 'data-tk-tooltip-options';
        this.tooltipContent = this.getAttribute(this.selectorTooltipContent) || undefined;
        this.customOptions = this.getAttribute(this.selectorTooltipOptions) || '{}';
        if (!this.tooltipContent) throw new Error('TK: Missing tooltip content');
    }
    connectedCallback() {
        this.initTooltip();
    }
    initTooltip() {
        this.customOptions = this.customOptions.replace(/'/g, '"');
        const tooltipOptions = {
            content: this.tooltipContent,
            ...this.defaultTooltipOptions(),
            ...JSON.parse(this.customOptions)
        };
        (0, $c55de979aca75bc6$export$2e2bcd8739ae039)(this, tooltipOptions);
    }
    defaultTooltipOptions() {
        return {
            arrow: false,
            theme: 'tk-tooltip',
            allowHTML: true,
            offset: [
                0,
                8
            ]
        };
    }
}





function $7e8cc8975b3fe464$export$60d21ef256fe91e0(point, rectangle, offset) {
    return point.x < rectangle.left + (offset?.left || 0) || point.x > rectangle.right + (offset?.right || 0) || point.y < rectangle.top + (offset?.top || 0) || point.y > rectangle.bottom + (offset?.bottom || 0);
}
function $7e8cc8975b3fe464$export$dcbd32acb1a13bc6(event, rectangles) {
    const point = {
        x: event.clientX,
        y: event.clientY
    };
    return rectangles.every((item)=>$7e8cc8975b3fe464$export$60d21ef256fe91e0(point, item.rectangle, item.offset));
}


class $68266fef2d1934e5$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.focusHistory = [], this.allowedToClickBasketButton = true;
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.fieldElement = this.querySelector('input') || undefined;
        this.resetButton = this.querySelector('[data-tk-quick-order-reset]') || undefined;
        this.submitButton = this.querySelector('[data-tk-quick-order-submit]') || undefined;
        this.resultElement = this.querySelector('[data-tk-quick-order-result]') || undefined;
        this.backButton = this.querySelector('[data-tk-quick-order-back]') || undefined;
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-search--active';
        this.hasDataClassName = this.getAttribute('data-tk-has-data-class-name') || 'tk-search--has-data';
        this.loadingClassName = this.getAttribute('data-tk-loading-class-name') || 'tk-search--loading';
        this.chooseKeybind = this.getAttribute('data-tk-choose-keybind') || 'Enter';
        this.navigateUpKeybind = this.getAttribute('data-tk-navigate-up-keybind') || 'ArrowUp';
        this.navigateDownKeybind = this.getAttribute('data-tk-navigate-down-keybind') || 'ArrowDown';
        this.closeKeybind = this.getAttribute('data-tk-close-keybind') || 'Escape';
        this.keybinds = [
            {
                keybind: this.closeKeybind,
                action: ()=>this.hideDropdown()
            },
            {
                keybind: this.navigateUpKeybind,
                action: ()=>this.focusNextElement(true)
            },
            {
                keybind: this.navigateDownKeybind,
                action: ()=>this.focusNextElement()
            },
            {
                keybind: this.chooseKeybind,
                action: ()=>this.clickBasketButton()
            }
        ];
    }
    connectedCallback() {
        if (!this.url || !this.fieldElement || !this.resetButton || !this.submitButton || !this.resultElement || !this.backButton) throw new Error('TKQuickOrder: Elements are missing!');
        this.registerClickListener();
        this.registerFocusInListener();
        this.registerFocusOutListener();
        this.registerFocusListener();
        this.registerInputListener();
        this.registerKeybindListener();
    }
    registerClickListener() {
        const onClick = this.goBack.bind(this);
        this.pushListener({
            event: 'click',
            element: this.backButton,
            action: onClick
        });
    }
    registerFocusInListener() {
        const onFocusIn = this.showDropdown.bind(this);
        this.pushListener({
            event: 'focusin',
            element: this.fieldElement,
            action: onFocusIn
        });
    }
    registerFocusOutListener() {
        const onFocusOut = this.focusOut.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: onFocusOut
        });
    }
    registerFocusListener() {
        const onFocus = this.focusFieldElement.bind(this);
        this.pushListener({
            event: 'focus',
            element: this.fieldElement,
            action: onFocus
        });
    }
    registerInputListener() {
        const onInput = this.search.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: onInput
        });
    }
    registerKeybindListener() {
        const onPress = this.handleKeybinds.bind(this);
        this.pushListener({
            event: 'keydown',
            element: this,
            action: onPress
        });
    }
    prepareKeybinds() {
        const keybindMap = new Map();
        this.keybinds.forEach((item)=>{
            if (!keybindMap.has(item.keybind)) keybindMap.set(item.keybind, [
                item.action
            ]);
            else keybindMap.get(item.keybind)?.push(item.action);
        });
        return keybindMap;
    }
    distinctKeybinds() {
        const distinctList = new Set(this.keybinds.map((item)=>item.keybind));
        return this.keybinds.length === distinctList.size;
    }
    goBack() {
        this.fieldElement.value = '';
        this.resultElement.innerHTML = '';
        this.hideDropdown();
    }
    showDropdown() {
        this.classList.add(this.activeClassName);
    }
    hideDropdown() {
        this.fieldElement.value = '';
        this.resultElement.innerHTML = '';
        this.classList.remove(this.activeClassName);
        this.classList.remove(this.hasDataClassName);
    }
    focusOut(event) {
        if (!this.fieldElement || !this.resultElement) return;
        if (event.clientX === 0 && event.clientY === 0 && (event.target instanceof HTMLSelectElement || event.target instanceof HTMLOptionElement || event.target.hasAttribute('data-tk-basket-button'))) return;
        const fieldElementRect = this.fieldElement.getBoundingClientRect();
        const resultRect = this.resultElement.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: fieldElementRect
            },
            {
                rectangle: resultRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) this.hideDropdown();
    }
    handleKeybinds(event) {
        const keybindMap = this.prepareKeybinds();
        if (!keybindMap.has(event.key)) return;
        event.preventDefault();
        keybindMap.get(event.key)?.forEach((item)=>item());
    }
    focusFieldElement() {
        this.focusHistory = [];
    }
    focusNextElement(reverse = false) {
        const childList = Array.from(this.resultElement.children);
        const lastEntry = this.focusHistory.at(-1);
        let index = 0;
        if (lastEntry) index = reverse ? lastEntry.index - 1 : lastEntry.index + 1;
        const nextChild = childList.at(index);
        const nextChildInput = nextChild?.querySelector('[data-tk-input-quantity]');
        if (!nextChild) return;
        nextChildInput?.focus();
        nextChildInput?.select();
        this.focusHistory.push({
            element: nextChild,
            index: index
        });
    }
    getCurrentElement() {
        const { activeElement: activeElement } = document;
        if (!activeElement) return;
        const closestElement = activeElement.closest('[data-tk-quick-order-tile]');
        let currentElement;
        if (activeElement.hasAttribute('data-tk-quick-order-tile')) currentElement = activeElement;
        else if (closestElement) currentElement = closestElement;
        else {
            const firstChild = this.resultElement?.querySelector('[data-tk-quick-order-tile]');
            if (!firstChild) return;
            currentElement = firstChild;
        }
        return currentElement;
    }
    clickBasketButton() {
        if (!(this.allowedToClickBasketButton || this.distinctKeybinds())) return;
        const articleElement = this.getCurrentElement();
        if (!articleElement) return;
        const basketButton = articleElement.querySelector('tk-basket-button [data-tk-basket-button]');
        if (basketButton) basketButton.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true
        }));
    }
    focusQuantity() {
        const articleElement = this.getCurrentElement();
        if (!articleElement) return;
        const fieldElements = articleElement.querySelectorAll('[data-tk-dimension]:not([hidden]) [data-tk-input-quantity]');
        const currentIndex = Array.from(fieldElements).findIndex((input)=>input === document.activeElement);
        if (currentIndex !== -1) {
            const nextIndex = currentIndex + 1;
            if (nextIndex < fieldElements.length) {
                const nextFieldElement = fieldElements.item(nextIndex);
                nextFieldElement.select();
                this.allowedToClickBasketButton = false;
                return;
            }
        } else {
            fieldElements.item(0).select();
            this.allowedToClickBasketButton = false;
            return;
        }
        this.allowedToClickBasketButton = true;
    }
    search() {
        this.showDropdown();
        const { value: value } = this.fieldElement;
        if (value.length < 3) {
            this.classList.remove(this.activeClassName);
            this.classList.remove(this.hasDataClassName);
            this.classList.remove(this.loadingClassName);
            this.timerId && clearTimeout(this.timerId);
            return;
        }
        this.classList.add(this.loadingClassName);
        this.timerId && clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            const data = {
                value: value
            };
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: this.url,
                resolveHandler: this.renderResult.bind(this),
                payload: data
            });
        }, 500);
    }
    renderResult(response) {
        if (!response || !response.success) return;
        this.classList.remove(this.loadingClassName);
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.resultElement.innerHTML = '';
        this.resultElement.insertAdjacentHTML('afterbegin', html.innerHTML);
        html.childElementCount > 0 && this.classList.add(this.hasDataClassName);
        // Add tabindex="-1" to basket button to skip focus and navigate directly to next input field.
        const basketButtons = this.resultElement.querySelectorAll('[data-tk-basket-button]');
        basketButtons.forEach((btn)=>btn.setAttribute('tabindex', '-1'));
    }
}




class $d9484b764f1a944d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buttons = this.querySelectorAll('[data-tk-context-button]');
        this.items = this.querySelector('[data-tk-context-items]') || undefined;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'tk-context-menu--open';
        this.responsiveClassName = this.getAttribute('data-tk-responsive-class-name') || 'tk-context-menu--responsive';
        this.dropDownClassName = this.getAttribute('data-tk-dropdown-class-name') || 'tk-context-menu__dropdown';
        this.showAlways = this.hasAttribute('data-tk-show-always');
        this.disableScrolldownBreakpoint = this.getAttribute('data-tk-disable-scrolldown-breakpoint') || 's';
        this.minWidthBreakpoint = window.viewport.breakpoints.get(this.disableScrolldownBreakpoint) || 0;
        this.offset = Number(this.getAttribute('data-tk-context-offset')) || 4;
        this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
        this.eventListeners = new Map();
    }
    subscribe(eventName, callback) {
        if (!this.eventListeners.has(eventName)) this.eventListeners.set(eventName, []);
        this.eventListeners.get(eventName).push(callback);
    }
    unsubscribe(eventName, callback) {
        const listeners = this.eventListeners.get(eventName);
        if (!listeners) return;
        this.eventListeners.set(eventName, listeners.filter((listener)=>listener !== callback));
    }
    emit(eventName, data) {
        const listeners = this.eventListeners.get(eventName);
        if (!listeners) return;
        listeners.forEach((callback)=>callback(data));
    }
    connectedCallback() {
        if (this.buttons.length === 0 || !this.items) throw new Error('Context Menu: Elements are missing!');
        this.registerViewportListener();
        (window.viewport.clientWidth < this.minWidthBreakpoint || this.showAlways) && this.switchToMobile();
        this.registerClickListener();
        this.emit('READY');
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
        this.emit('ENDED');
    }
    registerClickListener() {
        const onClick = this.open.bind(this);
        this.buttons.forEach((button)=>{
            this.pushListener({
                event: 'click',
                element: button,
                action: onClick
            });
        });
    }
    registerCloseListener() {
        const handleClose = this.handleClose.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleResize(entries) {
        entries.forEach(()=>{
            if (!this.copiedItems) return;
            this.setPosition(this.copiedItems);
            const width = this.copiedItems.offsetWidth;
            const height = this.copiedItems.offsetHeight;
            this.emit('RESIZED', {
                width: width,
                height: height
            });
        });
    }
    handleViewportResize(event) {
        event.detail.width < this.minWidthBreakpoint || this.showAlways ? this.switchToMobile() : this.switchToDesktop();
    }
    getVisibleButton(visibility) {
        const buttonList = Array.from(this.buttons);
        return buttonList.find((button)=>visibility === button.checkVisibility());
    }
    switchToDesktop() {
        const button = this.getVisibleButton(true);
        if (!button) return;
        button.hidden = true;
        this.classList.remove(this.responsiveClassName);
    }
    switchToMobile() {
        const button = this.getVisibleButton(false);
        if (!button) return;
        button.hidden = false;
        this.classList.add(this.responsiveClassName);
    }
    copyItemsIfNotExists() {
        const copiedItems = this.items.cloneNode(true);
        copiedItems.classList.add(this.dropDownClassName);
        this.copiedItems = copiedItems;
        document.body.insertAdjacentElement('beforeend', copiedItems);
        this.emit('COPIED');
    }
    open() {
        !this.copiedItems && this.copyItemsIfNotExists();
        if (!this.copiedItems) return;
        this.setPosition(this.copiedItems);
        this.resizeObserver.observe(document.body);
        setTimeout(()=>{
            this.registerCloseListener();
        }, 0);
        this.emit('OPENED', {
            target: this.copiedItems
        });
    }
    setPosition(element) {
        const button = this.getVisibleButton(true);
        if (!button) return;
        element.classList.add(this.openClassName);
        const { top: top, height: height, left: left, right: right } = button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        const rightPosition = right + window.scrollX;
        element.style.top = `${top + height + window.scrollY + this.offset}px`;
        if (window.innerWidth <= element.clientWidth + leftPosition) element.style.left = `${rightPosition - element.clientWidth}px`;
        else element.style.left = `${leftPosition}px`;
    }
    handleClose(event) {
        const button = this.getVisibleButton(true);
        if (!this.copiedItems || !button) return;
        const buttonRect = button.getBoundingClientRect();
        const dropdownRect = this.copiedItems.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: buttonRect
            },
            {
                rectangle: dropdownRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) this.close();
    }
    close() {
        if (!this.copiedItems) return;
        this.copiedItems.classList.remove(this.openClassName);
        this.removeListener(window);
        this.resizeObserver.unobserve(document.body);
        this.emit('CLOSED');
    }
}





class $68fa613ad09d90db$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.cursor = this.getAttribute('data-tk-cursor') || 'pointer';
    }
    connectedCallback() {
        this.style.cursor = this.cursor;
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.copy.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: onClick
        });
    }
    async copy() {
        try {
            await navigator.clipboard.writeText(this.textContent || '');
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$39227038979f1988).messageClipboard.text);
        } catch (error) {
            console.error('Error when copying to the clipboard:', error);
        }
    }
}



class $9cc5e30d1bc8a0e8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.viewportElement = this.closest('[data-tk-viewport]') || undefined;
    }
    connectedCallback() {
        if (!this.viewportElement) throw new Error('Status Console: Missing Viewport Element!');
        this.resize();
        this.registerViewportListener();
    }
    registerViewportListener() {
        const onResize = this.resize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: this.viewportElement,
            action: onResize
        });
    }
    resize() {
        document.documentElement.style.setProperty('--offset-top', `${this.clientHeight}px`);
    }
}




class $d3f5c18545e5cabd$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.queue = [], this.activeRequests = 0;
        this.maxConcurrentRequests = Number(this.getAttribute('data-tk-max-concurrent') || 3);
    }
    async addRequest(params) {
        return new Promise((resolve, reject)=>{
            const requestItem = {
                ...params,
                resolveHandler: (data)=>{
                    params.resolveHandler(data);
                    resolve();
                },
                rejectHandler: (error)=>{
                    params.rejectHandler?.(error);
                    reject(error);
                }
            };
            this.queue.push(requestItem);
            this.processQueue();
        });
    }
    async processQueue() {
        if (this.activeRequests >= this.maxConcurrentRequests || this.queue.length === 0) return;
        const request = this.queue.shift();
        this.activeRequests += 1;
        try {
            await (0, $1653b55d89a7adce$export$d5a8517da06db2d)(request);
        } finally{
            this.activeRequests -= 1;
            this.processQueue();
        }
    }
}





const $b314948e6a7c6950$var$isValidJSON = (value)=>{
    try {
        const json = JSON.parse(value);
        return {
            isValid: true,
            json: json
        };
    } catch  {
        return {
            isValid: false
        };
    }
};
var $b314948e6a7c6950$export$2e2bcd8739ae039 = $b314948e6a7c6950$var$isValidJSON;


const $3507ba4caf4aa34e$var$parseBooleanOrString = (value)=>{
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
};
var $3507ba4caf4aa34e$export$2e2bcd8739ae039 = $3507ba4caf4aa34e$var$parseBooleanOrString;


const $bf3fdf42d85858f4$var$toSnakeCase = (input)=>input.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
var $bf3fdf42d85858f4$export$2e2bcd8739ae039 = $bf3fdf42d85858f4$var$toSnakeCase;


class $0efda1b115753384$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.hasItems = false, this.attributeList = [];
        this.trackerElement = this.closest('[data-tk-tracker-wrapper]') || undefined;
        this.event = this.getAttribute('data-tk-event') || undefined;
        this.isAsync = this.hasAttribute('data-tk-is-async');
        this.asyncAttributesURL = this.getAttribute('data-tk-async-attributes-url') || undefined;
        this.trackerType = this.getAttribute('data-tk-tracker-type') || undefined;
        this.hasItems = this.hasAttribute('data-tk-has-items');
        this.itemsKey = this.getDataAttribute('has-items', 'items');
        this.location = window.location.href;
    }
    async connectedCallback() {
        if (!this.trackerElement) throw new Error('Tracker Element is missing!');
        if (!this.event) throw new Error('Event is not defined');
        if (this.isAsync) this.init();
        else this.pushListener({
            event: 'tk-tracker-ready',
            element: this.trackerElement,
            action: this.init.bind(this)
        });
    }
    async init() {
        this.attributeList = this.extractAttributesFrom(this);
        if (this.hasItems) this.collectItemAttributes();
        await this.getAsyncAttributes();
        this.pushTracker();
    }
    extractAttributesFrom(element) {
        return Object.keys(element.dataset).filter((key)=>!key.startsWith('tk')).map((key)=>this.createAttribute(key, element.dataset[key])).filter(Boolean);
    }
    createAttribute(key, value) {
        const result = (0, $b314948e6a7c6950$export$2e2bcd8739ae039)(value);
        return {
            key: key,
            value: result.isValid ? result.json : (0, $3507ba4caf4aa34e$export$2e2bcd8739ae039)(value)
        };
    }
    collectItemAttributes() {
        const items = Array.from(this.querySelectorAll('[data-tk-item]'));
        const itemAttributes = items.map((item)=>this.extractAttributesFrom(item)).map(this.mapToSnakeCase);
        this.attributeList.push({
            key: this.itemsKey,
            value: itemAttributes
        });
    }
    mapToSnakeCase(attributes) {
        return attributes.reduce((acc, attr)=>{
            const key = (0, $bf3fdf42d85858f4$export$2e2bcd8739ae039)(attr.key);
            // Wenn der Wert ein Array ist, konvertiere ihn in einen String (z.B. JSON.stringify)
            if (Array.isArray(attr.value)) acc[key] = JSON.stringify(attr.value);
            else acc[key] = attr.value;
            return acc;
        }, {});
    }
    async getAsyncAttributes() {
        if (!this.asyncAttributesURL) return;
        await (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncAttributesURL,
            resolveHandler: this.handleAsyncAttributes.bind(this)
        });
    }
    handleAsyncAttributes(response) {
        Object.entries(response.dataAsJson.attributes).forEach(([key, value])=>{
            this.attributeList.push({
                key: value,
                value: response.dataAsJson[key]
            });
        });
    }
    pushTracker() {
        const item = {
            event: this.event,
            location: this.location,
            ...this.attributeList.reduce((acc, attr)=>{
                const key = (0, $bf3fdf42d85858f4$export$2e2bcd8739ae039)(attr.key);
                acc[key] = attr.value;
                return acc;
            }, {})
        };
        this.trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                trackerType: this.trackerType,
                item: item
            }
        }));
    }
}






class $edcef81612fbf4b7$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector('[data-tk-static-content-edit]') || undefined;
        this.target = this.getAttribute('data-tk-target') || '#tk-static-content-editor';
        this.boId = this.getAttribute('data-tk-bo-id') || undefined;
        this.boNumber = this.getAttribute('data-tk-bo-number') || undefined;
        this.artTextNumber = this.getAttribute('data-tk-art-text-number') || undefined;
        this.bo = this.getAttribute('data-tk-bo') || undefined;
        this.attr = this.getAttribute('data-tk-attr') || undefined;
        this.itemId = this.getAttribute('data-tk-id') || undefined;
        this.langNumber = this.getAttribute('data-tk-lang-number') || undefined;
        this.dataPer = this.getAttribute('data-tk-data-per') || undefined;
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || undefined;
        this.urlTemplate = [];
        this.templateContentPromiseArray = [];
        this.templatesLoaded = false;
        this.fileUploadIFrameURL = this.getAttribute('data-tk-file-upload-iframe-url') || '';
    }
    async connectedCallback() {
        if (!this.button || !this.boId || !this.dataPer || !this.asyncTemplate) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        await (parcelRequire("cnCS2"));
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.sendAjaxRequest.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerModalListener(modal) {
        const saveButton = modal.querySelector('[data-tk-static-content-save]') || undefined;
        const onSave = this.save.bind(this, saveButton);
        saveButton && this.pushListener({
            event: 'click',
            element: saveButton,
            action: onSave
        });
        const cancelButton = modal.querySelector('[data-tk-static-content-cancel]');
        const onCancel = this.cancel.bind(this);
        cancelButton && this.pushListener({
            event: 'click',
            element: cancelButton,
            action: onCancel
        });
    }
    sendAjaxRequest() {
        this.requestData = {
            type: 'staticcontent',
            boid: this.boId,
            bonumber: this.boNumber,
            arttextno: this.artTextNumber,
            per: this.dataPer,
            template: this.asyncTemplate,
            modalid: this.target,
            bo: this.bo,
            id: this.itemId,
            attr: this.attr
        };
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.showContentInEditMode.bind(this),
            payload: this.requestData
        });
    }
    save(button) {
        if (!button) return;
        const htmlEncoded = $edcef81612fbf4b7$export$2e2bcd8739ae039.htmlEncode($edcef81612fbf4b7$export$2e2bcd8739ae039.getContentFromEditMode());
        this.requestData = {
            type: 'staticcontent',
            boid: this.boId,
            bonumber: this.boNumber,
            arttextno: this.artTextNumber,
            bo: this.bo,
            id: this.itemId,
            attr: this.attr,
            html: htmlEncoded
        };
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshContent.bind(this),
            payload: this.requestData
        });
        this.cancel();
    }
    cancel() {
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).close(this.dialog);
    }
    showContentInEditMode(response) {
        if (!response.success || !this.requestData) return;
        this.dialog = (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).renderDialog({
            content: response.dataAsHtml,
            className: 'tk-dialog tk-dialog--fullscreen',
            tag: 'div'
        });
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).open(this.dialog);
        this.pushListener({
            event: 'close',
            element: this.dialog,
            action: ()=>this.dialog?.remove()
        });
        this.initEditor();
        const modal = document.querySelector(this.target);
        if (!modal) return;
        this.registerModalListener(modal);
    }
    static getContentFromEditMode() {
        return window.tinymce.activeEditor?.getContent({
            format: 'raw'
        }) || '';
    }
    refreshContent(response) {
        if (!response.success || !this.requestData) return;
        let contentContainer = document.getElementById(`staticcontent-${this.requestData.boid}-${this.requestData.arttextno}`);
        if (!contentContainer) this.requestData.id !== undefined && (contentContainer = document.getElementById(this.requestData.id));
        else contentContainer.innerHTML = response.dataAsHtml;
    }
    initEditor() {
        if (!this.requestData) return;
        const selector = `${this.requestData.modalid} [data-tk-static-content-textarea]`;
        // Editor must be removed before initialisation
        window.tinymce.remove(selector);
        const options = {
            selector: selector,
            language: $edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage(),
            plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'pagebreak',
                'searchreplace',
                'wordcount',
                'visualblocks',
                'visualchars',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'nonbreaking',
                'save',
                'table',
                'directionality',
                'emoticons',
                'template',
                'quickbars'
            ],
            insertdatetime_formats: [
                '%d.%m.%Y',
                '%H:%M'
            ],
            contextmenu: 'link image table',
            tools: 'inserttable',
            toolbar: "undo redo | styles | bold italic | forecolor backcolor | alignleft aligncenteralignright alignjustify | bullist numlist outdent indent | image media link | preview print | filemanager",
            width: '100%',
            base_url: '/webportal/config/layout/themes/tk/vendor/tinymce/',
            language_url: `/webportal/config/layout/themes/tk/translations/tinymce/${$edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage()}.js`,
            promotion: false,
            content_css: [
                'default',
                `/webportal/config/layout/themes/project/generated/staticcontent.css?${new Date().getTime()}`
            ],
            templates: this.urlTemplate,
            extended_valid_elements: 'tk-tabs-accordion,tk-tabs-accordion[class],i[data-tk-accordion-icon]',
            custom_elements: 'tk-tabs-accordion,tk-tabs-accordion',
            setup: (editor)=>{
                editor.on('SaveContent', (event)=>{
                    event.content = $edcef81612fbf4b7$export$2e2bcd8739ae039.htmlEncode($edcef81612fbf4b7$export$2e2bcd8739ae039.htmlDecode(event.content));
                });
                const openmanager = ()=>{
                    editor.windowManager.openUrl({
                        title: 'File Manager',
                        url: $edcef81612fbf4b7$export$2e2bcd8739ae039.getFileManagerURL(editor),
                        width: 900,
                        height: 440
                    });
                };
                editor.ui.registry.addButton('filemanager', {
                    icon: 'browse',
                    tooltip: 'Insert file',
                    onAction: openmanager
                });
                editor.ui.registry.addMenuItem('filemanager', {
                    icon: 'browse',
                    text: 'Insert file',
                    onAction: openmanager
                });
                const templateURLElement = document.querySelector('[data-tk-staticcontent-templates-url]');
                const templateURL = templateURLElement && templateURLElement.getAttribute('data-op-url');
                if (templateURL) this.getTemplates(templateURL);
            }
        };
        if (this.fileUploadIFrameURL) options.file_picker_callback = this.handleFilePicker.bind(this);
        window.tinymce.init(options);
    }
    handleFilePicker(callback) {
        window.tinymce.activeEditor?.windowManager.openUrl({
            title: 'Fileupload Area',
            url: this.fileUploadIFrameURL,
            width: 800,
            height: 600
        });
        window.addEventListener('message', (event)=>{
            const { data: data } = event;
            if (window.location.origin !== event.origin) return;
            callback(data.content);
        });
    }
    static getFileManagerURL(editor) {
        return `/webportal/filemanager.aspx?editor=${editor.id}&lang=${$edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage()}`;
    }
    static htmlEncode(content) {
        return content.toString().replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    static htmlDecode(content) {
        return content.toString().replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
    }
    static getLanguage() {
        if (window.location.href.indexOf('/en/') !== -1) return 'en_GB';
        if (window.location.href.indexOf('/fr/') !== -1) return 'fr_FR';
        if (window.location.href.indexOf('/it/') !== -1) return 'it';
        return 'de';
    }
    async getTemplates(templateURL) {
        if (this.templatesLoaded) return;
        // get url content
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: templateURL,
                resolveHandler: (response)=>{
                    this.getTemplateContent(response, resolve);
                }
            });
        });
    }
    getTemplateContent(response, resolveFunction) {
        response.dataAsJson.forEach((element)=>{
            this.templateContentPromiseArray = [];
            this.templateContentPromiseArray.push(new Promise((resolve)=>{
                (0, $1653b55d89a7adce$export$24835cb787452b46)({
                    requestURL: element.url,
                    resolveHandler: (response)=>{
                        this.saveTemplateContent(response, element, resolveFunction, resolve);
                    }
                });
            }));
        });
    }
    saveTemplateContent(response, element, resolvedAllFunction, resolveArrayElementFunction) {
        const templateContent = response.dataAsHtml;
        const newTemplateEntry = {
            title: element.title,
            description: element.description,
            content: templateContent
        };
        this.urlTemplate.push(newTemplateEntry);
        resolveArrayElementFunction();
        Promise.allSettled(this.templateContentPromiseArray).then(()=>{
            resolvedAllFunction();
            this.templatesLoaded = true;
        });
    }
}





class $ad2181492f474118$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.isAsyncTile = Boolean(this.closest('[data-tk-product-tile][data-tk-url]'));
        this.articleList = this.closest('[data-tk-article-list]') || undefined;
        this.asyncURL = this.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.source = this.getAttribute('data-tk-source') || '';
        this.catItemId = this.getAttribute('data-tk-cat-item-id') || '';
        this.articleId = this.getAttribute('data-tk-article-id') || '';
        this.stockType = this.getAttribute('data-tk-stock-type') || '';
        this.stockLocation = this.getAttribute('data-tk-stock-location') || '';
        this.dispo = this.getAttribute('data-tk-dispo') || '';
        this.dispoDate = this.getAttribute('data-tk-dispo-date') || '';
        this.loadingType = this.getAttribute('data-tk-loading-type') || '';
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || '';
        this.stockPeriodType = this.getAttribute('data-tk-stock-period-type') || '1';
        this.artUnitType = this.getAttribute('data-tk-art-unit-type') || '3';
    }
    connectedCallback() {
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            stockPeriodType: this.stockPeriodType,
            artUnitType: this.artUnitType,
            element: this
        };
        if (this.articleList && !this.isAsyncTile) this.sendDataToArticleList(item);
        else this.handleStock(item);
    }
    sendDataToArticleList(item) {
        this.articleList.addStock(item);
    }
    handleStock(item) {
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? $ad2181492f474118$export$2e2bcd8739ae039.getItemsAsJSONString([
            item
        ]) : $ad2181492f474118$export$2e2bcd8739ae039.getItemsAsEntrypoint([
            item
        ]);
        const data = {
            type: 'stock',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this)
        });
    }
    static getItemsAsEntrypoint(data) {
        const items = [];
        const articles = [];
        data.forEach((item)=>{
            items.push([
                item.articleId,
                item.stockType,
                item.stockLocation,
                item.stockPeriodType,
                item.dispoDate,
                item.artUnitType
            ].join(','));
            articles.push(item.articleId);
        });
        return {
            items: items.join(','),
            articles: articles.join(',')
        };
    }
    static getItemsAsJSONString(data) {
        const items = [];
        data.forEach((item)=>{
            items.push({
                source: item.source,
                catitemboid: item.catItemId,
                catitemartinternalno: item.articleId,
                stocktype: item.stockType,
                stockloc: item.stockLocation,
                dispo: item.dispo,
                dispodate: item.dispoDate,
                loadingtype: item.loadingType,
                template: item.asyncTemplate
            });
        });
        return {
            catitems: JSON.stringify({
                items: items
            })
        };
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== 1) return;
        const list = response.dataAsJson.items;
        const responseItem = list[0];
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            element: undefined
        };
        this.refreshStock(item, responseItem);
    }
    refreshStock(_item, responseItem) {
        const { html: html } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? (0, $fbcf93c2a0aa5bcb$export$c537b38001c583b7)(html) : html;
        const tooltip = this.querySelector('tk-tooltip');
        tooltip && tooltip.remove();
        this.insertAdjacentHTML('beforeend', htmlString);
    }
}




class $c7b0de4494db348b$export$2e2bcd8739ae039 extends (0, $ad2181492f474118$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    connectedCallback() {
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            stockPeriodType: this.stockPeriodType,
            artUnitType: this.artUnitType,
            element: this
        };
        if (this.articleList && (!this.isAsyncTile || this.loadingType === '2')) this.sendDataToArticleList(item);
        else this.handleStock(item);
    }
    handleStock(item) {
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsJSONString([
            item
        ]) : (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsEntrypoint([
            item
        ]);
        const data = {
            type: 'stock',
            arttype: 'single',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this)
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    refreshStock(item, responseItem) {
        const { html: html, nextReceipt: nextReceipt } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? atob(html) : html;
        const tooltip = this.querySelector('tk-tooltip');
        tooltip && tooltip.remove();
        this.insertAdjacentHTML('beforeend', htmlString);
        if (nextReceipt) {
            const nextReceiptString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(nextReceipt) ? atob(nextReceipt) : nextReceipt;
            this.insertAdjacentHTML('afterend', nextReceiptString);
        }
    }
}






class $1ccb7c18f671f1de$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.hasStartedSync = false;
        this.isAsyncTile = Boolean(this.closest('[data-tk-product-tile][data-tk-url]'));
        this.articleList = this.closest('[data-tk-article-list]') || undefined;
        this.asyncURL = this.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.source = this.getAttribute('data-tk-source') || '';
        this.service = this.getAttribute('data-tk-service') || '';
        this.catItemId = this.getAttribute('data-tk-cat-item-id') || '';
        this.articleId = this.getAttribute('data-tk-article-id') || '';
        this.loadingType = this.getAttribute('data-tk-loading-type') || '';
        this.sort = this.getAttribute('data-tk-sort') || '';
        this.key = this.getAttribute('data-tk-key') || '';
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || '';
        this.isServiceClassName = this.getAttribute('data-tk-is-service-class-name') || 'tk-price--has-service';
        this.isPromotionClassName = this.getAttribute('data-tk-is-promotion-class-name') || 'tk-price--has-promotion';
    }
    connectedCallback() {
        this.item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: this
        };
        if (this.articleList && this.loadingType !== '2' && !this.isAsyncTile) this.sendDataToArticleList();
        else this.loadingType === '2' ? this.registerHoverListener() : this.handlePrice();
    }
    registerHoverListener() {
        const onHover = this.handlePrice.bind(this);
        this.pushListener({
            event: 'mouseover',
            element: this,
            action: onHover
        });
    }
    hover() {
        this.hasStartedSync = true;
        this.handlePrice();
    }
    sendDataToArticleList() {
        this.item && this.articleList.addPrice(this.item);
    }
    handlePrice() {
        if (!this.item) return;
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? $1ccb7c18f671f1de$export$2e2bcd8739ae039.getItemsAsJSONString([
            this.item
        ]) : $1ccb7c18f671f1de$export$2e2bcd8739ae039.getItemsAsEntrypoint([
            this.item
        ]);
        const data = {
            type: 'price',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            resolveHandler: this.handleResponse.bind(this),
            payload: data
        });
    }
    static getItemsAsEntrypoint(data) {
        const articles = [];
        data.forEach((item)=>{
            articles.push(item.articleId);
        });
        return {
            articles: articles.join(',')
        };
    }
    static getItemsAsJSONString(data) {
        const items = [];
        data.forEach((item)=>{
            items.push({
                source: item.source,
                service: item.service,
                catitemboid: item.catItemId,
                catitemartinternalno: item.articleId,
                loadingtype: item.loadingType,
                sort: item.sort,
                key: item.key,
                template: item.asyncTemplate
            });
        });
        return {
            catitems: JSON.stringify({
                items: items
            })
        };
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== 1) return;
        const list = response.dataAsJson.items;
        const responseItem = list[0];
        const item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: undefined
        };
        this.refreshPrice(item, responseItem);
    }
    handleError(error) {
        this.hasStartedSync = false;
        throw new Error(error);
    }
    refreshPrice(_item, responseItem) {
        const conditions = [
            {
                condition: responseItem.basispriceisset,
                selector: '[data-tk-price-basic]',
                className: undefined
            },
            {
                condition: responseItem.servicepriceisset,
                selector: '[data-tk-price-service]',
                className: this.isServiceClassName
            },
            {
                condition: responseItem.promopriceisset,
                selector: '[data-tk-price-promotion]',
                className: this.isPromotionClassName
            }
        ];
        const { selector: selector, className: className } = conditions.find(({ condition: condition })=>condition) || {};
        if (!selector) return;
        const element = this.querySelector(selector);
        const { html: html } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? (0, $fbcf93c2a0aa5bcb$export$c537b38001c583b7)(html) : html;
        if (element) element.innerHTML = htmlString;
        else this.innerHTML = htmlString;
        className && this.classList.add(className);
    }
}



const $7cf802f14f3a63bb$var$QUANTITY_ATTR = 'data-quantity';
class $7cf802f14f3a63bb$export$2e2bcd8739ae039 extends (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039) {
    static{
        this.observedAttributes = [
            $7cf802f14f3a63bb$var$QUANTITY_ATTR
        ];
    }
    constructor(){
        super();
        this.quantity = Number(this.getAttribute($7cf802f14f3a63bb$var$QUANTITY_ATTR)) || undefined;
        this.requestURL = this.getAttribute('data-tk-request-url') || undefined;
    }
    connectedCallback() {
        if (!this.requestURL) return;
        this.item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: this
        };
        this.loadingType === '2' ? this.registerHoverListener() : this.handlePrice();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === $7cf802f14f3a63bb$var$QUANTITY_ATTR) {
            const quantity = Number(newValue);
            this.quantity = quantity;
            this.handlePrice();
        }
    }
    handlePrice() {
        const data = {
            quantity: String(this.quantity || 1)
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.requestURL,
            resolveHandler: this.updatePrice.bind(this),
            payload: data
        });
    }
    updatePrice(response) {
        const priceElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        if (priceElement.querySelector('[data-tk-price-promotion]')) this.classList.add(this.isPromotionClassName);
        this.innerHTML = priceElement.innerHTML;
    }
}







var $fd4fdaa8be3050bd$export$eb1b84084436143e = /*#__PURE__*/ function(BasketAction) {
    BasketAction["FETCHING"] = "fetching";
    BasketAction["REFRESHED_LIST"] = "refreshed-list";
    BasketAction["REFRESHED_BASKET"] = "refreshed-basket";
    return BasketAction;
}({});
class $fd4fdaa8be3050bd$export$2e2bcd8739ae039 {
    constructor(component){
        this.listeners = [];
        this.component = component;
        this.componentSelector = `.${this.component.classList.value}`;
        this.basketList = document.querySelector('[data-tk-basket-list]') || undefined;
        this.totalAmount = document.querySelector('[data-tk-basket-total-amount]') || undefined;
        this.miniBasket = document.querySelector('[data-tk-minibasket]') || undefined;
        this.emptyClassName = this.basketList?.getAttribute('data-tk-basket-empty-class-name') || 'module-basket--empty';
    }
    subscribe(listener) {
        this.listeners.push(listener);
    }
    emit(data) {
        this.listeners.forEach((listener)=>{
            listener(data);
        });
    }
    fetch(checkForReadonlyContext = false) {
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(checkForReadonlyContext);
        this.emit({
            action: "fetching"
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshResultList.bind(this),
            payload: this.prepareDataSubmission()
        });
    }
    prepareDataSubmission() {
        const { tkAction: tkAction, tkModule: tkModule, tkArtInternalno: tkArtInternalno, tkSalDocItemBoId: tkSalDocItemBoId, tkSalDocBoId: tkSalDocBoId, tkAddAllOptions: tkAddAllOptions, tkVariant: tkVariant, tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3, tkAsyncTemplate: tkAsyncTemplate, tkRequest: tkRequest, tkEncrypted: tkEncrypted } = this.component.dataset;
        const data = {
            type: 'basket',
            action: tkAction,
            module: tkModule,
            originalUrl: window.location.href
        };
        tkArtInternalno && (data.artInternalNo = tkArtInternalno);
        tkSalDocItemBoId && (data.salDocItemBoId = tkSalDocItemBoId);
        tkSalDocBoId && (data.salDocBoId = tkSalDocBoId);
        tkAddAllOptions && (data.addalloptions = tkAddAllOptions);
        tkVariant && (data.artDimVariantNo = tkVariant);
        tkQuantityId1 && (data.catItemQuantityDim1 = this.getButtonDimValue(tkQuantityId1));
        tkQuantityId2 && (data.catItemQuantityDim2 = this.getButtonDimValue(tkQuantityId2));
        tkQuantityId3 && (data.catItemQuantityDim3 = this.getButtonDimValue(tkQuantityId3));
        tkAsyncTemplate && (data.template = tkAsyncTemplate);
        tkRequest && (data.request = tkRequest);
        tkEncrypted && (data.encrypted = tkEncrypted);
        Object.keys(this.component.dataset).filter((key)=>key.startsWith('tkSaldocitem.')).forEach((key)=>{
            data[key.substring(2).toLowerCase()] = this.component.dataset[key];
        });
        if (tkAction === 'addall') {
            const quantities = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.getQuantitiesFromPositions();
            quantities !== '{}' && (data.addall = quantities);
        }
        return data;
    }
    static getQuantitiesFromPositions() {
        const quantities = {};
        const articleList = document.querySelector('[data-tk-basket-add-all-wrapper]');
        const articles = articleList?.querySelectorAll('article');
        articles?.forEach((article)=>{
            const id = article.getAttribute('data-tk-item-number');
            if (!id) return;
            const basketButton = article.querySelector('[data-tk-basket-button]');
            if (!basketButton) return;
            const dimensions = basketButton.querySelectorAll('[data-tk-dimension]:not([hidden])');
            dimensions.forEach((dimension)=>{
                const dimensionNumber = dimension.getAttribute('data-tk-dimension') || '';
                const fieldElement = dimension.querySelector('[data-tk-input-quantity]');
                quantities[`position${id}${dimensionNumber}`] = fieldElement?.value || '0';
            });
        });
        return JSON.stringify(quantities);
    }
    getButtonDimValue(dimNumIdVal) {
        let retVal = '';
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return retVal;
        const input = dim.querySelector('[data-tk-input-quantity]');
        if (!input) return retVal;
        let value = Number(input.value);
        const defaultValue = Number(input.min) || 1;
        if (dim.hidden) return retVal;
        if (Number.isNaN(value) || value <= 0) {
            value = defaultValue;
            retVal = String(defaultValue);
        } else retVal = String(value);
        return retVal;
    }
    getButtonDimUnit(dimNumIdVal) {
        let unit = '';
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return unit;
        if (dim.hidden) return unit;
        const unitElement = dim.querySelector('[data-tk-basket-dim-unit]');
        if (!unitElement) return unit;
        unit = unitElement.innerText;
        return unit;
    }
    refreshResultList(response) {
        this.emit({
            action: "refreshed-list",
            data: response.dataAsJson
        });
        if (!response.success) return;
        this.updateMiniBasket(response.dataAsJson);
        this.updateBasket(response.dataAsJson);
        if (response.dataAsJson.action === 'added') (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(this.getQuantityMessage());
        const { action: action } = response.dataAsJson;
        this.updateCartTracker(action);
    }
    updateMiniBasket(data) {
        this.miniBasket?.dispatchEvent(this.miniBasket.updateEvent);
        this.miniBasket?.setAttribute('data-count', `${data.quantity}`);
    }
    updateBasket(data) {
        if (!this.basketList) return;
        const { tkAction: tkAction } = this.component.dataset;
        if (tkAction === 'delete' || tkAction === 'deleteall') {
            if (data.quantity === 0) window.location.reload();
            else {
                const basketPos = this.basketList.querySelector(`[data-tk-internalno="${this.component.dataset.tkInternalno}"]`) || this.component.closest('[data-tk-basket-item]');
                if (basketPos) basketPos.remove();
            }
        } else if (tkAction === 'change') {
            // update item price and amount
            const price = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-price]');
            if (price) price.innerHTML = `${data.currency} ${data.itemPrice}`;
            const amount = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-amount]');
            if (!amount) return;
            amount.innerHTML = `${data.currency} ${data.itemAmount}`;
        } else if (this.component.closest('tk-quick-order')) {
            // update after quickorder
            const quickorder = this.component.closest('tk-quick-order');
            if (!quickorder) return;
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: quickorder.dataset.tkUrlRefresh || window.location.href,
                resolveHandler: this.refreshBasketList.bind(this)
            });
        }
        // update total amount and VAT
        if (this.totalAmount) this.totalAmount.innerHTML = `${data.currency} ${data.totalAmount}`;
        const totalVat = this.basketList.querySelector('[data-tk-basket-total-vat]');
        if (totalVat) totalVat.innerHTML = `${data.currency} ${data.totalVat}`;
        this.emit({
            action: "refreshed-basket"
        });
    }
    refreshBasketList(response) {
        if (!response || !response.success || !this.basketList) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        const basketListWrapper = html.querySelector('[data-tk-basket-list]');
        basketListWrapper && (this.basketList.innerHTML = basketListWrapper.innerHTML);
        this.basketList.classList.remove(this.emptyClassName);
        const existDeleteAllButton = document.querySelector('[data-tk-basket-list-actions] > tk-basket-button');
        if (!existDeleteAllButton) {
            const basketHeaderActionWrapper = document.querySelector('[data-tk-basket-list-actions]');
            const deleteAllButton = html.querySelector('[data-tk-basket-list-actions] > tk-basket-button');
            deleteAllButton && basketHeaderActionWrapper?.insertAdjacentElement('beforeend', deleteAllButton);
        }
        const footer = document.querySelector('[data-tk-basket-list-footer]');
        if (!footer) {
            const footerWrapper = html.querySelector('[data-tk-basket-list-footer]');
            footerWrapper && this.basketList.insertAdjacentElement('afterend', footerWrapper);
        }
    }
    static quantityChanger(event) {
        const target = event.target;
        const currentTarget = event.currentTarget;
        if (!target || !target.parentElement) return;
        let wrapper = null;
        wrapper = target.closest('[data-tk-counter]');
        if (!wrapper) wrapper = target.closest('[data-tk-dimension]');
        if (!wrapper) return;
        const decrementButton = wrapper.querySelector('[data-tk-counter-decreaser]');
        const incrementButton = wrapper.querySelector('[data-tk-counter-increaser]');
        const inputField = wrapper.querySelector('[data-tk-input-quantity]');
        if (!inputField) return;
        const step = Number(inputField.getAttribute('step') || 1);
        const min = Number(inputField.getAttribute('min') || step);
        const max = Number(inputField.getAttribute('max') || 0);
        const isMaxSet = max > 0;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = inputField.dataset;
        const artDimCheck = tkArtDimCheckCd ? Number(tkArtDimCheckCd) : 0;
        const oldValue = Number(inputField.value || 0);
        let hasChanged = false;
        let operator = '+';
        if (incrementButton && target === incrementButton) {
            operator = '+';
            if (oldValue < min) operator = '-';
        } else if (decrementButton && target === decrementButton) {
            operator = '-';
            if (oldValue > max && isMaxSet) operator = '+';
        }
        if (event.key === 'ENTER') {
            if (oldValue > max) operator = '+';
            else if (oldValue < min) operator = '-';
        }
        if (artDimCheck > 0) {
            const multiplikator = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.countDecimals(step);
            const currentValPow = oldValue * 10 ** multiplikator;
            const stepPow = step * 10 ** multiplikator;
            if ((currentValPow === 0 || currentValPow % stepPow !== 0) && oldValue >= min) {
                const result = (currentValPow + stepPow - currentValPow % stepPow) / 10 ** multiplikator;
                (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace('{currentValue}', String(oldValue)).replace('{newValue}', String(result)).replace('{step}', String(step)));
                operator = '+';
            }
        }
        if (currentTarget === decrementButton || currentTarget === incrementButton) hasChanged = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.setCalculatedQuantityField(oldValue, inputField, step, min, max, operator);
        return hasChanged;
    }
    getQuantityMessage() {
        const message = {
            ...(0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket
        };
        const { tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3 } = this.component.dataset;
        const dim1Value = this.getButtonDimValue(tkQuantityId1 || '');
        const dim1Unit = this.getButtonDimUnit(tkQuantityId1 || '');
        const dim2Value = this.getButtonDimValue(tkQuantityId2 || '');
        const dim2Unit = this.getButtonDimUnit(tkQuantityId2 || '');
        const dim3Value = this.getButtonDimValue(tkQuantityId3 || '');
        const dim3Unit = this.getButtonDimUnit(tkQuantityId3 || '');
        let quantity = `${dim1Value} ${dim1Unit} `;
        if (dim2Value) quantity = `${quantity}x ${dim2Value} ${dim2Unit} `;
        if (dim3Value) quantity = `${quantity}x ${dim3Value} ${dim3Unit} `;
        message.text = quantity + (0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket.text;
        return message;
    }
    updateCartTracker(action) {
        const urlElement = document.querySelector('[data-tk-basket-tracker]');
        const url = urlElement?.getAttribute('data-tk-url');
        if (!url) return;
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleCartTracker.bind(this, action)
        });
    }
    handleCartTracker(action, response) {
        if (!response || !response.dataAsJson) return;
        const { items: items, data: data } = response.dataAsJson;
        const trackerElement = document.querySelector('[data-tk-tracker-wrapper]');
        trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                type: (0, $588d148f2c9ac202$export$4120f82005ec4b2d).BASKET_UPDATE,
                item: {
                    event: action,
                    location: window.location.href,
                    currency: data.currency,
                    value: data.totalAmount,
                    items: items
                }
            }
        }));
    }
    static setCalculatedQuantityField(currentVal, fieldElement, step, min, max = 0, operator = '+') {
        const multiplikator = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.countDecimals(step);
        const currentValPow = Math.round(currentVal * 10 ** multiplikator);
        const stepPow = Math.round(step * 10 ** multiplikator);
        const minPow = Math.round(min * 10 ** multiplikator);
        const maxPow = Math.round(max * 10 ** multiplikator);
        let newValuePow = currentValPow;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = fieldElement.dataset;
        const artDimCheck = Number(tkArtDimCheckCd);
        const operatorHandler = {
            '-': ()=>$fd4fdaa8be3050bd$export$2e2bcd8739ae039.calcMinus(currentValPow, newValuePow, stepPow, minPow, min, Number(artDimCheck)),
            '+': ()=>$fd4fdaa8be3050bd$export$2e2bcd8739ae039.calcPlus(currentValPow, newValuePow, stepPow, maxPow, max, Number(artDimCheck))
        };
        newValuePow = operatorHandler[operator]();
        // Wert veraendert und Step beruecksichtigt?
        if (newValuePow !== currentValPow) {
            if (newValuePow % stepPow === 0 || artDimCheck === 0) {
                fieldElement.value = String(newValuePow / 10 ** multiplikator);
                return true;
            }
            newValuePow = currentValPow;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace('{step}', String(step)));
        }
        return false;
    }
    static calcPlus(currentValPow, newValuePow, stepPow, maxPow, max, artDimCheck) {
        if (maxPow > 0 && newValuePow > maxPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeOverflow.replace('{max}', String(max)));
            return maxPow;
        }
        return currentValPow + stepPow - (artDimCheck > 0 ? currentValPow % stepPow : 0);
    }
    static calcMinus(currentValPow, newValuePow, stepPow, minPow, min, artDimCheck) {
        if (newValuePow <= minPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeUnderflow.replace('{min}', String(min)));
            return minPow;
        }
        const adjustment = artDimCheck === 0 || currentValPow % stepPow === 0 ? stepPow : currentValPow % stepPow;
        return currentValPow - adjustment;
    }
    static countDecimals(value) {
        if (Math.floor(value) === value) return 0;
        return value.toString().split('.')[1].length || 0;
    }
}





class $d69b369e50d21df9$export$2e2bcd8739ae039 extends (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039) {
    constructor(component){
        super(component);
    }
    async fetch(checkForReadonlyContext = false) {
        const payload = this.prepareDataSubmission();
        const favorite2basket = this.component.closest('diw-favorite-to-basket');
        const giftCardSelect = document.querySelector('#giftcard-value');
        if (giftCardSelect) {
            payload['saldocitem.netsp'] = giftCardSelect.value;
            payload['saldocitem.grosssp'] = giftCardSelect.value;
            payload['saldocitem.free7'] = giftCardSelect.value;
        }
        if (payload.action === 'addall' && favorite2basket.isActive) {
            await favorite2basket.fetch();
            const basketButton = this.component.button;
            basketButton && (basketButton.disabled = false);
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedAllToBasket.text);
            return;
        }
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(checkForReadonlyContext);
        this.emit({
            action: (0, $fd4fdaa8be3050bd$export$eb1b84084436143e).FETCHING
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshResultList.bind(this),
            payload: payload
        });
    }
    refreshResultList(response) {
        this.emit({
            action: (0, $fd4fdaa8be3050bd$export$eb1b84084436143e).REFRESHED_LIST,
            data: response.dataAsJson
        });
        if (!response.success) return;
        this.updateMiniBasket(response.dataAsJson);
        this.updateBasket(response.dataAsJson);
        if (response.dataAsJson.action === 'added') (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(this.getQuantityMessage());
        if (response.dataAsJson.action === 'addedAll') {
            const favorite2basket = this.component.closest('diw-favorite-to-basket');
            favorite2basket && favorite2basket.fetch();
        }
        const { action: action } = response.dataAsJson;
        this.updateCartTracker(action);
    }
    updateBasket(data) {
        if (!this.basketList) return;
        const { tkAction: tkAction } = this.component.dataset;
        if (tkAction === 'delete' || tkAction === 'deleteall') {
            if (data.quantity === 0) window.location.reload();
            else {
                const basketPos = this.basketList.querySelector(`[data-tk-internalno="${this.component.dataset.tkInternalno}"]`) || this.component.closest('[data-tk-basket-item]');
                if (basketPos) basketPos.remove();
            }
        } else if (tkAction === 'change') {
            // update item price and amount
            const price = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-price]');
            if (price) price.innerHTML = `${data.currency} ${data.itemPrice}`;
            const amount = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-amount]');
            if (!amount) return;
            amount.innerHTML = `${data.currency} ${data.itemAmount}`;
        } else if (this.component.closest('tk-quick-order')) {
            // update after quickorder
            const quickorder = this.component.closest('tk-quick-order');
            if (!quickorder) return;
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: quickorder.dataset.tkUrlRefresh || window.location.href,
                resolveHandler: this.refreshBasketList.bind(this)
            });
        }
        // update total amount and VAT
        if (this.totalAmount) {
            const url = this.totalAmount.getAttribute('data-tk-basket-amount-url');
            if (url) (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: this.refreshBasketTotal.bind(this)
            });
            else this.totalAmount.innerHTML = `${data.currency} ${data.totalAmount}`;
        }
        const totalVat = this.basketList.querySelector('[data-tk-basket-total-vat]');
        if (totalVat) totalVat.innerHTML = `${data.currency} ${data.totalVat}`;
        this.emit({
            action: (0, $fd4fdaa8be3050bd$export$eb1b84084436143e).REFRESHED_BASKET
        });
    }
    refreshBasketTotal(response) {
        if (!response || !response.dataAsJson) return;
        const data = response.dataAsJson;
        this.totalAmount.innerHTML = `${data.currency} ${data.amount}`;
        // update shipping fee
        const shipping = document.querySelector('[data-tk-shipping-fee]');
        if (shipping) shipping.innerHTML = data.shipping;
        // update article count
        const itemCount = document.querySelector('[data-tk-basket-icon-count]');
        if (itemCount) itemCount.innerHTML = data.itemCount;
    }
}






var $127c03b03da38c7a$export$416096e8140b15df = /*#__PURE__*/ function(BasketActionTypes) {
    BasketActionTypes["ADD"] = "add";
    BasketActionTypes["CHANGE"] = "change";
    BasketActionTypes["DELETE"] = "delete";
    BasketActionTypes["ADD_ALL"] = "addall";
    BasketActionTypes["DELETE_ALL"] = "deleteall";
    return BasketActionTypes;
}({});
class $127c03b03da38c7a$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.basketAction = new (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039)(this);
        this.action = this.getAttribute('data-tk-action') || "add";
        this.button = this.querySelector('[data-tk-basket-button]') || undefined;
        this.counterWrapper = this.querySelector('[data-tk-counter]') || undefined;
        this.variantWrapper = this.querySelector('[data-tk-basket-variants]') || undefined;
        if (this.counterWrapper) {
            this.decreaser = this.querySelector('[data-tk-counter-decreaser]') || undefined;
            this.increaser = this.querySelector('[data-tk-counter-increaser]') || undefined;
            this.counter = this.querySelector('[data-tk-input-quantity]') || undefined;
            this.counters = this.querySelectorAll('[data-tk-input-quantity]');
        }
    }
    connectedCallback() {
        if (!this.button) throw new Error('Basket: Button is missing!');
        this.registerClickListener();
        this.counterWrapper && this.registerCounter();
        this.registerBasketListener();
        this.variantWrapper && this.registerVariantListener();
    }
    registerClickListener() {
        const onClick = this.handleBasketClick.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerVariantListener() {
        const onInput = this.updateDimensions.bind(this);
        const fieldElement = this.variantWrapper?.querySelector('input[type="hidden"]');
        fieldElement && this.pushListener({
            event: 'change',
            element: fieldElement,
            action: onInput
        });
    }
    registerCounter() {
        if (!this.decreaser || !this.increaser) return;
        if (this.action === "change") {
            const onChange = this.change.bind(this);
            this.pushListener({
                event: 'click',
                element: this.decreaser,
                action: onChange
            });
            this.pushListener({
                event: 'click',
                element: this.increaser,
                action: onChange
            });
            this.counters?.forEach((counter)=>{
                this.pushListener({
                    event: 'change',
                    element: counter,
                    action: onChange
                });
            });
        } else {
            const onDecrease = this.decrease.bind(this);
            this.pushListener({
                event: 'click',
                element: this.decreaser,
                action: onDecrease
            });
            const onIncrease = this.increase.bind(this);
            this.pushListener({
                event: 'click',
                element: this.increaser,
                action: onIncrease
            });
        }
    }
    registerBasketListener() {
        this.basketAction.subscribe((event)=>{
            const basketActionHandler = {
                fetching: ()=>{},
                'refreshed-list': ()=>event.data && this.closeDialog(event.data),
                'refreshed-basket': ()=>{}
            };
            basketActionHandler[event.action]();
        });
    }
    closeDialog(data) {
        this.button.disabled = false;
        if (!data.success) return;
        const dialog = this.closest('dialog');
        if (!dialog) return;
        dialog.close();
    }
    handleBasketClick() {
        this.button.disabled = true;
        this.validateQuantity();
        this.basketAction.fetch(false);
    }
    increase() {
        if (!this.counter || !this.increaser) return;
        const { step: step, max: max, value: value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
    }
    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step: step, min: min, value: value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
    }
    change(event) {
        (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039).quantityChanger(event);
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.button?.click();
        }, 500);
    }
    validateQuantity() {
        const shouldCheckDimension = this.counter?.getAttribute('data-tk-art-dim-check-cd') === '1';
        if (!shouldCheckDimension || !this.counter) return;
        const step = Number(this.counter.step) || 1;
        const currentValue = Number(this.counter.value) || 1;
        const max = Number(this.counter.max);
        const min = Number(this.counter.min);
        if (currentValue % step === 0) return;
        let result = Math.ceil(currentValue / step) * step;
        if (min > 0 && result < min) result += step;
        if (max > 0 && result > max) result -= step;
        this.counter.value = String(result);
        (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepAdjust.replace('{currentValue}', String(currentValue)).replace('{newValue}', String(result)).replace('{step}', String(step)));
    }
    updateDimensions(event) {
        const selectedVariant = event.target;
        const getDimensionValue = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-value`) || '0';
        const getDimensionName = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-name`) || '';
        const getDimensionUnit = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-unit`) || '';
        const getDimensionMin = ()=>Number(selectedVariant.getAttribute('data-tk-min'));
        const getDimensionMax = ()=>Number(selectedVariant.getAttribute('data-tk-max'));
        const getDimensionStep = ()=>Number(selectedVariant.getAttribute('data-tk-step'));
        const getDimensionCheckCd = ()=>selectedVariant.getAttribute('data-tk-art-dim-check-cd') || '';
        const setDimension = (wrapper, dimension)=>{
            const value = getDimensionValue(dimension);
            const fieldElement = wrapper.querySelector('[data-tk-input-quantity]');
            const nameElement = wrapper.querySelector('[data-tk-basket-dim-unit-name]');
            const unitElements = wrapper.querySelectorAll('[data-tk-basket-dim-unit]');
            if (!fieldElement) return;
            fieldElement.value = value !== '0' ? value : '';
            fieldElement.setAttribute('data-tk-art-dim-check-cd', getDimensionCheckCd());
            if (getDimensionMin() > 0) fieldElement.setAttribute('min', String(getDimensionMin()));
            else fieldElement.removeAttribute('min');
            if (getDimensionMax() > 0) fieldElement.setAttribute('max', String(getDimensionMax()));
            else fieldElement.removeAttribute('max');
            if (getDimensionStep() > 0) fieldElement.setAttribute('step', String(getDimensionStep()));
            else fieldElement.removeAttribute('step');
            nameElement && (nameElement.textContent = getDimensionName(dimension));
            unitElements.forEach((element)=>{
                element.textContent = getDimensionUnit(dimension);
            });
        };
        const dimensionWrappers = this.querySelectorAll('[data-tk-dimension]:not([hidden])');
        dimensionWrappers.forEach((wrapper)=>{
            const dimension = wrapper.getAttribute('data-tk-dimension');
            dimension && setDimension(wrapper, dimension);
        });
        this.setAttribute('data-tk-variant', selectedVariant.value);
    }
}


class $676bf9a0b3e6a9fd$export$2e2bcd8739ae039 extends (0, $127c03b03da38c7a$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.basketAction = new (0, $d69b369e50d21df9$export$2e2bcd8739ae039)(this);
        this.articleWrapper = this.closest('[data-article-wrapper]') || undefined;
    }
    increase() {
        if (!this.counter || !this.increaser) return;
        const { step: step, max: max, value: value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
        this.syncPriceQuantity();
    }
    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step: step, min: min, value: value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
        this.syncPriceQuantity();
    }
    change(event) {
        (0, $d69b369e50d21df9$export$2e2bcd8739ae039).quantityChanger(event);
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.button?.click();
            this.syncPriceQuantity();
        }, 500);
    }
    syncPriceQuantity() {
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            if (!this.counter) return;
            const priceElement = this.articleWrapper?.querySelector('[data-tk-dynamic-price]');
            priceElement?.setAttribute('data-quantity', this.counter.value);
        }, 500);
    }
}




var $fe64c06a372e274b$export$bcd15065bd7fecf6 = /*#__PURE__*/ function(SortDirectionEnum) {
    SortDirectionEnum["ASC"] = "ASC";
    SortDirectionEnum["DESC"] = "DESC";
    return SortDirectionEnum;
}({});
const $fe64c06a372e274b$export$633da1651c3bd3f9 = (a, b, direction)=>direction.toUpperCase() === "DESC" ? b.localeCompare(a) : a.localeCompare(b);
const $fe64c06a372e274b$export$dcb32d3e7e407924 = (a, b, direction)=>{
    const numberA = Number(a);
    const numberB = Number(b);
    return direction.toUpperCase() === "DESC" ? numberB - numberA : numberA - numberB;
};
const $fe64c06a372e274b$export$c4c806e061935577 = (a, b, direction)=>{
    const dateFormattedA = a.split('.').reverse().join('-');
    const dateFormattedB = b.split('.').reverse().join('-');
    const dateA = Date.parse(dateFormattedA);
    const dateB = Date.parse(dateFormattedB);
    return direction.toUpperCase() === "DESC" ? dateB - dateA : dateA - dateB;
};
const $fe64c06a372e274b$export$15d252ed5f5f8636 = (a, b, direction)=>{
    const dateA = new Date();
    const dateB = new Date();
    const splittedA = a.split(':').map((item)=>Number(item));
    const splittedB = b.split(':').map((item)=>Number(item));
    dateA.setHours(splittedA.at(0) || 0, splittedA.at(1), splittedA.at(2));
    dateB.setHours(splittedB.at(0) || 0, splittedB.at(1), splittedB.at(2));
    const timeA = dateA.getTime();
    const timeB = dateB.getTime();
    return direction.toUpperCase() === "DESC" ? timeB - timeA : timeA - timeB;
};
const $fe64c06a372e274b$export$ed1371d464d87bcf = (a, b, direction)=>{
    const timeStampListA = a.split(' ');
    const timeStampListB = b.split(' ');
    const dateA = timeStampListA.at(0)?.split('.').reverse().join('-');
    const dateB = timeStampListB.at(0)?.split('.').reverse().join('-');
    const timeA = timeStampListA.at(1);
    const timeB = timeStampListB.at(1);
    const timestampA = Date.parse(`${dateA}T${timeA}`);
    const timestampB = Date.parse(`${dateB}T${timeB}`);
    return direction.toUpperCase() === "DESC" ? timestampB - timestampA : timestampA - timestampB;
};
const $fe64c06a372e274b$export$92f3520fe1ac7383 = (a, b, direction)=>{
    const booleanA = Boolean(a);
    const booleanB = Boolean(b);
    const numberA = Number(booleanA);
    const numberB = Number(booleanB);
    return direction === "DESC" ? numberB - numberA : numberA - numberB;
};



var $2595e2ca594d6789$var$DataMaster = /*#__PURE__*/ function(DataMaster) {
    DataMaster["CLIENT"] = "client";
    return DataMaster;
}($2595e2ca594d6789$var$DataMaster || {});
class $2595e2ca594d6789$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.gridTemplateColList = [], this.hasAccordionRows = false, this.isHorizontalScrollable = false;
        this.headElement = this.querySelector('[data-tk-table-head]') || undefined;
        if (!this.headElement) throw new Error('Table: Head is missing!');
        this.rowHeadElement = this.headElement.querySelector('[data-tk-table-row]') || undefined;
        this.headShadowClassName = this.getAttribute('data-tk-head-shadow-class-name') || 'tk-table__head-shadow';
        this.isStickyLeft = this.hasAttribute('data-tk-is-sticky-left');
        this.isStickyHead = this.hasAttribute('data-tk-is-sticky-head');
        this.gridTemplateMobile = this.getAttribute('data-tk-grid-template-mobile') || '1fr';
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-table--loaded';
        this.stickyLeftClassname = this.getAttribute('data-tk-sticky-left-class-name') || 'tk-table--sticky-left';
        this.rightShadowClassName = this.getAttribute('data-tk-right-shadow-class-name') || 'tk-table__right-shadow';
        this.stickyHeadClassName = this.getAttribute('data-tk-sticky-head-class-name') || 'tk-table--sticky-head';
        this.customCols = this.getAttribute('data-tk-col-width') || 'auto';
        this.observer = new ResizeObserver(this.handleResize.bind(this));
        this.desktopMinWidth = Number(this.getAttribute('data-tk-desktop-min-width')) || 992;
        this.rowLinkSelector = 'data-tk-table-row-link';
        this.table = this.querySelector('table') || undefined;
        this.ascSortClassName = this.getAttribute('data-tk-asc-sort-class-name') || 'tk-table--sort-asc';
        this.descSortClassName = this.getAttribute('data-tk-desc-sort-class-name') || 'tk-table--sort-desc';
        this.isSortTable = Boolean(this.table?.hasAttribute('data-tk-table-sort'));
        this.colAlignStart = this.hasAttribute('data-tk-col-align-start');
        this.colAlignStartClassName = this.getAttribute('data-tk-col-align-start-class-name') || 'tk-table__col--align-left';
        this.colItemAlignCenter = this.hasAttribute('data-tk-col-item-align-center');
        this.colItemAlignCenterClassName = this.getAttribute('data-tk-col-item-align-center-class-name') || 'tk-table__col--item-align-center';
        this.colItemAlignStart = this.hasAttribute('data-tk-col-item-align-start');
        this.colItemAlignStartClassName = this.getAttribute('data-tk-col-item-align-start-class-name') || 'tk-table__col--item-align-start';
        this.colItemAlignEnd = this.hasAttribute('data-tk-col-item-align-end');
        this.colItemAlignEndClassName = this.getAttribute('data-tk-col-item-align-end-class-name') || 'tk-table__col--item-align-end';
        this.tableSelector = '[data-tk-table-sort]';
        this.sortDirectionSelector = '[data-tk-sort-direction]';
        this.tkSortDirectionSelector = 'tkSortDirection';
        this.tkSortAttrSelector = 'tkSortAttr';
        this.tkSortDatatypeSelector = 'tkSortDatatype';
        this.dataMasterSelector = 'data-tk-datamaster';
        this.dataSortAttrSelector = 'data-tk-sort-attr';
        this.hasAccordionRows = this.hasAttribute('data-tk-accordion-rows');
        this.accordionRowHeadActiveClassName = this.getDataAttribute('accordion-row-head-active-class-name', 'tk-table__row--head-accordion-active');
        this.accordionRowBodyActiveClassName = this.getDataAttribute('accordion-row-body-active-class-name', 'tk-table__row--body-accordion-active');
        this.accordionLastElementClassName = this.getDataAttribute('accordion-last-element-class-name', 'tk-table--accordion-last-row');
    }
    connectedCallback() {
        this.classList.add(this.loadedClassName);
        window.viewport.clientWidth < this.desktopMinWidth ? this.setGridMobile() : this.setGrid();
        this.registerViewportListener();
        this.registerScrollListener();
        this.registerRowLinkListener();
        this.observer.observe(this);
        this.isStickyHead && this.setStickyHead();
        this.isSortTable && this.registerTableHeadListener();
        this.colAlignStart && this.setColAlignStart();
        this.colItemAlignCenter && this.setColItemAlign(this.colItemAlignCenterClassName);
        this.colItemAlignStart && this.setColItemAlign(this.colItemAlignStartClassName);
        this.colItemAlignEnd && this.setColItemAlign(this.colItemAlignEndClassName);
        this.hasAccordionRows && this.registerAccordionListener();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.observer.unobserve(this);
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        if (customEvent.detail.width < this.desktopMinWidth) this.setGridMobile();
        else this.setGrid();
    }
    registerScrollListener() {
        const action = this.handleScrollBehavior.bind(this);
        this.pushListener({
            event: 'scroll',
            element: this,
            action: action
        });
    }
    registerTableHeadListener() {
        const handleSortTable = this.handleSortTable.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleSortTable
        });
    }
    registerRowLinkListener() {
        const handleRowLink = this.handleRowLink.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleRowLink
        });
    }
    registerAccordionListener() {
        const onClick = this.handleAccordion.bind(this);
        const rows = this.querySelectorAll('[data-tk-table-row-id]');
        rows.forEach((row)=>{
            this.pushListener({
                event: 'click',
                element: row,
                action: onClick
            });
        });
    }
    handleScrollBehavior(event) {
        this.toggleScrollHorizontalBehavior(event);
        if (this.isStickyLeft) this.toggleScrollLeftBehavior(event);
        if (this.isStickyHead) this.toggleScrollTopBehavior(event);
    }
    handleRowLink(event) {
        const target = event.target;
        if (target.closest('a')) return;
        if (target.closest('button')) return;
        const row = target.closest(`[${this.rowLinkSelector}]`);
        if (!row) return;
        const link = row.getAttribute(this.rowLinkSelector);
        if (!link) return;
        window.location.href = link;
    }
    handleSortTable(event) {
        if (!event) return;
        const target = event.target;
        const column = target.closest('th');
        column && column.hasAttribute('data-tk-sort-direction') && this.sortTable(column);
    }
    handleResize(entries) {
        entries.forEach(()=>{
            this.isHorizontalScrollable = this.scrollWidth > this.clientWidth;
            if (this.isHorizontalScrollable && !this.horizontalScrollShadowElement) this.setHorizontalScrollShadow();
            if (!this.horizontalScrollShadowElement) return;
            this.horizontalScrollShadowElement.hidden = !this.isHorizontalScrollable;
            this.boxShadowElement && (this.boxShadowElement.style.width = `${this.scrollWidth}px`);
        });
    }
    setGrid() {
        if (!this.rowHeadElement) return;
        const cols = this.rowHeadElement.childElementCount;
        this.gridTemplateColList = this.customCols?.split(/(?!, ),/g);
        this.style.gridTemplateColumns = this.customCols?.includes(',') ? this.gridTemplateColList?.join(' ') : `repeat(${cols}, ${this.customCols})`;
        if (this.headElement) this.headElement.classList.remove('tk-table__head--force-mobile');
        const titleElements = this.table?.querySelectorAll('[data-tk-table-body] .tk-table__title');
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.remove('tk-table__title--force-mobile');
        });
    }
    setGridMobile() {
        this.style.gridTemplateColumns = this.gridTemplateMobile;
        if (this.headElement) this.headElement.classList.add('tk-table__head--force-mobile');
        const titleElements = this.table?.querySelectorAll('[data-tk-table-body] .tk-table__title');
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.add('tk-table__title--force-mobile');
        });
    }
    toggleScrollLeftBehavior(event) {
        const element = event.target;
        this.classList.toggle(this.stickyLeftClassname, element.scrollLeft > 0);
    }
    toggleScrollHorizontalBehavior(event) {
        if (!this.horizontalScrollShadowElement) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = event.target;
        this.horizontalScrollShadowElement.hidden = scrollLeft >= scrollWidth - clientWidth;
        this.horizontalScrollShadowElement.style.right = `-${scrollLeft}px`;
    }
    toggleScrollTopBehavior(event) {
        if (!this.boxShadowElement) return;
        const element = event.target;
        this.boxShadowElement.hidden = element.scrollTop === 0;
        this.classList.toggle(this.stickyHeadClassName, element.scrollTop > 0);
        this.boxShadowElement.style.top = `${element.scrollTop}px`;
    }
    setStickyHead() {
        if (!this.headElement) return;
        this.boxShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.headShadowClassName}' hidden></div>`);
        if (!this.boxShadowElement) return;
        const column = this.rowHeadElement?.firstElementChild;
        const height = column?.getBoundingClientRect().height || 0;
        this.boxShadowElement.style.width = `${this.scrollWidth}px`;
        this.boxShadowElement.style.height = `${height}px`;
        this.headElement.insertAdjacentElement('afterbegin', this.boxShadowElement);
    }
    setHorizontalScrollShadow() {
        this.horizontalScrollShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.rightShadowClassName}'></div>`);
        if (!this.horizontalScrollShadowElement) return;
        this.insertAdjacentElement('beforeend', this.horizontalScrollShadowElement);
    }
    sortTable(column) {
        const dataMaster = this.table?.getAttribute(this.dataMasterSelector);
        if (dataMaster === "client") {
            this.setOrToggleSortDirection(column);
            this.clearHeadElementClassList(column);
            this.clientSortTable({
                element: column,
                type: column.dataset[this.tkSortDatatypeSelector],
                sortDirection: column.dataset[this.tkSortDirectionSelector],
                column: column.cellIndex
            });
            this.postAsynClientSortState(column);
        } else this.serverAsynTableSortRequest(column);
    }
    clientSortTable(headItem) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const rows = tableBody.querySelectorAll('[data-tk-table-row]');
        if (!rows) return;
        const rowList = Array.from(rows).map((element)=>{
            const value = Array.from(element.querySelectorAll('[data-tk-table-value]')).at(headItem.column)?.textContent || '';
            return {
                element: element,
                value: value
            };
        });
        const sortTypes = {
            A: (a, b)=>(0, $fe64c06a372e274b$export$633da1651c3bd3f9)(a, b, headItem.sortDirection),
            N: (a, b)=>(0, $fe64c06a372e274b$export$dcb32d3e7e407924)(a, b, headItem.sortDirection),
            D: (a, b)=>(0, $fe64c06a372e274b$export$c4c806e061935577)(a, b, headItem.sortDirection),
            H: (a, b)=>(0, $fe64c06a372e274b$export$15d252ed5f5f8636)(a, b, headItem.sortDirection),
            S: (a, b)=>(0, $fe64c06a372e274b$export$ed1371d464d87bcf)(a, b, headItem.sortDirection),
            B: (a, b)=>(0, $fe64c06a372e274b$export$92f3520fe1ac7383)(a, b, headItem.sortDirection)
        };
        const sortedList = rowList.sort((a, b)=>sortTypes[headItem.type](a.value, b.value));
        tableBody.innerHTML = '';
        sortedList.forEach((item)=>{
            tableBody.appendChild(item.element);
        });
        if (headItem.element.classList.contains(this.ascSortClassName) || headItem.element.classList.contains(this.descSortClassName)) headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.replace(this.ascSortClassName, this.descSortClassName) : headItem.element.classList.replace(this.descSortClassName, this.ascSortClassName);
        else headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.add(this.descSortClassName) : headItem.element.classList.add(this.ascSortClassName);
    }
    clearHeadElementClassList(column) {
        if (!this.rowHeadElement) return;
        const head = Array.from(this.rowHeadElement.children);
        const filteredHead = head.filter((item)=>item !== column);
        filteredHead.forEach((child)=>{
            const element = child;
            element.classList.remove(this.ascSortClassName);
            element.classList.remove(this.descSortClassName);
        });
    }
    setOrToggleSortDirection(thElement) {
        this.removeUnseletectedSortDir(thElement);
        // toggelt direction auf geklickten header spalte
        thElement.dataset[this.tkSortDirectionSelector] = thElement.dataset[this.tkSortDirectionSelector] === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC ? (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC : (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC;
    }
    serverAsynTableSortRequest(thElement) {
        this.setOrToggleSortDirection(thElement);
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.asyncTableSortHandler.bind(this),
            payload: options
        });
    }
    postAsynClientSortState(thElement) {
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: ()=>{},
            payload: options
        });
    }
    asyncTableSortHandler(response) {
        if (!response.success || !response.dataAsHtml) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.replaceAllResponseTable(html);
    }
    replaceAllResponseTable(element) {
        const oldTables = document.querySelectorAll(this.tableSelector);
        const newTables = element.querySelectorAll(this.tableSelector);
        oldTables.forEach((oldTable)=>{
            const correspondingNewTable = Array.from(newTables).find((newTable)=>oldTable.id === newTable.id);
            if (correspondingNewTable) oldTable?.parentNode?.replaceChild(correspondingNewTable, oldTable);
        });
    }
    getAsynPostOptions(thElement) {
        const table = thElement.closest(this.tableSelector);
        if (!table) return {};
        const client = table.getAttribute(this.dataMasterSelector);
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const sortDirection = thElement.dataset[this.tkSortDirectionSelector];
        const options = {
            type: 'tablesort',
            clientSort: String(!!client),
            tableid: table.id,
            sorting: `{"${sortAttribut}":"${sortDirection}"}`
        };
        return options;
    }
    removeUnseletectedSortDir(thElement) {
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const table = thElement.closest(this.tableSelector);
        if (!table) return;
        const headers = table.querySelectorAll(this.sortDirectionSelector);
        headers.forEach((header)=>{
            const headerSortAttr = header.dataset[this.tkSortAttrSelector];
            if (headerSortAttr === sortAttribut) return;
            header.dataset[this.tkSortDirectionSelector] = '';
        });
    }
    setColAlignStart() {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll('[data-tk-table-row] td');
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(this.colAlignStartClassName);
        });
    }
    setColItemAlign(className) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll('[data-tk-table-row] td');
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(className);
        });
    }
    handleAccordion(event) {
        const headElement = event.currentTarget;
        const id = headElement.getAttribute('data-tk-table-row-id');
        if (!id) return;
        const bodyElements = this.querySelectorAll(`[data-tk-table-accordion="${id}"]`);
        const isActive = headElement.classList.toggle(this.accordionRowHeadActiveClassName);
        bodyElements.forEach((element, index)=>{
            element.hidden = !isActive;
            element.classList.toggle(this.accordionRowBodyActiveClassName, isActive);
            if (index === bodyElements.length - 1) element.classList.add(this.accordionLastElementClassName);
        });
    }
}


class $80c9cb4e91698ab0$export$2e2bcd8739ae039 extends (0, $2595e2ca594d6789$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    handleRowLink(event) {
        const target = event.target;
        if (target.closest('a')) return;
        if (target.closest('button')) return;
        if (target.closest('tk-basket-button')) return;
        const row = target.closest(`[${this.rowLinkSelector}]`);
        if (!row) return;
        const link = row.getAttribute(this.rowLinkSelector);
        if (!link) return;
        window.location.href = link;
    }
}





class $c478073c2c07b611$export$2e2bcd8739ae039 extends (0, $e31d2de11bbf216d$export$2e2bcd8739ae039) {
    constructor(){
        super([
            {
                name: 'tk-manager',
                constructor: (0, $aa35ef9547ba682e$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-request-manager',
                constructor: (0, $d3f5c18545e5cabd$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-viewport',
                constructor: (0, $9ada6dd3e169a5cf$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tracker',
                constructor: (0, $588d148f2c9ac202$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-status-console',
                constructor: (0, $9cc5e30d1bc8a0e8$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-clipboard',
                constructor: (0, $68fa613ad09d90db$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-datepicker',
                constructor: (0, $e018ac17002873dc$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-element',
                constructor: (0, $9a3403e3213d867d$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-validator',
                constructor: (0, $7217ff2f9b2d295c$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-dialog',
                constructor: (0, $5a26c1218729bf34$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-table',
                constructor: (0, $80c9cb4e91698ab0$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tooltip',
                constructor: (0, $b4b8cee06c4cfcc8$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-basket-button',
                constructor: (0, $676bf9a0b3e6a9fd$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-quick-order',
                constructor: (0, $68266fef2d1934e5$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-context-menu',
                constructor: (0, $d9484b764f1a944d$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tracking',
                constructor: (0, $0efda1b115753384$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-static-content',
                constructor: (0, $edcef81612fbf4b7$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-stock',
                constructor: (0, $c7b0de4494db348b$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-price',
                constructor: (0, $7cf802f14f3a63bb$export$2e2bcd8739ae039)
            }
        ]);
    }
}
new $c478073c2c07b611$export$2e2bcd8739ae039();

})();
//# sourceMappingURL=basket.js.map
